// general
export const GENERAL__SAVE_BUTTON = '[GENERAL] SAVE_BUTTON';
export const GENERAL__SEND_BUTTON = '[GENERAL] SEND_BUTTON';
export const GENERAL__SELECT = '[GENERAL] SELECT';
export const GENERAL__EDIT = '[GENERAL] EDIT';
export const GENERAL__CANCEL_BUTTON = '[GENERAL] CANCEL_BUTTON';
export const GENERAL__YES = '[GENERAL] YES';
export const GENERAL__SEARCH = '[GENERAL] SEARCH';
export const GENERAL__ADDRESS = '[GENERAL] ADDRESS';
export const GENERAL__SAVE_AND_NEXT_BUTTON = '[GENERAL] SAVE_AND_NEXT_BUTTON';
export const GENERAL__DELETE = '[GENERAL] DELETE';
export const GENERAL__DELETE_SELECTED = '[GENERAL] DELETE_SELECTED';
export const GENERAL__DELETE_MESSAGE = '[GENERAL] DELETE_MESSAGE';
export const GENERAL__ERROR_MESSAGE = '[GENERAL] ERROR_MESSAGE';
export const GENERAL__CREATE = '[GENERAL] CREATE';
export const GENERAL__QUANTITY = '[GENERAL] QUANTITY';
export const GENERAL__SELECT_ALL = '[GENERAL] SELECT_ALL';
export const GENERAL__CLEAR_ALL = '[GENERAL] CLEAR_ALL';
export const GENERAL__CLEAR_SELECTION = '[GENERAL] CLEAR_SELECTION';
export const GENERAL__NO = '[GENERAL] NO';
export const GENERAL__FIRST_NAME = '[GENERAL] FIRST_NAME';
export const GENERAL__LAST_NAME = '[GENERAL] LAST_NAME';
export const GENERAL__NAME = '[GENERAL] NAME';
export const GENERAL__EMAIL = '[GENERAL] EMAIL';
export const GENERAL__USERNAME = '[GENERAL] USERNAME';
export const GENERAL__LANGUAGE = '[GENERAL] LANGUAGE';
export const GENERAL__PHONE_NUMBER = '[GENERAL] PHONE_NUMBER';
export const GENERAL__CONTACT = '[GENERAL] CONTACT';
export const GENERAL__GENDER = '[GENERAL] GENDER';
export const GENDER__MAN = '[GENDER] MAN';
export const GENDER__WOMAN = '[GENDER] WOMAN';
export const GENERAL__IMPERSONATE = '[GENERAL] IMPERSONATE';
export const GENERAL__INVITE = '[GENERAL] INVITE';
export const GENERAL__ALL = '[GENERAL] ALL';
export const GENERAL__TOTAL = '[GENERAL] TOTAL';
export const GENERAL__YOU_ARE_LOGGED_IN_AS = '[GENERAL] YOU_ARE_LOGGED_IN_AS';
export const GENERAL__CLICK_HERE_TO_CANCEL = '[GENERAL] CLICK_HERE_TO_CANCEL';
export const GENERAL__COUNTRY = '[GENERAL] COUNTRY';
export const GENERAL__ITEMS_PER_PAGE = '[GENERAL] ITEMS_PER_PAGE';
export const GENERAL__DATE_RANGE_PICKER = '[GENERAL] DATE_RANGE_PICKER';
export const GENERAL__AUTOMATIC = '[GENERAL] AUTOMATIC';
export const GENERAL__CONFIRM = '[GENERAL] CONFIRM';
export const GENERAL__DAY = '[GENERAL] DAY';
export const GENERAL__ADD = '[GENERAL] ADD';
export const GENERAL__AND = '[GENERAL] AND';
export const GENERAL__HERE = '[GENERAL] HERE';
export const GENERAL__AGE = '[GENERAL] AGE';
export const GENERAL__PRIVACY_POLICY = '[GENERAL] PRIVACY_POLICY';
export const GENERAL__OF_UPDATE_PRO = '[GENERAL] OF_UPDATE_PRO';
export const GENERAL__COPIED_TO_CLIPBOARD = '[GENERAL] COPIED_TO_CLIPBOARD';
export const GENERAL__LINK_COPIED = '[GENERAL] LINK_COPIED';
export const GENERAL__LAST_MODIFIED_BY = '[GENERAL] LAST_MODIFIED_BY';
export const GENERAL__LAST_MODIFIED_DATE = '[GENERAL] LAST_MODIFIED_DATE';
export const GENERAL__HAS_TWO_FACTOR_AUTH = '[GENERAL] HAS_TWO_FACTOR_AUTH';
export const GENERAL__SECURITY = '[GENERAL] SECURITY';
export const GENERAL__MFA_REQUIRED_OVERRIDE = '[GENERAL] MFA_REQUIRED_OVERRIDE';
export const GENERAL__MFA_REQUIRED_OVERRIDE_REQUIRED = '[GENERAL] MFA_REQUIRED_OVERRIDE_REQUIRED';
export const GENERAL__MFA_REQUIRED_OVERRIDE_NOT_REQUIRED = '[GENERAL] MFA_REQUIRED_OVERRIDE_NOT_REQUIRED';
export const GENERAL__MFA_REQUIRED_OVERRIDE_NONE = '[GENERAL] MFA_REQUIRED_OVERRIDE_NONE';
export const GENERAL__MFA_REQUIRED_OVERRIDE_HELPER_TEXT = '[GENERAL] MFA_REQUIRED_OVERRIDE_HELPER_TEXT';
/* ── SuperAdmin-initiated MFA enrollment reset (US 131) ───────────────────── */
export const GENERAL__MFA_RESET_BUTTON = '[GENERAL] MFA_RESET_BUTTON';
export const GENERAL__MFA_RESET_ENROLLED = '[GENERAL] MFA_RESET_ENROLLED';
export const GENERAL__MFA_RESET_NOT_ENROLLED = '[GENERAL] MFA_RESET_NOT_ENROLLED';
export const GENERAL__MFA_RESET_CONFIRM = '[GENERAL] MFA_RESET_CONFIRM';
export const GENERAL__MFA_RESET_CONFIRM_DEVICES = '[GENERAL] MFA_RESET_CONFIRM_DEVICES'; // interpolates {count}
export const GENERAL__MFA_RESET_SUCCESS = '[GENERAL] MFA_RESET_SUCCESS';
export const GENERAL__MFA_RESET_ERROR = '[GENERAL] MFA_RESET_ERROR';
export const GENERAL__UNSAVED_CHANGES = '[GENERAL] UNSAVED_CHANGES';
export const GENERAL__DOWNLOAD = '[GENERAL] DOWNLOAD';
export const GENERAL__DOWNLOAD_SELECTED = '[GENERAL] DOWNLOAD_SELECTED';
export const GENERAL__SHOW = '[GENERAL] SHOW';
export const GENERAL__SELECTED = '[GENERAL] SELECTED';
export const GENERAL__WORKERCLASS = '[GENERAL] WORKERCLASS';
export const GENERAL__WORKERCLASS_INFO = '[GENERAL] WORKERCLASS_INFO';
export const GENERAL__WORKERCLASS_INFO_LINK = '[GENERAL] WORKERCLASS_INFO_LINK';
export const GENERAL__GO = '[GENERAL] GO';
export const GENERAL__AGREE_AND_CONFIRM = '[GENERAL] AGREE_AND_CONFIRM';
export const GENERAL__CLOSE = '[GENERAL] CLOSE';
export const GENERAL__NO_DATA_TO_SHOW = '[GENERAL] NO_DATA_TO_SHOW';
export const GENERAL__YEAR = '[GENERAL] YEAR';
export const GENERAL__MONTH = '[GENERAL] MONTH';
export const GENERAL__JANUARY = '[GENERAL] JANUARY';
export const GENERAL__FEBRUARY = '[GENERAL] FEBRUARY';
export const GENERAL__MARCH = '[GENERAL] MARCH';
export const GENERAL__APRIL = '[GENERAL] APRIL';
export const GENERAL__MAY = '[GENERAL] MAY';
export const GENERAL__JUNE = '[GENERAL] JUNE';
export const GENERAL__JULY = '[GENERAL] JULY';
export const GENERAL__AUGUST = '[GENERAL] AUGUST';
export const GENERAL__SEPTEMBER = '[GENERAL] SEPTEMBER';
export const GENERAL__OCTOBER = '[GENERAL] OCTOBER';
export const GENERAL__NOVEMBER = '[GENERAL] NOVEMBER';
export const GENERAL__DECEMBER = '[GENERAL] DECEMBER';
export const GENERAL__FROM = '[GENERAL] FROM';
export const GENERAL__UNTIL = '[GENERAL] UNTIL';
export const GENERAL__COLLARTYPE = '[GENERAL] COLLARTYPE';
export const GENERAL__COMPLETED = '[GENERAL] COMPLETED';
export const GENERAL__APP_UNDER_MAINTENANCE = '[GENERAL] APP_UNDER_MAINTENANCE';
export const GENERAL__FILTER = '[GENERAL] FILTER';
export const GENERAL__NO_ITEMS = '[GENERAL] NO_ITEMS';

// worker classes
export const GENERAL__STUD = '[GENERAL] STUD';
export const GENERAL__FLEX = '[GENERAL] FLEX';
export const GENERAL__ARB = '[GENERAL] ARB';
export const GENERAL__BED = '[GENERAL] BED';
export const GENERAL__EXT = '[GENERAL] EXT';

export const DATAGRID__NO_ROWS = '[DATAGRID] NO_ROWS';
export const DATAGRID__ROWS_PER_PAGE = '[DROPDOWN_SEARCH] ROWS_PER_PAGE';
export const DROPDOWN_SEARCH__NO_OPTIONS = '[DATAGRID] NO_ROWS';

export const WEEKDAY__MONDAY = '[WEEKDAY] MONDAY';
export const WEEKDAY__MONDAY_ABBREVIATION = '[WEEKDAY] MONDAY_ABBREVIATION';
export const WEEKDAY__TUESDAY = '[WEEKDAY] TUESDAY';
export const WEEKDAY__TUESDAY_ABBREVIATION = '[WEEKDAY] TUESDAY_ABBREVIATION';
export const WEEKDAY__WEDNESDAY = '[WEEKDAY] WEDNESDAY';
export const WEEKDAY__WEDNESDAY_ABBREVIATION = '[WEEKDAY] WEDNESDAY_ABBREVIATION';
export const WEEKDAY__THURSDAY = '[WEEKDAY] THURSDAY';
export const WEEKDAY__THURSDAY_ABBREVIATION = '[WEEKDAY] THURSDAY_ABBREVIATION';
export const WEEKDAY__FRIDAY = '[WEEKDAY] FRIDAY';
export const WEEKDAY__FRIDAY_ABBREVIATION = '[WEEKDAY] FRIDAY_ABBREVIATION';
export const WEEKDAY__SATURDAY = '[WEEKDAY] SATURDAY';
export const WEEKDAY__SATURDAY_ABBREVIATION = '[WEEKDAY] SATURDAY_ABBREVIATION';
export const WEEKDAY__SUNDAY = '[WEEKDAY] SUNDAY';
export const WEEKDAY__SUNDAY_ABBREVIATION = '[WEEKDAY] SUNDAY_ABBREVIATION';

// login
export const LOGIN__EMAIL_LABEL = '[LOGIN] EMAIL_LABEL';
export const LOGIN__PASSWORD_LABEL = '[LOGIN] PASSWORD_LABEL';
export const LOGIN__EXISTING_PASSWORD_LABEL = '[LOGIN] EXISTING_PASSWORD_LABEL';
export const LOGIN__PASSWORD_REQUIRED_ERROR = '[LOGIN] PASSWORD_REQUIRED_ERROR';
export const LOGIN__PAGE_TITLE = '[LOGIN] PAGE_TITLE';
export const LOGIN__PAGE_QUOTE = '[LOGIN] PAGE_QUOTE';
export const LOGIN__SIGN_IN = '[LOGIN] SIGN_IN';
export const LOGIN__CREATE_ACCOUNT = '[LOGIN] CREATE_ACCOUNT';
export const LOGIN__FORGOT_PASSWORD = '[LOGIN] FORGOT_PASSWORD';
export const LOGIN__CONTACT_US = '[LOGIN] CONTACT_US';
export const LOGIN__EMAIL_REQUIRED_ERROR = '[LOGIN] EMAIL_REQUIRED_ERROR';
export const LOGIN__EMAIL_MAX_LENGTH_ERROR = '[LOGIN] EMAIL_MAX_LENGTH_ERROR';
export const LOGIN__PASSWORD_MIN_LENGTH_ERROR = '[LOGIN] PASSWORD_MIN_LENGTH_ERROR';
export const LOGIN__INCORRECT_EMAIL_OR_PASSWORD = '[LOGIN] INCORRECT_EMAIL_OR_PASSWORD';
export const LOGIN__INVALID_CREDENTIALS = '[LOGIN] INVALID_CREDENTIALS';
export const LOGIN__CONFIRM_EMAIL_TITLE = '[LOGIN] CONFIRM_EMAIL_TITLE';
export const LOGIN__RESET_PASSWORD_EMAIL_SENT = '[LOGIN] RESET_PASSWORD_EMAIL_SENT';

// password policy
export const PASSWORD_POLICY__PASSWORD_POLICY = '[PASSWORD_POLICY] PASSWORD_POLICY';

export const FOOTER__TERMS_AND_CONDITIONS = '[FOOTER] TERMS_AND_CONDITIONS';
export const FOOTER__PRIVACY_POLICY = '[FOOTER] PRIVACY_POLICY';

export const HEADER__WEEK = '[HEADER] WEEK';

// pagination
export const PAGINATION__SHOWING = '[PAGINATION] SHOWING';
export const PAGINATION__TO = '[PAGINATION] TO';
export const PAGINATION__OF = '[PAGINATION] OF';
export const PAGINATION__ROWS = '[PAGINATION] ROWS';
export const PAGINATION__PAGE = '[PAGINATION] PAGE';

// company
export const COMPANIES__ADD_NEW_COMPANY = '[COMPANIES] ADD_NEW_COMPANY';
export const COMPANY__COMPANY = '[COMPANY] COMPANY';
export const COMPANY__CONTACT = '[COMPANY] CONTACT';
export const COMPANY__LOCATIONS = '[COMPANY] LOCATIONS';
export const COMPANY__PAYROLL = '[COMPANY] PAYROLL';
export const COMPANY__MANAGERS = '[COMPANY] MANAGERS';
export const COMPANY__VENDORS = '[COMPANY] VENDORS';
export const COMPANY__FINANCIAL = '[COMPANY] FINANCIAL';
export const COMPANY__INTEGRATION = '[COMPANY] INTEGRATION';
export const COMPANY__STRUCTURE = '[COMPANY] STRUCTURE';
export const COMPANY__SEARCH_COMPANY_NAME = '[COMPANY] SEARCH_COMPANY_NAME';
export const COMPANY__NO_COMPANIES_YET = '[COMPANY] NO_COMPANIES_YET';
export const COMPANY__NO_COMPANIES_MATCH_SEARCH = '[COMPANY] NO_COMPANIES_MATCH_SEARCH';
export const COMPANY__CLIENTS_TOGGLE_OPTION = '[COMPANY] CLIENTS_TOGGLE_OPTION';
export const COMPANY__ONBOARDING_TOGGLE_OPTION = '[COMPANY] ONBOARDING_TOGGLE_OPTION';

export const COMPANY_INFORMATION__COMPANY_NAME = '[COMPANY_INFORMATION] COMPANY_NAME';
export const COMPANY_INFORMATION__COMMERCIAL_NAME = '[COMPANY_INFORMATION] COMMERCIAL_NAME';
export const COMPANY_INFORMATION__STREET_NAME = '[COMPANY_INFORMATION] STREET_NAME';
export const COMPANY_INFORMATION__STREET_NUMBER = '[COMPANY_INFORMATION] STREET_NUMBER';
export const COMPANY_INFORMATION__BUS_NUMBER = '[COMPANY_INFORMATION] BUS_NUMBER';
export const COMPANY_INFORMATION__CITY = '[COMPANY_INFORMATION] CITY';
export const COMPANY_INFORMATION__POSTAL_CODE = '[COMPANY_INFORMATION] POSTAL_CODE';
export const COMPANY_INFORMATION__COMPANY_ID_NUMBER = '[COMPANY_INFORMATION] COMPANY_ID_NUMBER';
export const COMPANY_INFORMATION__COMPANY_FORMAT = '[COMPANY_INFORMATION] COMPANY_FORMAT';
export const COMPANY_INFORMATION__SMALL_COMPANY = '[COMPANY_INFORMATION] SMALL_COMPANY';
export const COMPANY_INFORMATION__UNION_DELEGATION = '[COMPANY_INFORMATION] UNION_DELEGATION';
export const COMPANY_INFORMATION__UNION_DELEGATION_DATE = '[COMPANY_INFORMATION] UNION_DELEGATION_DATE';
export const COMPANY_INFORMATION__LOGO = '[COMPANY_INFORMATION] LOGO';
export const COMPANY_INFORMATION__LOGO_PLACEHOLDER = '[COMPANY_INFORMATION] LOGO_PLACEHOLDER';
export const COMPANY_INFORMATION__ACTIVE = '[COMPANY_INFORMATION] ACTIVE';
export const COMPANY_INFORMATION__NON_ACTIVE = '[COMPANY_INFORMATION] NON_ACTIVE';
export const COMPANY_INFORMATION__DELETE_COMPANY = '[COMPANY_INFORMATION] DELETE_COMPANY';
export const COMPANY_INFORMATION__PARENT_COMPANY = '[COMPANY_INFORMATION] PARENT_COMPANY';
export const COMPANY_INFORMATION__PARENT_COMPANY_LABEL = '[COMPANY_INFORMATION] PARENT_COMPANY_LABEL';
export const COMPANY_INFORMATION__COMPANY_ADDED_SUCCESSFULLY = '[COMPANY_INFORMATION] COMPANY_ADDED_SUCCESSFULLY';
export const COMPANY_INFORMATION__COMPANY_UPDATED_SUCCESSFULLY = '[COMPANY_INFORMATION] COMPANY_UPDATED_SUCCESSFULLY';
export const COMPANY_INFORMATION__ASSIGN_CHILD_WARNING = '[COMPANY_INFORMATION] ASSIGN_CHILD_WARNING';

export const COMPANY_CONTACT__CONTACT_NAME = '[COMPANY_CONTACT] CONTACT_NAME';
export const COMPANY_CONTACT__CONTACT_PHONE = '[COMPANY_CONTACT] CONTACT_PHONE';
export const COMPANY_CONTACT__CONTACT_EMAIL = '[COMPANY_CONTACT] CONTACT_EMAIL';
export const COMPANY_CONTACT__CONTACT_UPDATED_SUCCESSFULLY = '[COMPANY_CONTACT] CONTACT_UPDATED_SUCCESSFULLY';

export const COMPANY_PAYROLL__PARITAIR_COMITE = '[COMPANY_PAYROLL] PARITAIR_COMITE';
export const COMPANY_PAYROLL__COEFFICIENT_PER_WORKERCLASS = '[COMPANY_PAYROLL] COEFFICIENT_PER_WORKERCLASS';
export const COMPANY_PAYROLL__HIGHEST_WAGE_PRIORITY_CHAIN = '[COMPANY_PAYROLL] HIGHEST_WAGE_PRIORITY_CHAIN';
export const COMPANY_PAYROLL__HIGHEST_WAGE_PRIORITY_CHAIN_TOOLTIP =
  '[COMPANY_PAYROLL] HIGHEST_WAGE_PRIORITY_CHAIN_TOOLTIP';
export const COMPANY_PAYROLL__HIGHEST_WAGE_WINS = '[COMPANY_PAYROLL] HIGHEST_WAGE_WINS';
export const COMPANY_PAYROLL__WAGE_CALCULATION_METHOD = '[COMPANY_PAYROLL] WAGE_CALCULATION_METHOD';
export const COMPANY_PAYROLL__EMPLOYER_LABEL = '[COMPANY_PAYROLL] EMPLOYER_LABEL';
export const COMPANY_PAYROLL__POSSIBLE_CONTRACT_MOTIVES = '[COMPANY_PAYROLL] POSSIBLE_CONTRACT_MOTIVES';
export const COMPANY_PAYROLL__DEFAULT_CONTRACT_MOTIVE = '[COMPANY_PAYROLL] DEFAULT_CONTRACT_MOTIVE';
export const CONTRACT_MOTIVE__STILL_USED_BY_EXCEPTION = '[CONTRACT_MOTIVE] STILL_USED_BY_EXCEPTION';
export const COMPANY_PAYROLL__WORKHOURS_RESTRICTIONS = '[COMPANY_PAYROLL] WORKHOURS_RESTRICTIONS';
export const COMPANY_PAYROLL__WORKHOURS_SETTINGS = '[COMPANY_PAYROLL] WORKHOURS_SETTINGS';
export const COMPANY_PAYROLL__MINIMUM_PERFORMED_HOURS = '[COMPANY_PAYROLL] MINIMUM_PERFORMED_HOURS';
export const COMPANY_PAYROLL__MAXIMUM_PLANNED_HOURS = '[COMPANY_PAYROLL] MAXIMUM_PLANNED_HOURS';
export const COMPANY_PAYROLL__ADD_NEW_FUNCTION = '[COMPANY_PAYROLL] ADD_NEW_FUNCTION';
export const COMPANY_PAYROLL__FUNCTIONS = '[COMPANY_PAYROLL] FUNCTIONS';
export const COMPANY_PAYROLL__FUNCTION_DESCRIPTION = '[COMPANY_PAYROLL] FUNCTION_DESCRIPTION';
export const COMPANY_PAYROLL__FUNCTION_COLOR = '[COMPANY_PAYROLL] FUNCTION_COLOR';
export const COMPANY_PAYROLL__FUNCTION_TYPE = '[COMPANY_PAYROLL] FUNCTION_TYPE';
export const COMPANY_PAYROLL__FUNCTION_WARNING_ON_DELETE = '[COMPANY_PAYROLL] FUNCTION_WARNING_ON_DELETE';
export const FUNCTION_TYPE__PER_HOUR = '[FUNCTION_TYPE] PER_HOUR';
export const FUNCTION_TYPE__PER_DAY = '[FUNCTION_TYPE] PER_DAY';
export const FUNCTION_TYPE__PER_MONTH = '[FUNCTION_TYPE] PER_MONTH';
export const COMPANY_PAYROLL__FUNCTION_WAGE = '[COMPANY_PAYROLL] FUNCTION_WAGE';
export const COMPANY_PAYROLL__EDIT_PAYROLL_FUNCTION = '[COMPANY_PAYROLL] EDIT_PAYROLL_FUNCTION';
export const COMPANY_PAYROLL__COST_CENTER_DESCRIPTION = '[COMPANY_PAYROLL] COST_CENTER_DESCRIPTION';
export const COMPANY_PAYROLL__COST_CENTER_ADD_NEW_COST_CENTER = '[COMPANY_PAYROLL] COST_CENTER_ADD_NEW_COST_CENTER';
export const COMPANY_PAYROLL__COST_CENTER_EDIT_COST_CENTER = '[COMPANY_PAYROLL] COST_CENTER_EDIT_COST_CENTER';
export const COMPANY_PAYROLL__GENERAL = '[COMPANY_PAYROLL] GENERAL';
export const COMPANY_PAYROLL__COST_CENTERS = '[COMPANY_PAYROLL] COST_CENTERS';
export const COMPANY_PAYROLL__COST_CENTER_LATITUDE = '[COMPANY_PAYROLL] COST_CENTER_LATITUDE';
export const COMPANY_PAYROLL__COST_CENTER_LONGITUDE = '[COMPANY_PAYROLL] COST_CENTER_LONGITUDE';
export const COMPANY_PAYROLL__COST_CENTER_GET_COORDINATES = '[COMPANY_PAYROLL] COST_CENTER_GET_COORDINATES';
export const COMPANY_PAYROLL__COST_CENTER_COORDINATES_NOT_RESOLVED =
  '[COMPANY_PAYROLL] COST_CENTER_COORDINATES_NOT_RESOLVED';
export const COMPANY_PAYROLL__COST_CENTER_ADDRESS_REQUIRED_FIRST =
  '[COMPANY_PAYROLL] COST_CENTER_ADDRESS_REQUIRED_FIRST';
export const COMPANY_PAYROLL__COST_CENTER_INVALID_COORDINATES = '[COMPANY_PAYROLL] COST_CENTER_INVALID_COORDINATES';
export const COMPANY_PAYROLL__WAGE_EXEMPTIONS = '[COMPANY_PAYROLL] WAGE_EXEMPTIONS';
export const COMPANY_PAYROLL__WAGE_SETUP = '[COMPANY_PAYROLL] WAGE_SETUP';
export const COMPANY_PAYROLL__WAGE_EXEMPTION = '[COMPANY_PAYROLL] WAGE_EXEMPTION';
export const COMPANY_PAYROLL__WAGE_EXEMPTIONS_ENABLE = '[COMPANY_PAYROLL] WAGE_EXEMPTIONS_ENABLE';
export const COMPANY_PAYROLL__WAGE_EXEMPTIONS_ENABLE_WORKERCLASS =
  '[COMPANY_PAYROLL] WAGE_EXEMPTIONS_ENABLE_WORKERCLASS';
export const COMPANY_PAYROLL__WAGE_EXEMPTIONS_ENABLE_FUNCTION = '[COMPANY_PAYROLL] WAGE_EXEMPTIONS_ENABLE_FUNCTION';
export const COMPANY_PAYROLL__ADD_NEW_WORKCLASS_EXEMPTION = '[COMPANY_PAYROLL] ADD_NEW_WORKCLASS_EXEMPTION';
export const COMPANY_PAYROLL__ADD_NEW_FUNCTION_EXEMPTION = '[COMPANY_PAYROLL] ADD_NEW_FUNCTION_EXEMPTION';
export const COMPANY_PAYROLL__DELETE_FUNCTION_EXEMPTION = '[COMPANY_PAYROLL] DELETE_FUNCTION_EXEMPTION';
export const COMPANY_PAYROLL__DELETE_WORKERCLASS_EXEMPTION = '[COMPANY_PAYROLL] DELETE_WORKERCLASS_EXEMPTION';
export const COMPANY_PAYROLL__ADD_NEW_EMPLOYEE_EXEMPTION = '[COMPANY_PAYROLL] ADD_NEW_EMPLOYEE_EXEMPTION';
export const COMPANY_PAYROLL__DELETE_EMPLOYEE_EXEMPTION = '[COMPANY_PAYROLL] DELETE_EMPLOYEE_EXEMPTION';
export const COMPANY_PAYROLL__EMPLOYEE = '[COMPANY_PAYROLL] EMPLOYEE';
export const COMPANY_PAYROLL__ENABLE_EMPLOYEE = '[COMPANY_PAYROLL] ENABLE_EMPLOYEE';
export const COMPANY_PAYROLL__FUNCTION = '[COMPANY_PAYROLL] FUNCTION';
export const COMPANY_PAYROLL__CATEGORY = '[COMPANY_PAYROLL] CATEGORY';
export const COMPANY_PAYROLL__LIMIT = '[COMPANY_PAYROLL] LIMIT';
export const COMPANY_PAYROLL__LIMIT_ERROR = '[COMPANY_PAYROLL] LIMIT_ERROR';
export const COMPANY_PAYROLL__INVALID_INTERVAL_FORMAT = '[COMPANY_PAYROLL] INVALID_INTERVAL_FORMAT';
export const COMPANY_PAYROLL__INTERVALS_OVERLAP = '[COMPANY_PAYROLL] INTERVALS_OVERLAP';
export const COMPANY_PAYROLL__MORNING_INTERVAL = '[COMPANY_PAYROLL] MORNING_INTERVAL';
export const COMPANY_PAYROLL__AFTERNOON_INTERVAL = '[COMPANY_PAYROLL] AFTERNOON_INTERVAL';
export const COMPANY_PAYROLL__EVENING_INTERVAL = '[COMPANY_PAYROLL] EVENING_INTERVAL';
export const COMPANY_PAYROLL__DUPLICATE_PER_JOINT_COMMISSION = '[COMPANY_PAYROLL] DUPLICATE_PER_JOINT_COMMISSION';
export const COMPANY_PAYROLL__WAGE_EXEPTION_VALUE_NOT_ZERO = '[COMPANY_PAYROLL] WAGE_EXEPTION_VALUE_NOT_ZERO';
export const COMPANY_PAYROLL__EMPLOYEE_REQUIRED = '[COMPANY_PAYROLL] EMPLOYEE_REQUIRED';
export const COMPANY_PAYROLL__FUNCTION_REQUIRED = '[COMPANY_PAYROLL] FUNCTION_REQUIRED';
export const COMPANY_PAYROLL__WORKERCLASS_REQUIRED = '[COMPANY_PAYROLL] WORKERCLASS_REQUIRED';
export const COMPANY_PAYROLL__JOINT_COMMISSION_REQUIRED = '[COMPANY_PAYROLL] JOINT_COMMISSION_REQUIRED';
export const COMPANY_PAYROLL__DEFAULT_BREAKTIME = '[COMPANY_PAYROLL] DEFAULT_BREAKTIME';
export const COMPANY_PAYROLL__INVALID_DEFAULT_BREAKTIME_FORMAT = '[COMPANY_PAYROLL] INVALID_DEFAULT_BREAKTIME';
export const COMPANY_PAYROLL__MAX_BREAKTIME_REACHED = '[COMPANY_PAYROLL] MAX_BREAKTIME_REACHED';
export const COMPANY_PAYROLL__MOTIVE = '[COMPANY_PAYROLL] MOTIVE';
export const COMPANY_PAYROLL__ATTEMPT = '[COMPANY_PAYROLL] ATTEMPT';
export const COMPANY_PAYROLL__ADD_MOTIVE_EXEMPTION = '[COMPANY_PAYROLL] ADD_MOTIVE_EXEMPTION';
export const COMPANY_PAYROLL__DELETE_MOTIVE_EXEMPTION = '[COMPANY_PAYROLL] DELETE_MOTIVE_EXEMPTION';
export const COMPANY_PAYROLL__ENABLE_MOTIVE_EXEMPTION = '[COMPANY_PAYROLL] ENABLE_MOTIVE_EXEMPTION';
export const COMPANY_PAYROLL__INVALID_MOTIVE = '[COMPANY_PAYROLL] INVALID_MOTIVE';

export const MOTIVE_EXCEPTION__TAB_TITLE = '[MOTIVE_EXCEPTION] TAB_TITLE';
export const MOTIVE_EXCEPTION__ADD_BUTTON = '[MOTIVE_EXCEPTION] ADD_BUTTON';
export const MOTIVE_EXCEPTION__EDIT_TITLE = '[MOTIVE_EXCEPTION] EDIT_TITLE';
export const MOTIVE_EXCEPTION__ADD_TITLE = '[MOTIVE_EXCEPTION] ADD_TITLE';
export const MOTIVE_EXCEPTION__TYPE = '[MOTIVE_EXCEPTION] TYPE';
export const MOTIVE_EXCEPTION__TYPE_EMPLOYEE = '[MOTIVE_EXCEPTION] TYPE_EMPLOYEE';
export const MOTIVE_EXCEPTION__TYPE_LOCATION = '[MOTIVE_EXCEPTION] TYPE_LOCATION';
export const MOTIVE_EXCEPTION__EMPLOYEES = '[MOTIVE_EXCEPTION] EMPLOYEES';
export const MOTIVE_EXCEPTION__LOCATIONS = '[MOTIVE_EXCEPTION] LOCATIONS';
export const MOTIVE_EXCEPTION__MOTIVE = '[MOTIVE_EXCEPTION] MOTIVE';
export const MOTIVE_EXCEPTION__ATTEMPT = '[MOTIVE_EXCEPTION] ATTEMPT';
export const MOTIVE_EXCEPTION__START_DATE = '[MOTIVE_EXCEPTION] START_DATE';
export const MOTIVE_EXCEPTION__END_DATE = '[MOTIVE_EXCEPTION] END_DATE';
export const MOTIVE_EXCEPTION__END_DATE_OPEN_ENDED = '[MOTIVE_EXCEPTION] END_DATE_OPEN_ENDED';
export const MOTIVE_EXCEPTION__CLEAR_END_DATE = '[MOTIVE_EXCEPTION] CLEAR_END_DATE';
export const MOTIVE_EXCEPTION__COLUMN_TYPE = '[MOTIVE_EXCEPTION] COLUMN_TYPE';
export const MOTIVE_EXCEPTION__COLUMN_TARGETS = '[MOTIVE_EXCEPTION] COLUMN_TARGETS';
export const MOTIVE_EXCEPTION__COLUMN_MOTIVE = '[MOTIVE_EXCEPTION] COLUMN_MOTIVE';
export const MOTIVE_EXCEPTION__COLUMN_START_DATE = '[MOTIVE_EXCEPTION] COLUMN_START_DATE';
export const MOTIVE_EXCEPTION__COLUMN_END_DATE = '[MOTIVE_EXCEPTION] COLUMN_END_DATE';
export const MOTIVE_EXCEPTION__COLUMN_ACTIONS = '[MOTIVE_EXCEPTION] COLUMN_ACTIONS';
export const MOTIVE_EXCEPTION__EMPTY_STATE = '[MOTIVE_EXCEPTION] EMPTY_STATE';

export const COMPANY_FINANCIAL__BANK_ACCOUNT = '[COMPANY_FINANCIAL] BANK_ACCOUNT';
export const COMPANY_FINANCIAL__PAYMENT_METHOD = '[COMPANY_FINANCIAL] PAYMENT_METHOD';
export const COMPANY_FINANCIAL__MANDATE_REFERENCE = '[COMPANY_FINANCIAL] MANDATE_REFERENCE';
export const COMPANY_FINANCIAL__DATE_MANDATE_SIGNED = '[COMPANY_FINANCIAL] DATE_MANDATE_SIGNED';
export const COMPANY_FINANCIAL__INVOICE_EMAIL = '[COMPANY_FINANCIAL] INVOICE_EMAIL';
export const COMPANY_FINANCIAL__UPDATED_SUCCESSFULLY = '[COMPANY_FINANCIAL] UPDATED_SUCCESSFULLY';
export const PAYMENT_METHOD__VIA_DOMICILIE = '[PAYMENT_METHOD] VIA_DOMICILIE';
export const PAYMENT_METHOD__MANUAL = '[PAYMENT_METHOD] MANUAL';

export const COMPANY_MANAGERS__ADD_NEW_MANAGER = '[COMPANY_MANAGERS] ADD_NEW_MANAGER';
export const COMPANY_MANAGERS__LOCATION = '[COMPANY_MANAGERS] LOCATION';
export const COMPANY_MANAGERS__LOCATIONS = '[COMPANY_MANAGERS] LOCATIONS';
export const COMPANY_MANAGERS__EDIT_MODAL_TITLE = '[COMPANY_MANAGERS] EDIT_MODAL_TITLE';
export const COMPANY_MANAGERS__VIEW_DETAILS = '[COMPANY_MANAGERS] VIEW_DETAILS';
export const COMPANY_MANAGERS__ROLE = '[COMPANY_MANAGERS] ROLE';
export const MANAGER_ROLE__CLIENT_MANAGER = '[MANAGER_ROLE] CLIENT_MANAGER';
export const MANAGER_ROLE__STORE_MANAGER = '[MANAGER_ROLE] STORE_MANAGER';
export const MANAGER_ROLE__HR_MANAGER = '[MANAGER_ROLE] HR_MANAGER';
export const MANAGER_ROLE__AGREE_GDPR = '[MANAGER_ROLE] AGREE_GDPR';
export const MANAGER_ROLE__MUST_AGREE_GDPR = '[MANAGER_ROLE] MUST_AGREE_GDPR';

export const COMPANY_VENDORS__VENDOR_NAME = '[COMPANY_VENDORS] VENDOR_NAME';
export const COMPANY_VENDORS__ADD_NEW_VENDOR = '[COMPANY_VENDORS] ADD_NEW_VENDOR';
export const COMPANY_VENDORS__EDIT_VENDOR = '[COMPANY_VENDORS] EDIT_VENDOR';

export const COMPANY_INTEGRATION__SALARY_ENGINE_REFERENCE = '[COMPANY_INTEGRATION] SALARY_ENGINE_REFERENCE';
export const COMPANY_INTEGRATION__ENVIRONMENT_KEY = '[COMPANY_INTEGRATION] ENVIRONMENT_KEY';
export const COMPANY_INTEGRATION__API_KEY = '[COMPANY_INTEGRATION] API_KEY';

export const COMPANY_LOCATIONS__ADD_NEW_LOCATION = '[COMPANY_LOCATIONS] ADD_NEW_LOCATION';
export const COMPANY_LOCATIONS__EDIT_LOCATION = '[COMPANY_LOCATIONS] EDIT_LOCATION';

export const COMPANY_PAYROLL__ADD_NEW_WORKCLASS_COEFFICIENT = '[COMPANY_PAYROLL] ADD_NEW_WORKCLASS_COEFFICIENT';
export const COMPANY_PAYROLL__DELETE_WORKCLASS_COEFFICIENT = '[COMPANY_PAYROLL] DELETE_WORKCLASS_COEFFICIENT';
export const COMPANY_PAYROLL__WORKERCLASS = '[COMPANY_PAYROLL] WORKERCLASS';
export const COMPANY_PAYROLL__COEFFICIENT = '[COMPANY_PAYROLL] COEFFICIENT';
export const COMPANY_PAYROLL__FACTOR_S = '[COMPANY_PAYROLL] FACTOR_S';
export const COMPANY_INFORMATION__ACTIVE_CONTRACT_COUNT = '[COMPANY_INFORMATION] ACTIVE_CONTRACT_COUNT';
export const COMPANY_INFORMATION__PAST_CONTRACT_COUNT = '[COMPANY_INFORMATION] PAST_CONTRACT_COUNT';
export const COMPANY_INFORMATION_WEEKLY_STATUS = '[COMPANY_INFORMATION] WEEKLY_STATUS';

// paritair-comite
export const PARITAIR_COMITE__ADD_PARITAIR_COMITE = '[PARITAIR_COMITE] ADD_PARITAIR_COMITE';
export const PARITAIR_COMITE__DUTCH = '[PARITAIR_COMITE] DUTCH';
export const PARITAIR_COMITE__FRENCH = '[PARITAIR_COMITE] FRENCH';
export const PARITAIR_COMITE__ENGLISH = '[PARITAIR_COMITE] ENGLISH';
export const PARITAIR_COMITE__GENERAL = '[PARITAIR_COMITE] GENERAL';
export const PARITAIR_COMITE__MINIMUM_WAGES = '[PARITAIR_COMITE] MINIMUM_WAGES';
export const PARITAIR_COMITE__WAGE_CALCULATION = '[PARITAIR_COMITE] WAGE_CALCULATION';
export const PARITAIR_COMITE__START_DATE = '[PARITAIR_COMITE] START_DATE';
export const PARITAIR_COMITE__END_DATE = '[PARITAIR_COMITE] END_DATE';
export const PARITAIR_COMITE__WORKER_CLASS = '[PARITAIR_COMITE] WORKER_CLASS';
export const PARITAIR_COMITE__ADD_NEW_ROW = '[PARITAIR_COMITE] ADD_NEW_ROW';
export const PARITAIR_COMITE__FILTER_BY_DATE = '[PARITAIR_COMITE] FILTER_BY_DATE';
export const PARITAIR_COMITE__EXPERIENCE_OR_AGE = '[PARITAIR_COMITE] EXPERIENCE_OR_AGE';
export const PARITAIR_COMITE__UPDATED_SUCCESSFULLY = '[PARITAIR_COMITE] UPDATED_SUCCESSFULLY';
export const PARITAIR_COMITE__ADDED_SUCCESSFULLY = '[PARITAIR_COMITE] ADDED_SUCCESSFULLY';
export const PARITAIR_COMITE__CATEGORIES_DESCRIPTION = '[PARITAIR_COMITE] CATEGORIES_DESCRIPTION';

// boilerplate
export const DRAWER__PROFILE = '[DRAWER] PROFILE';
export const DRAWER__GENERAL_SETTINGS = '[DRAWER] GENERAL_SETTINGS';
export const DRAWER__LOGOUT = '[DRAWER] LOGOUT';

export const LOGOUT_ALERT__CANCEL_BUTTON = '[LOGOUT_ALERT] CANCEL_BUTTON';
export const LOGOUT_ALERT__CONFIRM_BUTTON = '[LOGOUT_ALERT] CONFIRM_BUTTON';
export const LOGOUT_ALERT__MESSAGE = '[LOGOUT_ALERT] MESSAGE';
export const LOGOUT_ALERT__TITLE = '[LOGOUT_ALERT] TITLE';

export const TAB_ROUTE__HOME_NAME = '[TAB_ROUTE] HOME_NAME';
export const TAB_ROUTE__BOOKINGS_NAME = '[TAB_ROUTE] BOOKINGS_NAME';
export const TAB_ROUTE__COLLEGUES_NAME = '[TAB_ROUTE] COLLEGUES_NAME';
export const TAB_ROUTE__UPCOMING_NAME = '[TAB_ROUTE] UPCOMING_NAME';

export const PROFILE__SCREEN_TITLE = '[PROFILE] SCREEN_TITLE';
export const PROFILE__BUTTON_MY_BOOKINGS = '[PROFILE] BUTTON_MY_BOOKINGS';

export const GENERAL_SETTINGS__SCREEN_TITLE = '[GENERAL_SETTINGS] SCREEN_TITLE';
export const GENERAL_SETTINGS__LANGUAGE = '[GENERAL_SETTINGS] LANGUAGE';
export const GENERAL_SETTINGS__CHANGE_LANGUAGE = '[GENERAL_SETTINGS] CHANGE_LANGUAGE';

export const LANGUAGE__ENGLISH = '[LANGUAGE] ENGLISH';
export const LANGUAGE__FRENCH = '[LANGUAGE] FRENCH';

export const LOCATION__SCREEN_TITLE = '[LOCATION] SCREEN_TITLE';

// profile
export const PROFILE__CURRENT_PASSWORD = '[PROFILE] CURRENT_PASSWORD';
export const PROFILE__NEW_PASSWORD = '[PROFILE] NEW_PASSWORD';
export const PROFILE__CONFIRM_NEW_PASSWORD = '[PROFILE] CONFIRM_NEW_PASSWORD';
export const PROFILE__UPDATE_LANGUAGE_SUCCESSFUL = '[PROFILE] UPDATE_LANGUAGE_SUCCESSFUL';
export const PROFILE__UPDATE_PASSWORD_SUCCESSFUL = '[PROFILE] UPDATE_PASSWORD_SUCCESSFUL';

export const PROFILE__PINCODE_TITLE = '[PROFILE] PINCODE_TITLE';
export const PROFILE__PINCODE_NOT_SET = '[PROFILE] PINCODE_NOT_SET';
export const PROFILE__PINCODE_ADD = '[PROFILE] PINCODE_ADD';
export const PROFILE__PINCODE_CHANGE = '[PROFILE] PINCODE_CHANGE';
export const PROFILE__PINCODE_CHOOSE = '[PROFILE] PINCODE_CHOOSE';
export const PROFILE__PINCODE_LABEL = '[PROFILE] PINCODE_LABEL';
export const PROFILE__PINCODE_REPEAT = '[PROFILE] PINCODE_REPEAT';
export const PROFILE__PINCODE_VALID = '[PROFILE] PINCODE_VALID';
export const PROFILE__PINCODE_INVALID = '[PROFILE] PINCODE_INVALID';
export const PROFILE__PINCODE_MATCH = '[PROFILE] PINCODE_MATCH';
export const PROFILE__PINCODE_NO_MATCH = '[PROFILE] PINCODE_NO_MATCH';
export const PROFILE__PINCODE_HINT = '[PROFILE] PINCODE_HINT';
export const PROFILE__PINCODE_CONFLICT = '[PROFILE] PINCODE_CONFLICT';
export const PROFILE__PINCODE_SAVED = '[PROFILE] PINCODE_SAVED';
export const PROFILE__PINCODE_REVEAL_TITLE = '[PROFILE] PINCODE_REVEAL_TITLE';
export const PROFILE__PINCODE_WRONG_PASSWORD = '[PROFILE] PINCODE_WRONG_PASSWORD';

// menu
export const MENU__DASHBOARD = '[MENU] DASHBOARD';
export const MENU__COMPANIES = '[MENU] COMPANIES';
export const MENU__COMPANY = '[MENU] COMPANY';
export const MENU__CONTRACTS = '[MENU] CONTRACTS';
export const MENU__EMPLOYEES = '[MENU] EMPLOYEES';
export const MENU__AVAILABILITIES = '[MENU] AVAILABILITIES';
export const MENU__MY_INFORMATION = '[MENU] MY_INFORMATION';
export const MENU__DOCS = '[MENU] DOCS';
export const MENU__PARITAIR_COMITE = '[MENU] PARITAIR_COMITE';
export const MENU__USERS = '[MENU] USERS';
export const MENU__REPORTS = '[MENU] REPORTS';

export const MENU__MY_PROFILE = '[MENU] MY_PROFILE';
export const MENU__PASSWORD = '[MENU] PASSWORD';
export const MENU_LOGOUT = '[MENU] LOGOUT';

// superadmins
export const SUPERADMINS__ADD_NEW = '[SUPERADMINS] ADD_NEW';
export const SUPERADMINS__ADD_NEW_BUTTON = '[SUPERADMINS] ADD_NEW_BUTTON';
export const SUPERADMINS__EDIT_SUPERADMIN = '[SUPERADMINS] EDIT_SUPERADMIN';
export const SUPERADMINS__DELETE_SUPERADMIN = '[SUPERADMINS] DELETE_ADMIN';
export const SUPERADMINS = '[SUPERADMINS] SUPERADMINS';
export const USERS__ALREADY_EXISTS_WITH_DIFFERENT_ROLE = '[USERS] ALREADY_EXISTS_WITH_DIFFERENT_ROLE';

// availabilities
export const AVAILABILITIES__AVAILABILITY = '[AVAILABILITIES] AVAILABILITY';
export const AVAILABILITIES__FULL_DAY_AVAILABLE = '[AVAILABILITIES] FULL_DAY_AVAILABLE';
export const AVAILABILITIES__MORNING = '[AVAILABILITIES] MORNING';
export const AVAILABILITIES__AFTERNOON = '[AVAILABILITIES] AFTERNOON';
export const AVAILABILITIES__EVENING = '[AVAILABILITIES] EVENING';
export const AVAILABILITIES__MORNING_AND_AFTERNOON = '[AVAILABILITIES] MORNING_AND_AFTERNOON';
export const AVAILABILITIES__MORNING_AND_EVENING = '[AVAILABILITIES] MORNING_AND_EVENING';
export const AVAILABILITIES__AFTERNOON_AND_EVENING = '[AVAILABILITIES] AFTERNOON_AND_EVENING';
export const AVAILABILITIES__SUBMIT_AVAILABILITIES = '[AVAILABILITIES] SUBMIT_AVAILABILITIES';
export const AVAILABILITIES__COMPANY_PICK_SCREEN_TEXT = '[AVAILABILITIES] COMPANY_PICK_SCREEN_TEXT';
export const AVAILABILITIES__UNAVAILABLE = '[AVAILABILITIES] UNAVAILABLE';
export const AVAILABILITIES__NO_AVAILABILITIES = '[AVAILABILITIES] NO_AVAILABILITIES';
export const AVAILABILITIES__NO_EMPLOYEES_FOUND = '[AVAILABILITIES] NO_EMPLOYEES_FOUND';
export const AVAILABILITIES__REQUEST_AVAILABILITY = '[AVAILABILITIES] REQUEST_AVAILABILITY';
export const AVAILABILITIES__REQUEST_ALL_AVAILABILITIES = '[AVAILABILITIES] REQUEST_ALL_AVAILABILITIES';
export const AVAILABILITIES__REQUEST_BASED_ON_FILTERS = '[AVAILABILITIES] REQUEST_BASED_ON_FILTERS';
export const AVAILABILITIES__CHANGES_NOT_SUBMITTED = '[AVAILABILITIES] CHANGES_NOT_SUBMITTED';

// company availabilities
export const COMPANY_AVAILABILITY__AVAILABLE_EMPLOYEES = '[COMPANY_AVAILABILITY] AVAILABLE_EMPLOYEES';
export const COMPANY_AVAILABILITY__REQUEST_AVAILABILITY = '[COMPANY_AVAILABILITY] REQUEST_AVAILABILITY';
export const COMPANY_AVAILABILITY__REQUEST_ALL_AVAILABILITIES = '[COMPANY_AVAILABILITY] REQUEST_ALL_AVAILABILITIES';

// api users
export const API_USERS = '[API_USERS] API_USERS';
export const API_USERS__ADD_NEW = '[API_USERS] ADD_NEW';
export const API_USERS__ADD_NEW_BUTTON = '[API_USERS] ADD_NEW_BUTTON';
export const API_USERS__EDIT_SUPERADMIN = '[API_USERS] EDIT_SUPERADMIN';
export const API_USERS__DELETE_SUPERADMIN = '[API_USERS] DELETE_ADMIN';

// account managers
export const ACCOUNT_MANAGERS = '[ACCOUNT_MANAGERS] ACCOUNT_MANAGERS';
export const ACCOUNT_MANAGERS__ADD_NEW = '[ACCOUNT_MANAGERS] ADD_NEW';
export const ACCOUNT_MANAGERS__ADD_NEW_BUTTON = '[ACCOUNT_MANAGERS] ADD_NEW_BUTTON';

// employees
export const EMPLOYEES__PERSONAL_INFO = '[EMPLOYEES] PERSONAL_INFO';
export const EMPLOYEES__CONTACT_INFO = '[EMPLOYEES] CONTACT_INFO';
export const EMPLOYEES__WORKING_INFO = '[EMPLOYEES] WORKING_INFO';
export const EMPLOYEES__ACCOUNT = '[EMPLOYEES] ACCOUNT';
export const EMPLOYEES__BIRTH_DATE = '[EMPLOYEES] BIRTH_DATE';
export const EMPLOYEES__BIRTH_PLACE = '[EMPLOYEES] BIRTH_PLACE';
export const EMPLOYEES__BIRTH_COUNTRY = '[EMPLOYEES] BIRTH_COUNTRY';
export const EMPLOYEES__NATIONALITY = '[EMPLOYEES] NATIONALITY';
export const EMPLOYEES__INSS = '[EMPLOYEES] INSS';
export const EMPLOYEES__MARITAL_STATUS = '[EMPLOYEES] MARITAL_STATUS';
export const EMPLOYEES__MARITAL_STATUS_MARRIED = '[EMPLOYEES] MARITAL_STATUS_MARRIED';
export const EMPLOYEES__MARITAL_STATUS_SINGLE = '[EMPLOYEES] MARITAL_STATUS_SINGLE';
export const EMPLOYEES__MARITAL_STATUS_DIVORCED = '[EMPLOYEES] MARITAL_STATUS_DIVORCED';
export const EMPLOYEES__MARITAL_STATUS_WIDOW = '[EMPLOYEES] MARITAL_STATUS_WIDOW';
export const EMPLOYEES__MARITAL_STATUS_LIVING_TOGETHER = '[EMPLOYEES] MARITAL_STATUS_LIVING_TOGETHER';
export const EMPLOYEES__DEPENDANTS = '[EMPLOYEES] DEPENDANTS';
export const EMPLOYEES__DEPENDANTS_PARTNER = '[EMPLOYEES] DEPENDANTS_PARTNER';
export const EMPLOYEES__DEPENDANTS_DISABLED_PARTNER = '[EMPLOYEES] DEPENDANTS_DISABLED_PARTNER';
export const EMPLOYEES__DEPENDANTS_CHILDREN = '[EMPLOYEES] DEPENDANTS_CHILDREN';
export const EMPLOYEES__DEPENDANTS_DISABLED_CHILDREN = '[EMPLOYEES] DEPENDANTS_DISABLED_CHILDREN';
export const EMPLOYEES__DEPENDANTS_ELDERLY = '[EMPLOYEES] DEPENDANTS_ELDERLY';
export const EMPLOYEES__MOBILE_NUMBER = '[EMPLOYEES] MOBILE_NUMBER';
export const EMPLOYEES__ICE_MOBILE_NUMBER = '[EMPLOYEES] ICE_MOBILE_NUMBER';
export const EMPLOYEES__REASON_FOR_EMPLOYMENT = '[EMPLOYEES] REASON_FOR_EMPLOYMENT';
export const EMPLOYEES__ID_CARD_NUMBER = '[EMPLOYEES] ID_CARD_NUMBER';
export const EMPLOYEES__MODE_OF_TRANSPORT = '[EMPLOYEES] MODE_OF_TRANSPORT';
export const EMPLOYEES__UPLOAD_ID = '[EMPLOYEES] UPLOAD_ID';
export const EMPLOYEES__UPLOAD_PICTURE = '[EMPLOYEES] UPLOAD_PICTURE';
export const EMPLOYEES__ID_EXPIRATION_DATE = '[EMPLOYEES] ID_EXPIRATION_DATE';
export const EMPLOYEES__ADD_NEW_EMPLOYEE = '[EMPLOYEES] ADD_NEW_EMPLOYEE';
export const EMPLOYEES__EDIT_EMPLOYEE = '[EMPLOYEES] EDIT_EMPLOYEE';
export const EMPLOYEES__VIEW_EMPLOYEE = '[EMPLOYEES] VIEW_EMPLOYEE';
export const EMPLOYEES__YEARS_OF_EXPERIENCE = '[EMPLOYEES] YEARS_OF_EXPERIENCE';
export const EMPLOYEES__VALIDATE_YEARS_OF_EXPERIENCE = '[EMPLOYEES] VALIDATE_YEARS_OF_EXPERIENCE';
export const EMPLOYEES__AGREE_TO = '[EMPLOYEES] AGREE_TO';
export const EMPLOYEES__PICTURE_AGREEMENT_LINK = '[EMPLOYEES] PICTURE_AGREEMENT_LINK';
export const EMPLOYEES__AGREE_TO_GDPR = '[EMPLOYEES] AGREE_TO_GDPR';
export const EMPLOYEES__CHECK_GDPR_LINK = '[EMPLOYEES] CHECK_GDPR_LINK';
export const EMPLOYEES__AGREE_TO_GDPR_ERROR = '[EMPLOYEES] AGREE_TO_GDPR_ERROR';
export const EMPLOYEES__STREET_NAME = '[EMPLOYEES] STREET_NAME';
export const EMPLOYEES__STREET_NUMBER = '[EMPLOYEES] STREET_NUMBER';
export const EMPLOYEES__BUS_NUMBER = '[EMPLOYEES] BUS_NUMBER';
export const EMPLOYEES__INACTIVE = '[EMPLOYEES] INACTIVE';
export const EMPLOYEES__ACTIVE = '[EMPLOYEES] ACTIVE';
export const EMPLOYEES__SORT_CRITERIA = '[EMPLOYEES] SORT_CRITERIA';
export const EMPLOYEES__SORT_NEWEST = '[EMPLOYEES] SORT_NEWEST';
export const EMPLOYEES__SORT_ALPHABETICAL = '[EMPLOYEES] SORT_ALPHABETICAL';
export const EMPLOYEES__USE_EXISTING_PASSWORD = '[EMPLOYEES] USE_EXISTING_PASSWORD';
export const EMPLOYEES__LINK_EXISTING_ACCOUNT = '[EMPLOYEES] LINK_EXISTING_ACCOUNT';
export const EMPLOYEES__USE_CORRECT_EMAIL_AND_INSS = '[EMPLOYEES] USE_CORRECT_EMAIL_AND_INSS';
export const MODES_OF_TRANSPORT__PRIVATE = '[MODES_OF_TRANSPORT] PRIVATE';
export const MODES_OF_TRANSPORT__BIKE = '[MODES_OF_TRANSPORT] BIKE';
export const MODES_OF_TRANSPORT__PUBLIC_TRANSPORT = '[MODES_OF_TRANSPORT] PUBLIC_TRANSPORT';
export const EMPLOYEES__SELECT_A_COMPANY = '[EMPLOYEES] SELECT_A_COMPANY';
export const EMPLOYEES__COMPANY_NO_EMPLOYEES = '[EMPLOYEES] COMPANY_NO_EMPLOYEES';
export const EMPLOYEES__STATUS = '[EMPLOYEES] STATUS';
export const EMPLOYEES__AGE = '[EMPLOYEES] AGE';
export const EMPLOYEES__GENDER = '[EMPLOYEES] GENDER';
export const EMPLOYEES__REQUIRES_ACTION = '[EMPLOYEES] REQUIRES_ACTION';
export const EMPLOYEES__INVITE = '[EMPLOYEES] INVITE';
export const EMPLOYEES__INVITE_EMPLOYEE = '[EMPLOYEES] INVITE_EMPLOYEE';
export const EMPLOYEES__INVITE_EMPLOYEE_SENT = '[EMPLOYEES] INVITE_EMPLOYEE_SENT';
export const EMPLOYEES__INVITE_EMPLOYEE_SAVED = '[EMPLOYEES] INVITE_EMPLOYEE_SAVED';
export const EMPLOYEES__RESEND_INVITATION = '[EMPLOYEES] RESEND_INVITATION';
export const EMPLOYEES__INVITATION_SENT_SUCCESSFULLY = '[EMPLOYEES] INVITATION_SENT_SUCCESSFULLY';
export const EMPLOYEES__INVITE_EMPLOYEE_COPY_INVITATION_LINK = '[EMPLOYEES] INVITE_EMPLOYEE_COPY_INVITATION_LINK';
export const EMPLOYEES__REINVITE_BUTTON = '[EMPLOYEES] REINVITE_BUTTON';
export const EMPLOYEES__COPY_LINK_BUTTON = '[EMPLOYEES] COPY_LINK_BUTTON';
export const EMPLOYEES__EMPLOYEE_ONBOARDING = '[EMPLOYEES] EMPLOYEE_ONBOARDING';
export const EMPLOYEES__ADDED_SUCCESSFULLY = '[EMPLOYEES] ADDED_SUCCESSFULLY';
export const EMPLOYEES__CONFIRM_PASSWORD = '[EMPLOYEES] CONFIRM_PASSWORD';
export const EMPLOYEES__COUNTRY = '[EMPLOYEES] COUNTRY';
export const EMPLOYEES__ALREADY_EXISTS_ERROR = '[EMPLOYEES] ALREADY_EXISTS_ERROR';
export const EMPLOYEES__INSS_ERROR = '[EMPLOYEES] INSS_ERROR';
export const EMPLOYEES__IBAN_ERROR = '[EMPLOYEES] IBAN_ERROR';
export const EMPLOYEES__EMAIL_ERROR = '[EMPLOYEES] EMAIL_ERROR';
export const EMPLOYEES__SEARCH_EMPLOYEE_NAME = '[EMPLOYEES] SEARCH_EMPLOYEE_NAME';
export const EMPLOYEES__VIEW_ID = '[EMPLOYEES] VIEW_ID';
export const EMPLOYEES__UPLOAD_ID_FRONT = '[EMPLOYEES] UPLOAD_ID_FRONT';
export const EMPLOYEES__UPLOAD_ID_BACK = '[EMPLOYEES] UPLOAD_ID_BACK';
export const EMPLOYEES__STUDENT_FULL = '[EMPLOYEES] STUDENT';
export const EMPLOYEES__FLEXI_FULL = '[EMPLOYEES] FLEXI';
export const EMPLOYEES__EXTRA_FULL = '[EMPLOYEES] EXTRA';
export const EMPLOYEES__LABOURER_FULL = '[EMPLOYEES] LABOURER';
export const EMPLOYEES__SERVANT_FULL = '[EMPLOYEES] SERVANT';
export const EMPLOYEES__PERMANENT = '[EMPLOYEES] PERMANENT';
export const EMPLOYEES__START_DATE = '[EMPLOYEES] START_DATE';
export const EMPLOYEES__PERMANENT_CHANGE_VALIDATION = '[EMPLOYEES] PERMANENT_CHANGE_VALIDATION';
export const EMPLOYEES__STUDENT_TOOLTIP = '[EMPLOYEES] STUDENT_TOOLTIP';
export const EMPLOYEES__FLEXI_TOOLTIP = '[EMPLOYEES] FLEXI_TOOLTIP';
export const EMPLOYEES__EXTRA_TOOLTIP = '[EMPLOYEES] EXTRA_TOOLTIP';
export const EMPLOYEES__LABOURER_TOOLTIP = '[EMPLOYEES] LABOURER_TOOLTIP';
export const EMPLOYEES__SERVANT_TOOLTIP = '[EMPLOYEES] SERVANT_TOOLTIP';
export const EMPLOYEES__STAY_ADDRESS = '[EMPLOYEES] STAY_ADDRESS';
export const EMPLOYEES__STAY_CITY = '[EMPLOYEES] STAY_CITY';
export const EMPLOYEES__STAY_STREET = '[EMPLOYEES] STAY_STREET';
export const EMPLOYEES__STAY_NUMBER = '[EMPLOYEES] STAY_NUMBER';
export const EMPLOYEES__STAY_BUS = '[EMPLOYEES] STAY_BUS';
export const EMPLOYEES__POSTAL_CODE = '[EMPLOYEES] STAY_POSTAL_CODE';
export const EMPLOYEES__STAY_COUNTRY = '[EMPLOYEES] STAY_COUNTRY';
export const EMPLOYEE__COMPANY_LOCATION = '[EMPLOYEE] COMPANY_LOCATION';
export const EMPLOYEE__COMPANY_LOCATION_NO_COMMON = '[EMPLOYEE] COMPANY_LOCATION_NO_COMMON';
export const EMPLOYEE__STUDENT_DECLARATION = '[EMPLOYEE] STUDENT_DECLARATION';
export const EMPLOYEE__LETTER_OF_INTENT = '[EMPLOYEE] LETTER_OF_INTENT';
export const EMPLOYEE__FIND_STUDENT_DECLARATION_TEXT = '[EMPLOYEE] FIND_STUDENT_DECLARATION_TEXT';
export const EMPLOYEE__FIND_LETTER_OF_INTENT_TEXT = '[EMPLOYEE] FIND_LETTER_OF_INTENT_TEXT';
export const EMPLOYEE__UPLOADED_DOCUMENT = '[EMPLOYEE] UPLOADED_DOCUMENT';
export const EMPLOYEE__WORKERCLASS_NOT_SELECTED_ERROR = '[EMPLOYEE] WORKERCLASS_NOT_SELECTED_ERROR';
export const EMPLOYEE__WORKERCLASS_TOOLTIP = '[EMPLOYEE] WORKERCLASS_TOOLTIP';
export const EMPLOYEE__WORKERCLASS_HYPERLINK_TEXT = '[EMPLOYEE] WORKERCLASS_HYPERLINK_TEXT';
export const EMPLOYEE__ACADEMIC_PERIOD_ERROR = '[EMPLOYEE] ACADEMIC_PERIOD_ERROR';
export const EMPLOYEE__INVALID_ACADEMIC_PERIOD = '[EMPLOYEE] INVALID_ACADEMIC_PERIOD';
export const EMPLOYEES__INDIVIDUAL_INVITATION = '[EMPLOYEE] INDIVIDUAL_INVITATION';
export const EMPLOYEES__GENERAL_INVITATION_LIST = '[EMPLOYEE] GENERAL_INVITATION_LIST';
export const EMPLOYEES__IS_FOR_ALL_LOCATIONS = '[EMPLOYEE] IS_FOR_ALL_LOCATIONS';
export const EMPLOYEES__INVATION_TOKEN_INVALID = '[EMPLOYEE] INVATION TOKEN INVALID';
export const EMPLOYEES__SAME_EMAIL_AS_MANAGER_ERROR = '[EMPLOYEE] SAME_EMAIL_AS_MANAGER_ERROR';
export const EMPLOYEES__SAME_EMAIL_AS_SUPERADMIN_ERROR = '[EMPLOYEE] SAME_EMAIL_AS_SUPERADMIN_ERROR';
export const EMPLOYEES__SAME_EMAIL_AS_EMPLOYEE_ERROR = '[EMPLOYEE] SAME_EMAIL_AS_EMPLOYEE_ERROR';
export const EMPLOYEES__SAME_EMAIL_AS_OTHER_USER = '[EMPLOYEE] SAME_EMAIL_AS_OTHER_USER';
export const EMPLOYEE__INVITE_INVALID_BRANCH = '[EMPLOYEE] INVITE_INVALID_BRANCH';
export const EMPLOYEE__INVITE_NOT_FOUND = '[EMPLOYEE] INVITE_NOT_FOUND';
export const EMPLOYEE__INVITE_INVALID_CONTRACT_TYPE = '[EMPLOYEE] INVITE_INVALID_CONTRACT_TYPE';
export const EMPLOYEE__INVITE_INVALID_LANGUAGE = '[EMPLOYEE] INVITE_INVALID_LANGUAGE';
export const EMPLOYEES__RETIRED = '[EMPLOYEES] RETIRED';
export const EMPLOYEES__RETIRED_DATE = '[EMPLOYEES] RETIRED_DATE';
export const EMPLOYEES__TERMINATED = '[EMPLOYEES] TERMINATED';
export const EMPLOYEES__TERMINATION_DATE = '[EMPLOYEES] TERMINATION_DATE';
export const EMPLOYEES__TERMINATED_FILTER = '[EMPLOYEES] TERMINATED_FILTER';
export const EMPLOYEES__CANNOT_SWITCH_TERMINATED = '[EMPLOYEES] CANNOT_SWITCH_TERMINATED';
export const EMPLOYEES__ELIGIBLE = '[EMPLOYEES] ELIGIBLE';
export const EMPLOYEES__ELIGIBLE_FILTER = '[EMPLOYEES] ELIGIBLE_FILTER';
export const EMPLOYEES__INVITED = '[EMPLOYEES] INVITED';
export const EMPLOYEES__EMPLOYMENT = '[EMPLOYEES] EMPLOYMENT';
export const EMPLOYEES__APPLICANTS = '[EMPLOYEES] APPLICANTS';

// set password
export const SET_PASSWORD__TITLE = '[SET_PASSWORD] TITLE';
export const SET_PASSWORD__CONFIRM_PASSWORD_LABEL = '[SET_PASSWORD] CONFIRM_PASSWORD_LABEL';
export const SET_PASSWORD__UNAUTHORISED_REQUEST = '[SET_PASSWORD] UNAUTHORISED_REQUEST';
export const SET_PASSWORD__LINK_EXPIRED = '[SET_PASSWORD] LINK_EXPIRED';

// validation messages
export const VALIDATION__IS_REQUIRED = '[VALIDATION] IS_REQUIRED';
export const VALIDATION__INVALID_NUMBER = '[VALIDATION] INVALID_NUMBER';
export const VALIDATION__INVALID_FIELD = '[VALIDATION] INVALID_FIELD';
export const VALIDATION__INVALID_FORMAT = '[VALIDATION] INVALID_FORMAT';
export const VALIDATION__PASSWORDS_NOT_MATCH = '[VALIDATION] PASSWORDS_NOT_MATCH';
export const VALIDATION__INVALID_INSS = '[VALIDATION] INVALID_INSS';
export const VALIDATION__MAX_LENGTH = '[VALIDATION] MAX_LENGTH';
export const VALIDATION__MIN_LENGTH = '[VALIDATION] MIN_LENGTH';
export const VALIDATION__CHARACTERS = '[VALIDATION] CHARACTERS';
export const VALIDATION__DIGITS = '[VALIDATION] DIGITS';
export const VALIDATION__SHOULD_BE_GREATER_THAN = '[VALIDATION] SHOULD_BE_GREATER_THAN';

// reason for employment enum
export const REASON__EXTRA_CASH = '[REASON] EXTRA_CASH';
export const REASON__SEEKING_PERMANENT_JOB = '[REASON] SEEKING_PERMANENT_JOB';
export const REASON__SEEKING_EXPERIENCE = '[REASON] SEEKING_EXPERIENCE';

// contracts
export const CONTRACTS__NEW_CONTRACT = '[CONTRACTS] NEW_CONTRACT';
export const CONTRACTS__NEW_CONTRACT_SLOT = '[CONTRACTS] NEW_CONTRACT_SLOT';
export const CONTRACTS__NEW_CONTRACT_SLOT_DISABLED = '[CONTRACTS] NEW_CONTRACT_SLOT_DISABLED';
export const CONTRACTS__COST_CENTER = '[CONTRACTS] COST_CENTER';
export const CONTRACTS__COMPANY_LOCATION = '[CONTRACTS] COMPANY_LOCATION';
export const CONTRACTS__CANCEL = '[CONTRACTS] CANCEL';
export const CONTRACTS__FUNCTION = '[CONTRACTS] FUNCTION';
export const CONTRACTS__VENDOR = '[CONTRACTS] VENDOR';
export const CONTRACTS__TO_BE_CONFIRMED = '[CONTRACTS] TO_BE_CONFIRMED';
export const CONTRACTS__START_WORK = '[CONTRACTS] START_WORK';
export const CONTRACTS__START_BREAK = '[CONTRACTS] START_BREAK';
export const CONTRACTS__END_BREAK = '[CONTRACTS] END_BREAK';
export const CONTRACTS__END_WORK = '[CONTRACTS] END_WORK';
export const CONTRACTS__DATES = '[CONTRACTS] DATES';
export const CONTRACTS__WAGE = '[CONTRACTS] WAGE';
export const CONTRACTS__ADD_ANOTHER = '[CONTRACTS] ADD_ANOTHER';
export const CONTRACTS__MIN_HOURS_VALIDATION = '[CONTRACTS] MIN_HOURS_VALIDATION';
export const CONTRACTS__MAX_HOURS_VALIDATION = '[CONTRACTS] MAX_HOURS_VALIDATION';
export const CONTRACTS__CHRONOLOGICAL_ORDER_VALIDATION = '[CONTRACTS] CHRONOLOGICAL_ORDER_VALIDATION';
export const CONTRACTS__SELECTED = '[CONTRACTS] SELECTED';
export const CONTRACTS__COPY_SELECTED = '[CONTRACTS] COPY_SELECTED';
export const CONTRACTS__CANCEL_COPY_MODE = '[CONTRACTS] CANCEL_COPY_MODE';
export const CONTRACTS__WORKING_LOCATION = '[CONTRACTS] WORKING_LOCATION';
export const CONTRACTS__PASTE_HERE = '[CONTRACTS] PASTE_HERE';
export const CONTRACTS__CLEAR_ALL = '[CONTRACTS] CLEAR_ALL';
export const CONTRACTS__DELETE_SELECTED = '[CONTRACTS] DELETE_SELECTED';
export const CONTRACTS__PRESENT_DATE_ERROR = '[CONTRACTS] PRESENT_DATE_ERROR';
export const CONTRACTS__PRESENT_START_HOUR_ERROR = '[CONTRACTS] PRESENT_START_HOUR_ERROR';
export const CONTRACTS__END_HOUR_ERROR = '[CONTRACTS] END_HOUR_ERROR';
export const CONTRACTS__INVALID_HOUR_ERROR = '[CONTRACTS] INVALID_HOUR_ERROR';
export const CONTRACTS__CONFIRM_SERVICE = '[CONTRACTS] CONFIRM_SERVICE';
export const CONTRACTS__CONFIRM_COST_DECLARATION_ERROR = '[CONTRACTS] CONFIRM_COST_DECLARATION_ERROR';
export const CONTRACTS__SELECT_REASON = '[CONTRACTS] SELECT_REASON';
export const CONTRACTS__DATE = '[CONTRACTS] DATE';
export const CONTRACTS__EDIT_CONTRACT = '[CONTRACTS] EDIT_CONTRACT';
export const CONTRACTS__FILL_CONTRACT_SLOT = '[CONTRACTS] FILL_CONTRACT_SLOT';
export const CONTRACTS__VIEW_CONTRACT = '[CONTRACTS] VIEW_CONTRACT';
export const CONTRACTS__ARE_YOU_SURE = '[CONTRACTS] ARE_YOU_SURE';
export const CONTRACTS__ALREADY_CONFIRMED = '[CONTRACTS] ALREADY_CONFIRMED';
export const CONTRACTS__NONE = '[CONTRACTS] NONE';
export const CONTRACTS__DELETE_PAST_CONTRACT_ERROR = '[CONTRACTS] DELETE_PAST_CONTRACT_ERROR';
export const CONTRACTS__DELETE_WEEKLY_CONTRACT_WARNING = '[CONTRACTS] DELETE_WEEKLY_CONTRACT_WARNING';
export const CONTRACTS__DELETE_CONTRACT_WITH_ID_ERROR = '[CONTRACTS] DELETE_CONTRACT_WITH_ID_ERROR';
export const CONTRACTS__DEFAULT_ERROR = '[CONTRACTS] DEFAULT_ERROR';
export const CONTRACTS__SIGNED_CONTRACT_ERROR = '[CONTRACTS] SIGNED_CONTRACT_ERROR';
export const CONTRACTS__OTHER_CONTRACT_CHRONOLOGICAL_ORDER_VALIDATION =
  '[CONTRACTS] OTHER_CONTRACT_CHRONOLOGICAL_ORDER_VALIDATION';
export const CONTRACTS__NO_SHOW = '[CONTRACTS] NO_SHOW';
export const CONTRACTS__ABSENT = '[CONTRACTS] ABSENT';
export const CONTRACTS__ARCHIVED = '[CONTRACTS] ARCHIVED';
export const CONTRACTS__CONFIRM_SELECTED = '[CONTRACTS] CONFIRM_SELECTED';
export const CONTRACTS__EDIT_MORE_CONTRACTS_ERROR = '[CONTRACTS] EDIT_MORE_CONTRACTS_ERROR';
export const CONTRACTS__START_END_WORK_ERROR = '[CONTRACTS] START_END_WORK_ERROR';
export const CONTRACTS__REASON_FOR_NO_SHOW = '[CONTRACTS] REASON_FOR_NO_SHOW';
export const CONTRACTS__FUTURE_CONTRACTS = '[CONTRACTS] FUTURE_CONTRACTS';
export const CONTRACTS__CONFIRM_MULTIPLE_ERROR = '[CONTRACTS] CONFIRM_MULTIPLE_ERROR';
export const CONTRACTS__PASTE_WEEKLY_CONTRACT = '[CONTRACTS] PASTE_WEEKLY_CONTRACTS';
export const CONTRACTS__COPY_MULTIPLE_CONTRACTS = '[CONTRACTS] COPY_MULTIPLE_CONTRACTS';
export const CONTRACTS__EDIT_BEFORE_PASTING = '[CONTRACTS] EDIT_BEFORE_PASTING';
export const CONTRACTS__WEEKS_TO_COPY_TO = '[CONTRACTS] WEEKS_TO_COPY_TO';
export const CONTRACTS__ACTIVE_CONTRACTS = '[CONTRACTS] ACTIVE_CONTRACTS';
export const CONTRACTS__EXPORTED_CONTRACTS = '[CONTRACTS] EXPORTED_CONTRACTS';
export const CONTRACTS__ARCHIVED_CONTRACTS = '[CONTRACTS] ARCHIVED_CONTRACTS';
export const CONTRACTS__ITEMS_SELECTED = '[CONTRACTS] ITEMS_SELECTED';
export const CONTRACTS__COST_DELCARATION = '[CONTRACTS] COST_DELCARATION';
export const CONTRACTS__COST_DELCARATION_ADD = '[CONTRACTS] COST_DELCARATION_ADD';
export const CONTRACTS__COST_DELCARATION_VALUE = '[CONTRACTS] COST_DELCARATION_VALUE';
export const CONTRACTS__COST_DELCARATION_AMOUNT = '[CONTRACTS] COST_DELCARATION_AMOUNT';
export const CONTRACTS__GET_DIMONA_ID = '[CONTRACTS] GET_DIMONA_ID';
export const CONTRACTS__DIMONA = '[CONTRACTS] DIMONA';
export const CONTRACTS__PLEASE_USE_FILTERS = '[CONTRACTS] PLEASE_USE_FILTERS';
export const CONTRACTS__FETCH_MORE = '[CONTRACTS] FETCH_MORE';
export const CONTRACTS__MULTIPLE_ERROR_MESSAGES = '[CONTRACTS] MULTIPLE_ERROR_MESSAGES';
export const CONTRACTS__IS_SIGNED_WARNING = '[CONTRACTS] IS_SIGNED_WARNING';
export const CONTRACTS__PROCEED_QUESTION = '[CONTRACTS] PROCEED_QUESTION';
export const CONTRACTS__ANOTHER_WORKERTYPE_EXISTS_IN_QUARTER = '[CONTRACTS] ANOTHER_WORKERTYPE_EXISTS_IN_QUARTER';
export const CONTRACTS__FLEXI_WORKERTYPE_EXISTS_IN_QUARTER = '[CONTRACTS] FLEXI_WORKERTYPE_EXISTS_IN_QUARTER';
export const CONTRACTS__FUNCTION_NOT_LINKED_TO_EMPLOYEE = '[CONTRACTS] FUNCTION_NOT_LINKED_TO_EMPLOYEE';
export const CONTRACTS__TO_BE_PROCESSED = '[CONTRACTS] TO_BE_PROCESSED';
export const CONTRACTS__DEVIATION = '[CONTRACTS] DEVIATION';
export const CONTRACTS__ADJUSTED = '[CONTRACTS] ADJUSTED';
export const CONTRACTS__REGISTRATION_STATUS = '[CONTRACTS] REGISTRATION_STATUS';
export const CONTRACTS__VIEW_DETAILS = '[CONTRACTS] VIEW_DETAILS';
export const CONTRACTS__EFFECTIVE_TOTAL = '[CONTRACTS] EFFECTIVE_TOTAL';
export const CONTRACTS__NO_ITEMS_TO_PROCESS = '[CONTRACTS] NO_ITEMS_TO_PROCESS';
export const CONTRACTS__SAVE_SUCCESS = '[CONTRACTS] SAVE_SUCCESS';
export const CONTRACTS__SAVE_FAILED = '[CONTRACTS] SAVE_FAILED';
export const CONTRACTS__NO_PLANNING_EXISTS = '[CONTRACTS] NO_PLANNING_EXISTS';
export const CONTRACTS__PLANNING_DELETED_BANNER = '[CONTRACTS] PLANNING_DELETED_BANNER';
export const CONTRACTS__NO_REGISTRATION_EXISTS = '[CONTRACTS] NO_REGISTRATION_EXISTS';
export const CONTRACTS__COULD_NOT_LOAD_DETAILS = '[CONTRACTS] COULD_NOT_LOAD_DETAILS';
export const CONTRACTS__NO_ACCESS_TO_VIEW = '[CONTRACTS] NO_ACCESS_TO_VIEW';
export const CONTRACTS__FAILED_TO_SAVE = '[CONTRACTS] FAILED_TO_SAVE';
export const CONTRACTS__CONFIRM_WORKED_HOURS = '[CONTRACTS] CONFIRM_WORKED_HOURS';
export const CONTRACTS__PLANNED_TIME = '[CONTRACTS] PLANNED_TIME';
export const CONTRACTS__REGISTERED_TIME = '[CONTRACTS] REGISTERED_TIME';
export const CONTRACTS__ADD_EXTRA_BREAK = '[CONTRACTS] ADD_EXTRA_BREAK';
export const CONTRACTS__GENERAL = '[CONTRACTS] GENERAL';
export const CONTRACTS__BREAK = '[CONTRACTS] BREAK';
export const CONTRACTS__AUDIT = '[CONTRACTS] AUDIT';
export const CONTRACTS__AUDIT_SERVICE = '[CONTRACTS] AUDIT_SERVICE';
export const CONTRACTS__AUDIT_CONTRACT = '[CONTRACTS] AUDIT_CONTRACT';
export const CONTRACTS__AUDIT_CREATED = '[CONTRACTS] AUDIT_CREATED';
export const CONTRACTS__AUDIT_LAST_MODIFIED = '[CONTRACTS] AUDIT_LAST_MODIFIED';
export const CONTRACTS__AUDIT_CLOCK_IN = '[CONTRACTS] AUDIT_CLOCK_IN';
export const CONTRACTS__AUDIT_CLOCK_OUT = '[CONTRACTS] AUDIT_CLOCK_OUT';
export const CONTRACTS__AUDIT_ON_LOCATION = '[CONTRACTS] AUDIT_ON_LOCATION';
export const CONTRACTS__AUDIT_ACCURACY_RADIUS = '[CONTRACTS] AUDIT_ACCURACY_RADIUS';
export const CONTRACTS__ON_LOCATION_ON = '[CONTRACTS] ON_LOCATION_ON';
export const CONTRACTS__ON_LOCATION_OFF = '[CONTRACTS] ON_LOCATION_OFF';
export const CONTRACTS__ON_LOCATION_UNKNOWN = '[CONTRACTS] ON_LOCATION_UNKNOWN';
export const CONTRACTS__ON_LOCATION_KIOSK = '[CONTRACTS] ON_LOCATION_KIOSK';
export const CONTRACTS__WORKING_TIMES = '[CONTRACTS] WORKING_TIMES';

// cost estimation
export const COST_ESTIMATION__COST_FOR_ALL = '[COST_ESTIMATION] COST_FOR_ALL';
export const COST_ESTIMATION__TOOLTIP = '[COST_ESTIMATION] TOOLTIP';
export const COST_ESTIMATION__STUDENTS = '[COST_ESTIMATION] STUDENTS';
export const COST_ESTIMATION__FLEXI = '[COST_ESTIMATION] FLEXI';
export const COST_ESTIMATION__EXTRA = '[COST_ESTIMATION] EXTRA';
export const COST_ESTIMATION__BED = '[COST_ESTIMATION] BED';
export const COST_ESTIMATION__ARB = '[COST_ESTIMATION] ARB';
export const COST_ESTIMATION__VIEW_INVOICES = '[COST_ESTIMATION] VIEW_INVOICES';

// employee status
export const EMPLOYEE_STATUS__INVITED = '[EMPLOYEE_STATUS] INVITED';
export const EMPLOYEE_STATUS__REQUIRES_ACTION = '[EMPLOYEE_STATUS] REQUIRES_ACTION';
export const EMPLOYEE_STATUS__READY = '[EMPLOYEE_STATUS] READY';
export const EMPLOYEE_STATUS__DEPLOYED = '[EMPLOYEE_STATUS] DEPLOYED';
export const EMPLOYEE_STATUS__TERMINATED = '[EMPLOYEE_STATUS] TERMINATED';
export const EMPLOYEE_STATUS__NOT_ELIGIBLE = '[EMPLOYEE_STATUS] NOT_ELIGIBLE';

// reason for no show in contracts
export const NO_SHOW__ALLOWED_ABSENCE = '[NO_SHOW] ALLOWED_ABSENCE';
export const NO_SHOW__NOT_ALLOWED_ABSENCE = '[NO_SHOW] NOT_ALLOWED_ABSENCE';
export const NO_SHOW__SICKNESS = '[NO_SHOW] SICKNESS';
export const NO_SHOW__OTHER = '[NO_SHOW] OTHER';

// documents
export const DOCUMENTS__ADD_NEW_DOCUMENT = '[DOCUMENTS] ADD_NEW_DOCUMENT';
export const DOCUMENTS__ADD_DOCUMENTS = '[DOCUMENTS] ADD_DOCUMENTS';
export const DOCUMENTS__DATE = '[DOCUMENTS] DATE';
export const DOCUMENTS__SELECT_CATEGORY = '[DOCUMENTS] SELECT_CATEGORY';
export const DOCUMENTS__CATEGORY = '[DOCUMENTS] CATEGORY';
export const DOCUMENTS__DRAG_AND_DROP_FILES = '[DOCUMENTS] DRAG_AND_DROP_FILES';
export const DOCUMENTS__DRAG_AND_DROP_STUD_DECLARATION = '[DOCUMENTS] DRAG_AND_DROP_STUD_DECLARATION';
export const DOCUMENTS__BROWSE = '[DOCUMENTS] BROWSE';
export const DOCUMENTS__ALL_FIELDS_ARE_REQUIRED_ERROR = '[DOCUMENTS] ALL_FIELDS_ARE_REQUIRED_ERROR';
export const DOCUMENTS__CONTRACT = '[DOCUMENTS] CONTRACT';
export const DOCUMENTS__INVOICE = '[DOCUMENTS] INVOICE';
export const DOCUMENTS__WORKPOSTFILE = '[DOCUMENTS] WORKPOSTFILE';
export const DOCUMENTS__BANKING_MANDATE = '[DOCUMENTS] BANKING_MANDATE';
export const DOCUMENTS__STUDENT_PROOF_OF_INSCRIPTION = '[DOCUMENTS] STUDENT_PROOF_OF_INSCRIPTION';
export const DOCUMENTS__ID = '[DOCUMENTS] ID';
export const DOCUMENTS__DOCUMENT_NAME = '[DOCUMENTS] DOCUMENT_NAME';
export const DOCUMENTS__DOCUMENT_CATEGORY = '[DOCUMENTS] DOCUMENT_CATEGORY';
export const DOCUMENTS__DOCUMENT_USER = '[DOCUMENTS] DOCUMENT_USER';
export const DOCUMENTS__SYNC_WITH_EXPRESSO = '[DOCUMENTS] SYNC_WITH_EXPRESSO';
export const DOCUMENTS__SYNC_WITH_EXPRESSO_INCLUDE_EMPLOYEE_DOCS =
  '[DOCUMENTS] SYNC_WITH_EXPRESSO_INCLUDE_EMPLOYEE_DOCS';
export const DOCUMENTS__PERIOD_START = '[DOCUMENTS] PERIOD_START';
export const DOCUMENTS__PERIOD_END = '[DOCUMENTS] PERIOD_END';
export const DOCUMENTS__INVALID_PERIOD = '[DOCUMENTS] INVALID_PERIOD';
export const DOCUMENTS__INVALID_EXPIRATION_DATE = '[DOCUMENTS] INVALID_EXPIRATION_DATE';
export const DOCUMENTS__VCA = '[DOCUMENTS] VCA';
export const DOCUMENTS__MEDICAL_CHECK = '[DOCUMENTS] MEDICAL_CHECK';
export const DOCUMENTS__SAFETY_PASSPORT = '[DOCUMENTS] SAFETY_PASSPORT';
export const DOCUMENTS__BANK_CARD = '[DOCUMENTS] BANK_CARD';
export const DOCUMENTS__DRIVING_LICENSE = '[DOCUMENTS] DRIVING_LICENSE';
export const DOCUMENTS__WORK_PERMIT = '[DOCUMENTS] WORK_PERMIT';
export const DOCUMENTS__CONFIRMATION_SHEET = '[DOCUMENTS] CONFIRMATION_SHEET';
export const DOCUMENTS__PARTNERSHIP_AGREEMENT = '[DOCUMENTS] PARTNERSHIP_AGREEMENT';
export const DOCUMENTS__SHARED_FILES = '[DOCUMENTS] SHARED_FILES';
export const DOCUMENTS__UPLOAD_DATE = '[DOCUMENTS] UPLOAD_DATE';
export const DOCUMENTS__EMPLOYEE = '[DOCUMENTS] EMPLOYEE';
export const DOCUMENTS__SELECTED = '[DOCUMENTS] SELECTED';
export const DOCUMENTS__CLEAR_ALL = '[DOCUMENTS] CLEAR_ALL';
export const DOCUMENTS__MANAGERS_WARNING = '[DOCUMENTS] MANAGERS_WARNING';
export const DOCUMENTS__DEVIATION_REGISTER = '[DOCUMENTS] DEVIATION_REGISTER';
export const DOCUMENTS__UPLOAD_FORMAT_NOT_SUPPORTED = '[DOCUMENTS] UPLOAD_FORMAT_NOT_SUPPORTED';
export const DOCUMENTS__PROCESSING = '[DOCUMENTS] PROCESSING';
export const DOCUMENTS__SOCIAL_DOCUMENT = '[DOCUMENTS] SOCIAL_DOCUMENT';
export const DOCUMENTS__INDIVIDUAL_ACCOUNT = '[DOCUMENTS] INDIVIDUAL_ACCOUNT';
export const DOCUMENTS__VACATION_CERTIFICATE = '[DOCUMENTS] VACATION_CERTIFICATE';
export const DOCUMENTS__EMPLOYMENT_CERTIFICATE = '[DOCUMENTS] EMPLOYMENT_CERTIFICATE';
export const DOCUMENTS__PAYSLIP = '[DOCUMENTS] PAYSLIP';
export const DOCUMENTS__FISCAL_FILE = '[DOCUMENTS] FISCAL_FILE';
export const DOCUMENTS__INTENTION_DECLARATION = '[DOCUMENTS] INTENTION_DECLARATION';
export const DOCUMENTS__ABSENCE_CERTIFICATE = '[DOCUMENTS] ABSENCE_CERTIFICATE';
export const DOCUMENTS__DRIVER_CARD = '[DOCUMENTS] DRIVER_CARD';
export const DOCUMENTS__C4 = '[DOCUMENTS] C4';
export const DOCUMENTS__CV = '[DOCUMENTS] CV';
export const DOCUMENTS__CODE_95 = '[DOCUMENTS] CODE_95';
export const DOCUMENTS__RESIDENCE_CARD = '[DOCUMENTS] RESIDENCE_CARD';
export const DOCUMENTS__BURDEN_OF_PROOF_EMPLOYEE = '[DOCUMENTS] BURDEN_OF_PROOF_EMPLOYEE';
export const DOCUMENTS__BURDEN_OF_PROOF_EMPLOYER = '[DOCUMENTS] BURDEN_OF_PROOF_EMPLOYER';
export const DOCUMENTS__CERTIFICATE_OF_GOOD_CONDUCT = '[DOCUMENTS] CERTIFICATE_OF_GOOD_CONDUCT';
export const DOCUMENTS__A1_DECLARATION = '[DOCUMENTS] A1_DECLARATION';
// blogs
export const BLOGS__TITLE = '[BLOGS] TITLE';
export const BLOGS__DESCRIPTION = '[BLOGS] DESCRIPTION';
export const BLOGS__ADD_NEW_BLOG = '[BLOGS] ADD_NEW_BLOG';
export const BLOGS__URL = '[BLOGS] URL';
export const BLOGS__BLOGS = '[BLOGS] BLOGS';
export const BLOGS__TARGET_GROUP = '[BLOGS] TARGET_GROUP';
export const BLOGS__TARGET_GROUP_ERROR = '[BLOGS] TARGET_GROUP_ERROR';
export const BLOGS__EMPLOYEE = '[BLOGS] EMPLOYEE';
export const BLOGS__EDIT_BLOG_TITLE = '[BLOGS] EDIT_BLOG_TITLE';

// dashboard
export const DASHBOARD__EDENRED_TEXT = '[DASHBOARD] EDENRED_TEXT';
export const DASHBOARD__UPDATEPRO_TEXT = '[DASHBOARD] UPDATEPRO_TEXT';
export const DASHBOARD__GO_TO_CONTRACTS = '[DASHBOARD] GO_TO_CONTRACTS';
export const DASHBOARD__THIS_WEEK = '[DASHBOARD] THIS_WEEK';
export const DASHBOARD__GO_TO_EMPLOYEES = '[DASHBOARD] GO_TO_EMPLOYEES';
export const DASHBOARD__SEE_HOURS_LEFT = '[DASHBOARD] SEE_HOURS_LEFT';
export const DASHBOARD__FOR_YOU = '[DASHBOARD] FOR_YOU';
export const DASHBOARD__SHORTCUTS = '[DASHBOARD] SHORTCUTS';
export const DASHBOARD__SIGN_CONTRACT = '[DASHBOARD] SIGN_CONTRACT';
export const DASHBOARD__ERROR_RELATED_TO = '[DASHBOARd] ERRPR_RELATED_TO';
export const DASHBOARD__INCLUDE_ARCHIVED = '[DASHBOARD] INCLUDE_ARCHIVED';
export const DASHBOARD__SHOW_WITHOUT_TYPE = '[DASHBOARD] SHOW_WITHOUT_TYPE';
export const DASHBOARD__SHOW_ARCHIVED = '[DASHBOARD] SHOW_ARCHIVED';
export const DASHBOARD__BUSINESS_OBJECT = '[DASHBOARD] BUSINESS_OBJECT';
export const DASHBOARD__EVENT_TYPE = '[DASHBOARD] EVENT_TYPE';
export const DASHBOARD__EVENT_SOURCE = '[DASHBOARD] EVENT_SOURCE';
export const DASHBOARD__EVENT_LOGS = '[DASHBOARD] EVENT_LOGS';
export const DASHBOARD__TOTAL_CONTRACTS = '[DASHBOARD] TOTAL_CONTRACTS';
export const DASHBOARD__KPIS = '[DASHBOARD] KPIS';
export const DASHBOARD__PLANNING_KPIS = '[DASHBOARD] PLANNING_KPIS';
export const DASHBOARD__PLANNING_KPIS_CONTRACTS_CREATED = '[DASHBOARD] PLANNING_KPIS_CONTRACTS_CREATED';
export const DASHBOARD__PLANNING_KPIS_PLANNED_HOURS = '[DASHBOARD] PLANNING_KPIS_PLANNED_HOURS';
export const DASHBOARD__NO_SHOW_KPI = '[DASHBOARD] NO_SHOW_KPI';
export const DASHBOARD__NO_SHOW_KPI_ALL = '[DASHBOARD] NO_SHOW_KPI_ALL';
export const DASHBOARD__NO_SHOW_KPI_ALLOWED_ABSENCE = '[DASHBOARD] NO_SHOW_KPI_ALLOWED_ABSENCE';
export const DASHBOARD__NO_SHOW_KPI_NOT_ALLOWED_ABSENCE = '[DASHBOARD] NO_SHOW_KPI_NOT_ALLOWED_ABSENCE';
export const DASHBOARD__NO_SHOW_KPI_TOP_COMPANIES = '[DASHBOARD] NO_SHOW_KPI_TOP_COMPANIES';
export const DASHBOARD__NO_SHOW_KPI_SICKNESS = '[DASHBOARD] NO_SHOW_KPI_SICKNESS';
export const DASHBOARD__NO_SHOW_KPI_OTHER = '[DASHBOARD] NO_SHOW_KPI_OTHER';
export const DASHBOARD__CONFIRMED_KPI = '[DASHBOARD] CONFIRMED_KPI';
export const DASHBOARD__CONFIRMED_KPI_LAST_WEEK = '[DASHBOARD] CONFIRMED_KPI_LAST_WEEK';
export const DASHBOARD__CONFIRMED_KPI_CURRENT_WEEK = '[DASHBOARD] CONFIRMED_KPI_CURRENT_WEEK';
export const DASHBOARD__CONFIRMED_KPI_LAST_MONTH = '[DASHBOARD] CONFIRMED_KPI_LAST_MONTH';
export const DASHBOARD__CONFIRMED_KPI_SOURCE_ALL = '[DASHBOARD] CONFIRMED_KPI_SOURCE_ALL';
export const DASHBOARD__CONFIRMED_KPI_SOURCE_UPORTAL = '[DASHBOARD] CONFIRMED_KPI_SOURCE_UPORTAL';
export const DASHBOARD__CONFIRMED_KPI_SOURCE_STROBBO = '[DASHBOARD] CONFIRMED_KPI_SOURCE_STROBBO';
export const DASHBOARD__CONFIRMED_KPI_SOURCE_SUPERPLANNER = '[DASHBOARD] CONFIRMED_KPI_SOURCE_SUPERPLANNER';
export const DASHBOARD__CONFIRMED_KPI_SOURCE_SHYFTER = '[DASHBOARD] CONFIRMED_KPI_SOURCE_SHYFTER';
export const DASHBOARD__GO_TO_WIZARD = '[DASHBOARD] GO_TO_WIZARD';
export const DASHBOARD__KPI_FETCH_ERROR = '[DASHBOARD] KPI_FETCH_ERROR';

// payroll-settings
export const PAYROLL_SETTINGS__PARITAIR_COMITE = '[PAYROLL_SETTINGS] PAIRTAIR_COMITE';
export const PAYROLL_SETTINGS__WAGE_COMPONENTS = '[PAYROLL_SETTINGS] WAGE_COMPONENTS';
export const WAGE_COMPONENTS__SERVICE_CODES = '[WAGE_COMPONENTS] SERVICE_CODES';
export const WAGE_COMPONENTS__COST_DECLARATION = '[WAGE_COMPONENTS] COST_DECLARATION';
export const WAGE_COMPONENTS__COST_DECLARATIONS = '[WAGE_COMPONENTS] COST_DECLARATIONS';
export const WAGE_COMPONENTS__COST_DECLARATION_HEADER = '[WAGE_COMPONENTS] COST_DECLARATION_HEADER';
export const WAGE_COMPONENTS__COST_DECLARATION_NAME = '[WAGE_COMPONENTS] COST_DECLARATION_NAME';
export const WAGE_COMPONENTS__COST_DECLARATION_ADD = '[WAGE_COMPONENTS] COST_DECLARATION_ADD';
export const WAGE_COMPONENTS__COST_DECLARATION_EDIT = '[WAGE_COMPONENTS] COST_DECLARATION_EDIT';

export const WAGE_COMPONENTS__COST_DECLARATION_CHANGE_ACTIV_STATUS =
  '[WAGE_COMPONENTS] COST_DECLARATION_CHANGE_ACTIV_STATUS';
export const WAGE_COMPONENTS__COST_DECLARATION_FOR_ALL_PC = '[WAGE_COMPONENTS] COST_DECLARATION_FOR_ALL_PC';
export const WAGE_COMPONENTS__COST_DECLARATION_FOR_NO_PC = '[WAGE_COMPONENTS] COST_DECLARATION_FOR_NO_PC';

export const WAGE_COMPONENTS__NIGHT_SHIFT = '[WAGE_COMPONENTS] NIGHT_SHIFT';
export const WAGE_COMPONENTS__OVERTIME = '[WAGE_COMPONENTS] OVERTIME';
export const WAGE_COMPONENTS__HOLIDAY = '[WAGE_COMPONENTS] HOLIDAY';
export const WAGE_COMPONENTS__STARTS_FROM = '[WAGE_COMPONENTS] STARTS_FROM';
export const WAGE_COMPONENTS__ENDS_AT = '[WAGE_COMPONENTS] ENDS_AT';
export const WAGE_COMPONENTS__OUTCOME = '[WAGE_COMPONENTS] OUTCOME';
export const WAGE_COMPONENTS__CODE = '[WAGE_COMPONENTS] CODE';
export const WAGE_COMPONENTS__DESCRIPTION = '[WAGE_COMPONENTS] DESCRIPTION';
export const WAGE_COMPONENTS__WORK_HOURS_WEEKDAY = '[WAGE_COMPONENTS] WORK_HOURS_WEEKDAY';
export const WAGE_COMPONENTS__WORK_HOURS_SATURDAY = '[WAGE_COMPONENTS] WORK_HOURS_SATURDAY';
export const WAGE_COMPONENTS__WORK_HOURS_SUNDAY = '[WAGE_COMPONENTS] WORK_HOURS_SUNDAY';
export const WAGE_COMPONENTS__OVERTIME_WEEKDAY = '[WAGE_COMPONENTS] OVERTIME_WEEKDAY';
export const WAGE_COMPONENTS__OVERTIME_SATURDAY = '[WAGE_COMPONENTS] OVERTIME_SATURDAY';
export const WAGE_COMPONENTS__OVERTIME_SUNDAY = '[WAGE_COMPONENTS] OVERTIME_SUNDAY';

// wage indexation
export const PAYROLL_SETTINGS__WAGE_INDEXATION = '[PAYROLL_SETTINGS] WAGE_INDEXATION';
export const WAGE_INDEXATION__INDEX_VALUE = '[WAGE_INDEXATION] INDEX_VALUE';
export const WAGE_INDEXATION__ORIGINAL_VALUES = '[WAGE_INDEXATION] ORIGINAL_VALUES';
export const WAGE_INDEXATION__NEW_VALUES = '[WAGE_INDEXATION] NEW_VALUES';
export const WAGE_INDEXATION__COMPANY_DETAILS = '[WAGE_INDEXATION] COMPANY_DETAILS';
export const WAGE_INDEXATION__COMPANY_WITH_EXCEPTIONS = '[WAGE_INDEXATION] COMPANY_WITH_EXCEPTIONS';
export const WAGE_INDEXATION__ALL_AFFECTED_COMPANIES = '[WAGE_INDEXATION] ALL_AFFECTED_COMPANIES';
export const WAGE_INDEXATION__EXCEPTION_TYPE = '[WAGE_INDEXATION] EXCEPTION_TYPE';
export const WAGE_INDEXATION__CURRENT_WAGE = '[WAGE_INDEXATION] CURRENT_WAGE';
export const WAGE_INDEXATION__NEW_WAGE = '[WAGE_INDEXATION] NEW_WAGE';
export const WAGE_INDEXATION__MINIMUM_WAGE_INDEXATION = '[WAGE_INDEXATION] MINIMUM_WAGE_INDEXATION';
export const WAGE_INDEXATION__INDEXATION_SOURCE = '[WAGE_INDEXATION] INDEXATION_SOURCE';
export const WAGE_INDEXATION__AFFECTED_CONTRACTS_COUNT = '[WAGE_INDEXATION] AFFECTED_CONTRACTS_COUNT';
export const WAGE_INDEXATION__SHOULD_INDEX = '[WAGE_INDEXATION] SHOULD_INDEX';
export const WAGE_INDEXATION__PREVIOUS_STEP = '[WAGE_INDEXATION] PREVIOUS_STEP';
export const WAGE_INDEXATION__NEXT_STEP = '[WAGE_INDEXATION] NEXT_STEP';
export const WAGE_INDEXATION__CONFIRM_BEFORE_SAVE_MESSAGE = '[WAGE_INDEXATION] CONFIRM_BEFORE_SAVE_MESSAGE';
export const WAGE_INDEXATION__SAVE_INDEXATION = '[WAGE_INDEXATION] SAVE_INDEXATION';
export const WAGE_INDEXATION__CONFIRM_INDEXATION = '[WAGE_INDEXATION] CONFIRM_INDEXATION';
export const WAGE_INDEXATION__VALID_FROM = '[WAGE_INDEXATION] VALID_FROM';
export const WAGE_INDEXATION__VALID_TO = '[WAGE_INDEXATION] VALID_TO';
export const WAGE_INDEXATION__PERFORMED = '[WAGE_INDEXATION] PERFORMED';

// reporting
export const REPORTING__WEEKLY_CONTRACT_COUNT = '[REPORTING] WEEKLY_CONTRACT_COUNT';
export const REPORTING__GENERAL_STATISTICS = '[REPORTING] GENERAL_STATISTICS';
export const REPORTING__REQUIRED_ACTIONS = '[REPORTING] REQUIRED_ACTIONS';
export const REPORTING__CONFIRMED_CONTRACTS_ONLY = '[REPORTING] CONFIRMED_CONTRACTS_ONLY';
export const REPORTING__NOSHOW_CONTRACTS_ONLY = '[REPORTING] NOSHOW_CONTRACTS_ONLY';
export const REPORTING__PAYROLL_OFFICER = '[REPORTING] PAYROLL_OFFICER';
export const REPORTING__TOTAL_CONTRACT_HOURS = '[REPORTING] TOTAL_CONTRACT_HOURS';
export const REPORTING__CLIENT_PERFORMANCE_REPORT = '[REPORTING] CLIENT_PERFORMANCE_REPORT';
export const REPORTING__STATISTICS_PER_COST_CENTER = '[REPORTING] STATISTICS_PER_COST_CENTER';
export const REPORTING__FTE_CHECK = '[REPORTING] FTE_CHECK';
export const REPORTING__HOUR_TYPES = '[REPORTING] HOUR_TYPES';
export const REPORTING_CURRENT_MONTH_HOURS = '[REPORTING] CURRENT_MONTH_HOURS';
export const REPORTING__PAST_MONTH_HOURS = '[REPORTING] PAST_MONTH_HOURS';
export const REPORTING__PAST_YEAR_SELECTED_MONTH_HOURS = '[REPORTING] PAST_YEAR_SELECTED_MONTH_HOURS';
export const REPORTING__PLANNED_HOURS = '[REPORTING] PLANNED_HOURS';
export const REPORTING__WORKED_HOURS = '[REPORTING] WORKED_HOURS';
export const REPORTING__NOSHOW_HOURS = '[REPORTING] NOSHOW_HOURS';
export const REPORTING__CONTRACTED_COST = '[REPORTING] CONTRACTED_COST';
export const REPORTING__WORKED_COST = '[REPORTING] WORKED_COST';
export const REPORTING__DOCUMENT_FOLLOW_UP = '[REPORTING] DOCUMENT_FOLLOW_UP';
export const REPORTING__DOCUMENT_FOLLOW_UP_HAS = '[REPORTING] DOCUMENT_FOLLOW_UP_HAS';
export const REPORTING__DOCUMENT_FOLLOW_UP_MISSING = '[REPORTING] DOCUMENT_FOLLOW_UP_MISSING';
export const REPORTING__DOCUMENT_FOLLOW_UP_STATUS = '[REPORTING] DOCUMENT_FOLLOW_UP_STATUS';
export const REPORTING__DOCUMENT_VALIDITY_START = '[REPORTING] DOCUMENT_VALIDITY_START';
export const REPORTING__DOCUMENT_VALIDITY_END = '[REPORTING] DOCUMENT_VALIDITY_END';
export const REPORTING__UPLOADED_DATE = '[REPORTING] UPLOADED_DATE';
export const REPORTING__UPLOADED_BY = '[REPORTING] UPLOADED_BY';
export const REPORTING__DOCUMENT_FOLLOW_UP_COMPANY_REQUIRED = '[REPORTING] DOCUMENT_FOLLOW_UP_COMPANY_REQUIRED';
export const REPORTING__DOCUMENT_FOLLOW_UP_CATEGORY_REQUIRED = '[REPORTING] DOCUMENT_FOLLOW_UP_CATEGORY_REQUIRED';
export const REPORTING__DOCUMENT_FOLLOW_UP_DATE_REQUIRED = '[REPORTING] DOCUMENT_FOLLOW_UP_DATE_REQUIRED';
export const REPORTING__DOCUMENT_FOLLOW_UP_MAX_COMPANIES = '[REPORTING] DOCUMENT_FOLLOW_UP_MAX_COMPANIES';
export const REPORTING__DOCUMENT_FOLLOW_UP_NO_EMPLOYEES = '[REPORTING] DOCUMENT_FOLLOW_UP_NO_EMPLOYEES';
export const REPORTING__GENERATE_FAILED = '[REPORTING] GENERATE_FAILED';

// permissions
export const PERMISSIONS_SHOW_WAGES = '[PERMISSIONS] SHOW_WAGES';
export const PERMISSIONS_HIDE_WAGES = '[PERMISSIONS] HIDE_WAGES';

// days

export const DAYS__SHORT_MONDAY = '[DAYS] MONDAY';
export const DAYS__SHORT_TUESDAY = '[DAYS] TUESDAY';
export const DAYS__SHORT_WEDNESDAY = '[DAYS] WEDNESDAY';
export const DAYS__SHORT_THURSDAY = '[DAYS] THURSDAY';
export const DAYS__SHORT_FRIDAY = '[DAYS] FRIDAY';
export const DAYS__SHORT_SATURDAY = '[DAYS] SATURDAY';
export const DAYS__SHORT_SUNDAY = '[DAYS] SUNDAY';

// onboarding flow
export const ONBOARDING__COMPANY_STEP = '[ONBOARDING] COMPANY_STEP';
export const ONBOARDING__ADDRESS_STEP = '[ONBOARDING] ADDRESS_STEP';
export const ONBOARDING__CONTACT_STEP = '[ONBOARDING] CONTACT_STEP';
export const ONBOARDING__ACCOUNT_STEP = '[ONBOARDING] ACCOUNT_STEP';
export const ONBOARDING__NEXT_STEP = '[ONBOARDING] NEXT_STEP';
export const ONBOARDING__PREVIOUS_STEP = '[ONBOARDING] PREVIOUS_STEP';
export const ONBOARDING__COMPLETE_ONBOARDING = '[ONBOARDING] COMPLETE_ONBOARDING';
export const ONBOARDING__COMPANY_NAME_PLACEHOLDER = '[ONBOARDING] COMPANY_NAME_PLACEHOLDER';
export const ONBOARDING__DIFFERENT_COMMERCIAL_NAME = '[ONBOARDING] DIFFERENT_COMMERCIAL_NAME';
export const ONBOARDING__COMMERCIAL_NAME_PLACEHOLDER = '[ONBOARDING] COMMERCIAL_NAME_PLACEHOLDER';
export const ONBOARDING__POST_BOX = '[ONBOARDING] POST_BOX';
export const ONBOARDING__PROCESS_ALREADY_FINISHED = '[ONBOARDING] PROCESS_ALREADY_FINISHED';
export const ONBOARDING__APPROVE_COLLABORATION_AGREEMENT = '[ONBOARDING] APPROVE_COLLABORATION_AGREEMENT';
export const ONBOARDING__COLLABORATION_AGREEMENT = '[ONBOARDING] COLLABORATION_AGREEMENT';
export const ONBOARDING__AWAITING_PAYROLL_CONFIRMATION_TEXT = '[ONBOARDING] AWAITING_PAYROLL_CONFIRMATION_TEXT';
export const ONBOARDING__SUBMIT_PAYROLL_INFO = '[ONBOARDING] SUBMIT_PAYROLL_INFO';
export const ONBOARDING__ADD_EMPLOYEES = '[ONBOARDING] ADD_EMPLOYEES';
export const ONBOARDING__CREATE_CONTRACTS = '[ONBOARDING] CREATE_CONTRACTS';
export const ONBOARDING__GETTING_STARTED = '[ONBOARDING] GETTING_STARTED';
export const ONBOARDING__OPEN_TASKS = '[ONBOARDING] OPEN_TASKS';
export const ONBOARDING__FUTURE_TASKS = '[ONBOARDING] FUTURE_TASKS';
export const ONBOARDING__ALREADY_STARTED_MESSAGE = '[ONBOARDING] ALREADY_STARTED_MESSAGE';
export const ONBOARDING__ONBOARDING = '[ONBOARDING] ONBOARDING';
export const ONBOARDING__READY_FOR_MARKUP = '[ONBOARDING] READY_FOR_MARKUP';
export const ONBOARDING__AWAITING_APPROVAL = '[ONBOARDING] AWAITING_APPROVAL';

// password strength
export const PASSWORD_STRENGTH__MIN_LENGTH_ERROR = '[PASSWORD_STRENGTH] MIN_LENGTH_ERROR';
export const PASSWORD_STRENGTH__SPECIAL_CHAR_ERROR = '[PASSWORD_STRENGTH] SPECIAL_CHAR_ERROR';
export const PASSWORD_STRENGTH__NUMBER_ERROR = '[PASSWORD_STRENGTH] NUMBER_ERROR';
export const PASSWORD_STRENGTH__UPPERCASE_WARNING = '[PASSWORD_STRENGTH] UPPERCASE_WARNING';
export const PASSWORD_STRENGTH__LOWERCASE_WARNING = '[PASSWORD_STRENGTH] LOWERCASE_WARNING';
export const PASSWORD_STRENGTH__STRONG_PASSWORD = '[PASSWORD_STRENGTH] STRONG_PASSWORD';
export const PASSWORD_STRENGTH__PASSWORDS_MATCH = '[PASSWORD_STRENGTH] PASSWORDS_MATCH';
export const PASSWORD_STRENGTH__PASSWORDS_NOT_MATCH = '[PASSWORD_STRENGTH] PASSWORDS_NOT_MATCH';

// translations
export const TRANSLATIONS__LANGUAGE_CODE = '[TRANSLATIONS] LANGUAGE_CODE';
export const TRANSLATIONS__DUTCH = '[TRANSLATIONS] DUTCH';
export const TRANSLATIONS__FRENCH = '[TRANSLATIONS] FRENCH';
export const TRANSLATIONS__ENGLISH = '[TRANSLATIONS] ENGLISH';
export const TRANSLATIONS__ADD_NEW = '[TRANSLATIONS] ADD_NEW';
export const TRANSLATIONS__CONFIRM_DELETE = '[TRANSLATIONS] CONFIRM_DELETE';

// employee app page
export const EMPLOYEES_APP__TITLE = '[EMPLOYEES_APP] TITLE';
export const EMPLOYEES_APP__SELLING_POINT = '[EMPLOYEES_APP] SELLING_POINT';
export const EMPLOYEES_APP__GO_TO_APP_STORE = '[EMPLOYEES_APP] GO_TO_APP_STORE';
export const EMPLOYEES_APP__GO_TO_WEB_ONBOARDING = '[EMPLOYEES_APP] GO_TO_WEB_ONBOARDING';

// existing employee onboarding
export const EXISTING_EMPLOYEE_ONBOARDING__LOGIN_CONFIRM = '[EXISTING_EMPLOYEE_ONBOARDING] LOGIN_CONFIRM';
export const EXISTING_EMPLOYEE_ONBOARDING__LOGIN_ERROR = '[EXISTING_EMPLOYEE_ONBOARDING] LOGIN_ERROR';
export const EXISTING_EMPLOYEE_ONBOARDING__LOGIN_TITLE = '[EXISTING_EMPLOYEE_ONBOARDING] LOGIN_TITLE';
export const EXISTING_EMPLOYEE_ONBOARDING__LOGIN_SUBTITLE = '[EXISTING_EMPLOYEE_ONBOARDING] LOGIN_SUBTITLE';
export const EXISTING_EMPLOYEE_ONBOARDING__EMAIL = '[EXISTING_EMPLOYEE_ONBOARDING] EMAIL';
export const EXISTING_EMPLOYEE_ONBOARDING__EMAIL_PLACEHOLDER = '[EXISTING_EMPLOYEE_ONBOARDING] EMAIL_PLACEHOLDER';
export const EXISTING_EMPLOYEE_ONBOARDING__INSS = '[EXISTING_EMPLOYEE_ONBOARDING] INSS';
export const EXISTING_EMPLOYEE_ONBOARDING__INSS_PLACEHOLDER = '[EXISTING_EMPLOYEE_ONBOARDING] INSS_PLACEHOLDER';
export const EXISTING_EMPLOYEE_ONBOARDING__EXISTING_PASSWORD = '[EXISTING_EMPLOYEE_ONBOARDING] EXISTING_PASSWORD';
export const EXISTING_EMPLOYEE_ONBOARDING__EXISTING_PASSWORD_PLACEHOLDER =
  '[EXISTING_EMPLOYEE_ONBOARDING] EXISTING_PASSWORD_PLACEHOLDER';
export const EXISTING_EMPLOYEE_ONBOARDING__LOGIN_EXISTING_PASSWORD = '[EXISTING_EMPLOYEE_ONBOARDING] EXISTING_PASSWORD';
export const EXISTING_EMPLOYEE_ONBOARDING__LOGIN_EXISTING_PASSWORD_PLACEHOLDER =
  '[EXISTING_EMPLOYEE_ONBOARDING] EXISTING_PASSWORD_PLACEHOLDER';

// set password app page
export const SET_PASSWORD_APP__SELLING_POINT = '[SET_PASSWORD_APP] SELLING_POINT';
export const SET_PASSWORD_APP__GO_TO_APP_STORE = '[SET_PASSWORD_APP] GO_TO_APP_STORE';
export const WE_HAVE_AN_APP__CONTINUE_ON_WEB = '[WE_HAVE_AN_APP] CONTINUE_ON_WEB';

// audit logs
export const AUDITING__VIEW_HISTORY = '[AUDITING] VIEW_HISTORY';
export const AUDITING__NO_ITEMS_FOUND = '[AUDITING] NO_ITEMS_FOUND';
export const AUDITING__USER_MODIFIED = '[AUDITING] USER_MODIFIED';
export const AUDITING__USER_CREATED = '[AUDITING] USER_CREATED';
export const AUDITING__TABLE_HEADER_NAME = '[AUDITING] TABLE_HEADER_NAME';
export const AUDITING__TABLE_HEADER_DATE = '[AUDITING] TABLE_HEADER_DATE';
export const AUDITING__TABLE_HEADER_CHANGELOG = '[AUDITING] TABLE_HEADER_CHANGELOG';
export const AUDITING__FIELD_NAME = '[AUDITING] FIELD_NAME';
export const AUDITING__FIELD_OLD_VALUE = '[AUDITING] FIELD_OLD_VALUE';
export const AUDITING__FIELD_NEW_VALUE = '[AUDITING] FIELD_NEW_VALUE';

export const TIME_REGISTRATION__IN_PROGRESS = '[TIME_REGISTRATION] IN_PROGRESS';
export const TIME_REGISTRATION__COMPLETED = '[TIME_REGISTRATION] COMPLETED';
export const TIME_REGISTRATION__SUBMITTED = '[TIME_REGISTRATION] SUBMITTED';
export const TIME_REGISTRATION__FROZEN = '[TIME_REGISTRATION] FROZEN';
export const TIME_REGISTRATION__CONFIRMED = '[TIME_REGISTRATION] CONFIRMED';
export const TIME_REGISTRATION__ARCHIVED = '[TIME_REGISTRATION] ARCHIVED';

// time registration settings (company UI)
export const TIME_REGISTRATION_SETTINGS__TAB_TITLE = '[TIME_REGISTRATION_SETTINGS] TAB_TITLE';
export const TIME_REGISTRATION_SETTINGS__GENERAL_SECTION = '[TIME_REGISTRATION_SETTINGS] GENERAL_SECTION';
export const TIME_REGISTRATION_SETTINGS__STARTING_SECTION = '[TIME_REGISTRATION_SETTINGS] STARTING_SECTION';
export const TIME_REGISTRATION_SETTINGS__BREAKS_SECTION = '[TIME_REGISTRATION_SETTINGS] BREAKS_SECTION';
export const TIME_REGISTRATION_SETTINGS__PROCESSING_SECTION = '[TIME_REGISTRATION_SETTINGS] PROCESSING_SECTION';
export const TIME_REGISTRATION_SETTINGS__LOCATION_SECTION = '[TIME_REGISTRATION_SETTINGS] LOCATION_SECTION';

export const TIME_REGISTRATION_SETTINGS__ACTIVE = '[TIME_REGISTRATION_SETTINGS] ACTIVE';
export const TIME_REGISTRATION_SETTINGS__ACTIVE_HELPER = '[TIME_REGISTRATION_SETTINGS] ACTIVE_HELPER';
export const TIME_REGISTRATION_SETTINGS__SUPER_ADMIN_ONLY = '[TIME_REGISTRATION_SETTINGS] SUPER_ADMIN_ONLY';

export const TIME_REGISTRATION_SETTINGS__ALLOW_EMPLOYEE_EDIT = '[TIME_REGISTRATION_SETTINGS] ALLOW_EMPLOYEE_EDIT';
export const TIME_REGISTRATION_SETTINGS__ALLOW_EMPLOYEE_EDIT_HELPER =
  '[TIME_REGISTRATION_SETTINGS] ALLOW_EMPLOYEE_EDIT_HELPER';
export const TIME_REGISTRATION_SETTINGS__ALLOW_BEFORE_PLANNED_START =
  '[TIME_REGISTRATION_SETTINGS] ALLOW_BEFORE_PLANNED_START';
export const TIME_REGISTRATION_SETTINGS__ALLOW_BEFORE_PLANNED_START_HELPER =
  '[TIME_REGISTRATION_SETTINGS] ALLOW_BEFORE_PLANNED_START_HELPER';
export const TIME_REGISTRATION_SETTINGS__ALLOW_START_IN_FUTURE = '[TIME_REGISTRATION_SETTINGS] ALLOW_START_IN_FUTURE';
export const TIME_REGISTRATION_SETTINGS__ALLOW_START_IN_FUTURE_HELPER =
  '[TIME_REGISTRATION_SETTINGS] ALLOW_START_IN_FUTURE_HELPER';
export const TIME_REGISTRATION_SETTINGS__REGISTRATION_WINDOW_BEFORE =
  '[TIME_REGISTRATION_SETTINGS] REGISTRATION_WINDOW_BEFORE';
export const TIME_REGISTRATION_SETTINGS__REGISTRATION_WINDOW_AFTER =
  '[TIME_REGISTRATION_SETTINGS] REGISTRATION_WINDOW_AFTER';
export const TIME_REGISTRATION_SETTINGS__EXTENDED_WINDOW_BEFORE = '[TIME_REGISTRATION_SETTINGS] EXTENDED_WINDOW_BEFORE';
export const TIME_REGISTRATION_SETTINGS__EXTENDED_WINDOW_AFTER = '[TIME_REGISTRATION_SETTINGS] EXTENDED_WINDOW_AFTER';

export const TIME_REGISTRATION_SETTINGS__MAXIMUM_NUMBER_OF_BREAKS =
  '[TIME_REGISTRATION_SETTINGS] MAXIMUM_NUMBER_OF_BREAKS';
export const TIME_REGISTRATION_SETTINGS__BREAK_ROUNDING = '[TIME_REGISTRATION_SETTINGS] BREAK_ROUNDING';
export const TIME_REGISTRATION_SETTINGS__BREAK_ROUNDING_HELPER = '[TIME_REGISTRATION_SETTINGS] BREAK_ROUNDING_HELPER';
export const TIME_REGISTRATION_SETTINGS__BREAK_ROUNDING_RULES = '[TIME_REGISTRATION_SETTINGS] BREAK_ROUNDING_RULES';
export const TIME_REGISTRATION_SETTINGS__BREAK_START_INTERVAL = '[TIME_REGISTRATION_SETTINGS] BREAK_START_INTERVAL';
export const TIME_REGISTRATION_SETTINGS__BREAK_START_DIRECTION = '[TIME_REGISTRATION_SETTINGS] BREAK_START_DIRECTION';
export const TIME_REGISTRATION_SETTINGS__BREAK_END_INTERVAL = '[TIME_REGISTRATION_SETTINGS] BREAK_END_INTERVAL';
export const TIME_REGISTRATION_SETTINGS__BREAK_END_DIRECTION = '[TIME_REGISTRATION_SETTINGS] BREAK_END_DIRECTION';

export const TIME_REGISTRATION_SETTINGS__START_END_ROUNDING = '[TIME_REGISTRATION_SETTINGS] START_END_ROUNDING';
export const TIME_REGISTRATION_SETTINGS__START_END_ROUNDING_HELPER =
  '[TIME_REGISTRATION_SETTINGS] START_END_ROUNDING_HELPER';
export const TIME_REGISTRATION_SETTINGS__START_END_ROUNDING_RULES =
  '[TIME_REGISTRATION_SETTINGS] START_END_ROUNDING_RULES';
export const TIME_REGISTRATION_SETTINGS__START_INTERVAL = '[TIME_REGISTRATION_SETTINGS] START_INTERVAL';
export const TIME_REGISTRATION_SETTINGS__START_DIRECTION = '[TIME_REGISTRATION_SETTINGS] START_DIRECTION';
export const TIME_REGISTRATION_SETTINGS__END_INTERVAL = '[TIME_REGISTRATION_SETTINGS] END_INTERVAL';
export const TIME_REGISTRATION_SETTINGS__END_DIRECTION = '[TIME_REGISTRATION_SETTINGS] END_DIRECTION';

export const TIME_REGISTRATION_SETTINGS__OVERWORK_LIMIT = '[TIME_REGISTRATION_SETTINGS] OVERWORK_LIMIT';
export const TIME_REGISTRATION_SETTINGS__OVERWORK_LIMIT_HELPER = '[TIME_REGISTRATION_SETTINGS] OVERWORK_LIMIT_HELPER';
export const TIME_REGISTRATION_SETTINGS__OVERWORK_RULES = '[TIME_REGISTRATION_SETTINGS] OVERWORK_RULES';
export const TIME_REGISTRATION_SETTINGS__MAX_OVERWORK = '[TIME_REGISTRATION_SETTINGS] MAX_OVERWORK';
export const TIME_REGISTRATION_SETTINGS__AUTO_FREEZE = '[TIME_REGISTRATION_SETTINGS] AUTO_FREEZE';
export const TIME_REGISTRATION_SETTINGS__AUTO_FREEZE_HELPER = '[TIME_REGISTRATION_SETTINGS] AUTO_FREEZE_HELPER';

export const TIME_REGISTRATION_SETTINGS__LOCATION_REQUIRED = '[TIME_REGISTRATION_SETTINGS] LOCATION_REQUIRED';
export const TIME_REGISTRATION_SETTINGS__LOCATION_REQUIRED_HELPER =
  '[TIME_REGISTRATION_SETTINGS] LOCATION_REQUIRED_HELPER';
export const TIME_REGISTRATION_SETTINGS__ON_SITE_RADIUS = '[TIME_REGISTRATION_SETTINGS] ON_SITE_RADIUS';
export const TIME_REGISTRATION_SETTINGS__COST_CENTERS_MISSING_COORDINATES =
  '[TIME_REGISTRATION_SETTINGS] COST_CENTERS_MISSING_COORDINATES';

export const TIME_REGISTRATION_SETTINGS__ROUND_UP = '[TIME_REGISTRATION_SETTINGS] ROUND_UP';
export const TIME_REGISTRATION_SETTINGS__ROUND_DOWN = '[TIME_REGISTRATION_SETTINGS] ROUND_DOWN';
export const TIME_REGISTRATION_SETTINGS__MINUTES_UNIT = '[TIME_REGISTRATION_SETTINGS] MINUTES_UNIT';
export const TIME_REGISTRATION_SETTINGS__METERS_UNIT = '[TIME_REGISTRATION_SETTINGS] METERS_UNIT';

export const TIME_REGISTRATION_SETTINGS__SAVE_SUCCESS = '[TIME_REGISTRATION_SETTINGS] SAVE_SUCCESS';
export const TIME_REGISTRATION_SETTINGS__CONFLICT = '[TIME_REGISTRATION_SETTINGS] CONFLICT';
export const TIME_REGISTRATION_SETTINGS__RELOAD = '[TIME_REGISTRATION_SETTINGS] RELOAD';
export const TIME_REGISTRATION_SETTINGS__INVALID_INTERVAL = '[TIME_REGISTRATION_SETTINGS] INVALID_INTERVAL';
export const TIME_REGISTRATION_SETTINGS__INVALID_NUMBER = '[TIME_REGISTRATION_SETTINGS] INVALID_NUMBER';
export const TIME_REGISTRATION_SETTINGS__INVALID_RADIUS = '[TIME_REGISTRATION_SETTINGS] INVALID_RADIUS';
export const TIME_REGISTRATION__SETTING_NOT_OVERRULABLE = '[TIME_REGISTRATION] SETTING_NOT_OVERRULABLE';

// kiosk settings
export const KIOSK_SETTINGS__SECTION = '[KIOSK_SETTINGS] SECTION';
export const KIOSK_SETTINGS__COMPANY_DEFAULT_TITLE = '[KIOSK_SETTINGS] COMPANY_DEFAULT_TITLE';
export const KIOSK_SETTINGS__PER_LOCATION_TITLE = '[KIOSK_SETTINGS] PER_LOCATION_TITLE';
export const KIOSK_SETTINGS__AUTH_MODE_LABEL = '[KIOSK_SETTINGS] AUTH_MODE_LABEL';
export const KIOSK_SETTINGS__AUTH_MODE_OPEN_LIST = '[KIOSK_SETTINGS] AUTH_MODE_OPEN_LIST';
export const KIOSK_SETTINGS__AUTH_MODE_PIN = '[KIOSK_SETTINGS] AUTH_MODE_PIN';
export const KIOSK_SETTINGS__AUTH_MODE_PIN_PLUS_APPROVAL = '[KIOSK_SETTINGS] AUTH_MODE_PIN_PLUS_APPROVAL';
export const KIOSK_SETTINGS__PERSONAL_DEVICE_BLOCK = '[KIOSK_SETTINGS] PERSONAL_DEVICE_BLOCK';
export const KIOSK_SETTINGS__PERSONAL_DEVICE_BLOCK_HELPER = '[KIOSK_SETTINGS] PERSONAL_DEVICE_BLOCK_HELPER';
export const KIOSK_SETTINGS__BADGE_INHERITS = '[KIOSK_SETTINGS] BADGE_INHERITS';
export const KIOSK_SETTINGS__BADGE_OVERRIDE = '[KIOSK_SETTINGS] BADGE_OVERRIDE';
export const KIOSK_SETTINGS__REVERT_BUTTON = '[KIOSK_SETTINGS] REVERT_BUTTON';
export const KIOSK_SETTINGS__SAVE_SUCCESS = '[KIOSK_SETTINGS] SAVE_SUCCESS';
export const KIOSK_SETTINGS__CONFIGURATION_MISSING = '[KIOSK_SETTINGS] CONFIGURATION_MISSING';
// Kiosk mode
export const MENU__KIOSK_MODE = '[MENU] KIOSK_MODE';

export const KIOSK__ACTIVATION_TITLE = '[KIOSK] ACTIVATION_TITLE';
export const KIOSK__ACTIVATION_SUBTITLE = '[KIOSK] ACTIVATION_SUBTITLE';
export const KIOSK__NAME_LABEL = '[KIOSK] NAME_LABEL';
export const KIOSK__NAME_PLACEHOLDER = '[KIOSK] NAME_PLACEHOLDER';
export const KIOSK__LOCATION_LABEL = '[KIOSK] LOCATION_LABEL';
export const KIOSK__LOCATION_PLACEHOLDER = '[KIOSK] LOCATION_PLACEHOLDER';
export const KIOSK__COST_CENTRE_LABEL = '[KIOSK] COST_CENTRE_LABEL';
export const KIOSK__COST_CENTRE_PLACEHOLDER = '[KIOSK] COST_CENTRE_PLACEHOLDER';
export const KIOSK__COST_CENTRE_HINT = '[KIOSK] COST_CENTRE_HINT';
export const KIOSK__ACTIVATE_BUTTON = '[KIOSK] ACTIVATE_BUTTON';
export const KIOSK__NO_LOCATIONS = '[KIOSK] NO_LOCATIONS';

export const KIOSK__SHELL_ACTIVE_TITLE = '[KIOSK] SHELL_ACTIVE_TITLE';
export const KIOSK__SHELL_ACTIVE_SUBTITLE = '[KIOSK] SHELL_ACTIVE_SUBTITLE';
export const KIOSK__SHELL_LOCATION_LABEL = '[KIOSK] SHELL_LOCATION_LABEL';
export const KIOSK__SHELL_COST_CENTRE_LABEL = '[KIOSK] SHELL_COST_CENTRE_LABEL';
export const KIOSK__EXIT_BUTTON = '[KIOSK] EXIT_BUTTON';
export const KIOSK__OFFLINE_MESSAGE = '[KIOSK] OFFLINE_MESSAGE';
export const KIOSK__MAINTENANCE_MESSAGE = '[KIOSK] MAINTENANCE_MESSAGE';

export const KIOSK__DEACTIVATE_TITLE = '[KIOSK] DEACTIVATE_TITLE';
export const KIOSK__DEACTIVATE_SUBTITLE = '[KIOSK] DEACTIVATE_SUBTITLE';
export const KIOSK__DEACTIVATE_EMAIL_LABEL = '[KIOSK] DEACTIVATE_EMAIL_LABEL';
export const KIOSK__DEACTIVATE_PASSWORD_LABEL = '[KIOSK] DEACTIVATE_PASSWORD_LABEL';
export const KIOSK__DEACTIVATE_BUTTON = '[KIOSK] DEACTIVATE_BUTTON';

// kiosk selection screen (US 7346) — values added later after manager sign-off
export const KIOSK__SELECTION_GREETING_MORNING = '[KIOSK] SELECTION_GREETING_MORNING';
export const KIOSK__SELECTION_GREETING_AFTERNOON = '[KIOSK] SELECTION_GREETING_AFTERNOON';
export const KIOSK__SELECTION_GREETING_EVENING = '[KIOSK] SELECTION_GREETING_EVENING';
export const KIOSK__SELECTION_SECTION_ACTIVE = '[KIOSK] SELECTION_SECTION_ACTIVE';
export const KIOSK__SELECTION_SECTION_PLANNED = '[KIOSK] SELECTION_SECTION_PLANNED';
export const KIOSK__SELECTION_SECTION_OTHER = '[KIOSK] SELECTION_SECTION_OTHER';
export const KIOSK__SELECTION_MATCH_COUNT = '[KIOSK] SELECTION_MATCH_COUNT';
export const KIOSK__SELECTION_EMPTY_NO_EMPLOYEES = '[KIOSK] SELECTION_EMPTY_NO_EMPLOYEES';
export const KIOSK__SELECTION_EMPTY_NO_MATCH = '[KIOSK] SELECTION_EMPTY_NO_MATCH';
export const KIOSK__SELECTION_ERROR = '[KIOSK] SELECTION_ERROR';
export const KIOSK__SELECTION_RELOAD = '[KIOSK] SELECTION_RELOAD';
export const KIOSK__SELECTION_EXIT = '[KIOSK] SELECTION_EXIT';
export const KIOSK__LANGUAGE_SELECTOR = '[KIOSK] LANGUAGE_SELECTOR';

// kiosk start-work / clock-in modal (US 7386a) — values added later after manager sign-off
export const KIOSK__START_REGISTRATION_TITLE = '[KIOSK] START_REGISTRATION_TITLE';
export const KIOSK__START_REGISTRATION_PLANNING_LABEL = '[KIOSK] START_REGISTRATION_PLANNING_LABEL';
export const KIOSK__START_REGISTRATION_DATE_LABEL = '[KIOSK] START_REGISTRATION_DATE_LABEL';
export const KIOSK__START_REGISTRATION_START_LABEL = '[KIOSK] START_REGISTRATION_START_LABEL';
export const KIOSK__START_REGISTRATION_END_LABEL = '[KIOSK] START_REGISTRATION_END_LABEL';
export const KIOSK__START_REGISTRATION_POLICIES_TITLE = '[KIOSK] START_REGISTRATION_POLICIES_TITLE';
export const KIOSK__START_REGISTRATION_POLICIES_INTRO = '[KIOSK] START_REGISTRATION_POLICIES_INTRO';
export const KIOSK__START_REGISTRATION_BUTTON = '[KIOSK] START_REGISTRATION_BUTTON';
export const KIOSK__START_REGISTRATION_BEFORE_PLANNED_START = '[KIOSK] START_REGISTRATION_BEFORE_PLANNED_START';
export const KIOSK__START_REGISTRATION_NO_ELIGIBLE_PLANNING = '[KIOSK] START_REGISTRATION_NO_ELIGIBLE_PLANNING';
export const KIOSK__CLOCK_IN_SUCCESS = '[KIOSK] CLOCK_IN_SUCCESS'; // interpolates {employeeName}
export const KIOSK__EMPLOYEE_UNAVAILABLE = '[KIOSK] EMPLOYEE_UNAVAILABLE';

// US 7347 — kiosk clock-out (end registration)
export const KIOSK__END_REGISTRATION_TITLE = '[KIOSK] END_REGISTRATION_TITLE';
export const KIOSK__END_REGISTRATION_BUTTON = '[KIOSK] END_REGISTRATION_BUTTON';
export const KIOSK__END_REGISTRATION_BREAKS_LABEL = '[KIOSK] END_REGISTRATION_BREAKS_LABEL';
export const KIOSK__END_REGISTRATION_BREAK_START_LABEL = '[KIOSK] END_REGISTRATION_BREAK_START_LABEL';
export const KIOSK__END_REGISTRATION_BREAK_END_LABEL = '[KIOSK] END_REGISTRATION_BREAK_END_LABEL';
export const KIOSK__END_REGISTRATION_ADD_BREAK = '[KIOSK] END_REGISTRATION_ADD_BREAK';
export const KIOSK__END_REGISTRATION_BREAKS_OVERLAP = '[KIOSK] END_REGISTRATION_BREAKS_OVERLAP';
export const KIOSK__END_REGISTRATION_MAX_BREAKS = '[KIOSK] END_REGISTRATION_MAX_BREAKS';
export const KIOSK__END_REGISTRATION_TOTAL_WORKED_LABEL = '[KIOSK] END_REGISTRATION_TOTAL_WORKED_LABEL';
export const KIOSK__END_REGISTRATION_DEVIATION_LABEL = '[KIOSK] END_REGISTRATION_DEVIATION_LABEL';
export const KIOSK__CLOCK_OUT_SUCCESS = '[KIOSK] CLOCK_OUT_SUCCESS'; // interpolates {workedHours}
export const KIOSK__CLOCK_OUT_ALREADY_ENDED = '[KIOSK] CLOCK_OUT_ALREADY_ENDED';

/* ── PIN entry panel (US 7344) ────────────────────────────────────────────── */
export const KIOSK__PIN_WELCOME = '[KIOSK] PIN_WELCOME'; // interpolates {name}
export const KIOSK__PIN_PROMPT = '[KIOSK] PIN_PROMPT';
export const KIOSK__PIN_INVALID = '[KIOSK] PIN_INVALID';
export const KIOSK__PIN_NOT_SET_TITLE = '[KIOSK] PIN_NOT_SET_TITLE';
export const KIOSK__PIN_NOT_SET_BODY = '[KIOSK] PIN_NOT_SET_BODY';
export const KIOSK__PIN_VERIFICATION_EXPIRED = '[KIOSK] PIN_VERIFICATION_EXPIRED';

// job applicant links
export const EMPLOYEES__CREATE_LINK = '[EMPLOYEE] CREATE_LINK';
export const EMPLOYEES__LINK_TYPE = '[EMPLOYEE] LINK_TYPE';
export const EMPLOYEES__LINK_TYPE_ONBOARDING = '[EMPLOYEE] LINK_TYPE_ONBOARDING';
export const EMPLOYEES__LINK_TYPE_APPLICATION = '[EMPLOYEE] LINK_TYPE_APPLICATION';
export const EMPLOYEES__APPLICATION_LINK_SAVED = '[EMPLOYEE] APPLICATION_LINK_SAVED';
export const GENERAL__TYPE = '[GENERAL] TYPE';

// job applicant link API error keys — values match ErrorResponse.error verbatim
export const JOB_APPLICANTS__BRANCH_REQUIRED = '[JOB_APPLICANTS] BRANCH_REQUIRED';
export const JOB_APPLICANTS__BRANCH_NOT_ACCESSIBLE = '[JOB_APPLICANTS] BRANCH_NOT_ACCESSIBLE';
export const JOB_APPLICANTS__LINK_NOT_FOUND = '[JOB_APPLICANTS] LINK_NOT_FOUND';
export const JOB_APPLICANTS__FEATURE_DISABLED = '[JOB_APPLICANTS] FEATURE_DISABLED';
export const JOB_APPLICANTS__COMPANY_NOT_FOUND = '[JOB_APPLICANTS] COMPANY_NOT_FOUND';

// public application form (US 7494) — applicant-facing copy
export const JOB_APPLICATION__FORM_TITLE = '[JOB_APPLICATION] FORM_TITLE';
export const JOB_APPLICATION__FORM_INTRO = '[JOB_APPLICATION] FORM_INTRO';
export const JOB_APPLICATION__PHONE = '[JOB_APPLICATION] PHONE';
export const JOB_APPLICATION__MOTIVATION = '[JOB_APPLICATION] MOTIVATION';
export const JOB_APPLICATION__MOTIVATION_PLACEHOLDER = '[JOB_APPLICATION] MOTIVATION_PLACEHOLDER';
export const JOB_APPLICATION__CV_LABEL = '[JOB_APPLICATION] CV_LABEL';
export const JOB_APPLICATION__CV_HINT = '[JOB_APPLICATION] CV_HINT';
export const JOB_APPLICATION__CV_TYPE_ERROR = '[JOB_APPLICATION] CV_TYPE_ERROR';
export const JOB_APPLICATION__CV_SIZE_ERROR = '[JOB_APPLICATION] CV_SIZE_ERROR';
export const JOB_APPLICATION__CV_PLACEHOLDER = '[JOB_APPLICATION] CV_PLACEHOLDER';
export const JOB_APPLICATION__PRIVACY_CONFIRM = '[JOB_APPLICATION] PRIVACY_CONFIRM';
export const JOB_APPLICATION__PRIVACY_TOOLTIP = '[JOB_APPLICATION] PRIVACY_TOOLTIP';
export const JOB_APPLICATION__PRIVACY_REQUIRED_ERROR = '[JOB_APPLICATION] PRIVACY_REQUIRED_ERROR';
export const JOB_APPLICATION__SUBMIT = '[JOB_APPLICATION] SUBMIT';
export const JOB_APPLICATION__SUCCESS_TITLE = '[JOB_APPLICATION] SUCCESS_TITLE';
export const JOB_APPLICATION__SUCCESS_BODY = '[JOB_APPLICATION] SUCCESS_BODY';
export const JOB_APPLICATION__LINK_INACTIVE_TITLE = '[JOB_APPLICATION] LINK_INACTIVE_TITLE';
export const JOB_APPLICATION__LINK_INACTIVE_BODY = '[JOB_APPLICATION] LINK_INACTIVE_BODY';
/** Bare 413 from the transport layer: no ErrorResponse body exists, so this key is ours alone. */
export const JOB_APPLICATION__REQUEST_TOO_LARGE = '[JOB_APPLICATION] REQUEST_TOO_LARGE';

// public application form API error keys — values match ErrorResponse.error verbatim
export const JOB_APPLICANTS__LINK_NOT_ACTIVE = '[JOB_APPLICANTS] LINK_NOT_ACTIVE';
export const JOB_APPLICANTS__DUPLICATE_APPLICATION = '[JOB_APPLICANTS] DUPLICATE_APPLICATION';
export const JOB_APPLICANTS__PRIVACY_STATEMENT_REQUIRED = '[JOB_APPLICANTS] PRIVACY_STATEMENT_REQUIRED';
export const JOB_APPLICANTS__CV_TYPE_NOT_ALLOWED = '[JOB_APPLICANTS] CV_TYPE_NOT_ALLOWED';
export const JOB_APPLICANTS__CV_TOO_LARGE = '[JOB_APPLICANTS] CV_TOO_LARGE';

// applicants in the employees overview (US 7495)
export const APPLICANTS__STATUS_SUBMITTED = '[APPLICANTS] STATUS_SUBMITTED';
export const APPLICANTS__STATUS_DISCARDED = '[APPLICANTS] STATUS_DISCARDED';
export const APPLICANTS__NO_APPLICANTS = '[APPLICANTS] NO_APPLICANTS';
export const APPLICANTS__LOAD_FAILED = '[APPLICANTS] LOAD_FAILED';
export const APPLICANTS__SUBMITTED_ON = '[APPLICANTS] SUBMITTED_ON';
export const APPLICANTS__SEARCH_APPLICANT_NAME = '[APPLICANTS] SEARCH_APPLICANT_NAME';

// applicant profile modal: discard / restore (US: Discard an applicant)
export const APPLICANTS__VIEW_APPLICANT = '[APPLICANTS] VIEW_APPLICANT';
export const APPLICANTS__MOTIVATIONAL_TEXT = '[APPLICANTS] MOTIVATIONAL_TEXT';
export const APPLICANTS__CV = '[APPLICANTS] CV';
export const APPLICANTS__VIEW_CV = '[APPLICANTS] VIEW_CV';
export const APPLICANTS__DISCARD_BUTTON = '[APPLICANTS] DISCARD_BUTTON';
export const APPLICANTS__RESTORE_BUTTON = '[APPLICANTS] RESTORE_BUTTON';
export const APPLICANTS__PROMOTE_BUTTON = '[APPLICANTS] PROMOTE_BUTTON';
export const APPLICANTS__DISCARD_CONFIRM_MESSAGE = '[APPLICANTS] DISCARD_CONFIRM_MESSAGE';
export const APPLICANTS__DETAIL_LOAD_FAILED = '[APPLICANTS] DETAIL_LOAD_FAILED';
export const APPLICANTS__CV_DOWNLOAD_FAILED = '[APPLICANTS] CV_DOWNLOAD_FAILED';
export const GENERAL__RETRY = '[GENERAL] RETRY';

// discard/restore API error keys — values match ErrorResponse.error verbatim
export const JOB_APPLICANTS__APPLICANT_NOT_FOUND = '[JOB_APPLICANTS] APPLICANT_NOT_FOUND';
export const JOB_APPLICANTS__APPLICANT_ALREADY_DISCARDED = '[JOB_APPLICANTS] APPLICANT_ALREADY_DISCARDED';
export const JOB_APPLICANTS__APPLICANT_ALREADY_PROMOTED = '[JOB_APPLICANTS] APPLICANT_ALREADY_PROMOTED';
export const JOB_APPLICANTS__APPLICANT_ALREADY_RESTORED = '[JOB_APPLICANTS] APPLICANT_ALREADY_RESTORED';
export const JOB_APPLICANTS__RESTORE_BLOCKED_DUPLICATE_APPLICATION =
  '[JOB_APPLICANTS] RESTORE_BLOCKED_DUPLICATE_APPLICATION';

// applicant profile modal: promote (US: Promote an applicant to employee onboarding)
export const APPLICANTS__EXISTING_EMPLOYEE_INDICATOR = '[APPLICANTS] EXISTING_EMPLOYEE_INDICATOR';
export const APPLICANTS__PROMOTE_SUCCESS_NEW_INVITATION = '[APPLICANTS] PROMOTE_SUCCESS_NEW_INVITATION';
export const APPLICANTS__PROMOTE_SUCCESS_INVITATION_REUSED = '[APPLICANTS] PROMOTE_SUCCESS_INVITATION_REUSED';
export const APPLICANTS__PROMOTE_SUCCESS_BRANCHES_APPENDED = '[APPLICANTS] PROMOTE_SUCCESS_BRANCHES_APPENDED';
export const APPLICANTS__PROMOTE_SUCCESS_PARTIAL_OVERLAP = '[APPLICANTS] PROMOTE_SUCCESS_PARTIAL_OVERLAP';

// promote / edit-branches API error keys — values match ErrorResponse.error verbatim
export const JOB_APPLICANTS__PROMOTE_BLOCKED_CONFLICTING_ROLE = '[JOB_APPLICANTS] PROMOTE_BLOCKED_CONFLICTING_ROLE';
export const JOB_APPLICANTS__PROMOTE_BLOCKED_DELETED_BRANCH = '[JOB_APPLICANTS] PROMOTE_BLOCKED_DELETED_BRANCH';
export const JOB_APPLICANTS__PROMOTE_BLOCKED_ALL_BRANCHES_ASSIGNED =
  '[JOB_APPLICANTS] PROMOTE_BLOCKED_ALL_BRANCHES_ASSIGNED';
export const JOB_APPLICANTS__APPLICANT_MODIFIED_CONCURRENTLY = '[JOB_APPLICANTS] APPLICANT_MODIFIED_CONCURRENTLY';

// management
export const MENU__MANAGEMENT = '[MENU] MANAGEMENT';
export const MANAGEMENT__CONFIGURATION_DOMAINS = '[MANAGEMENT] CONFIGURATION_DOMAINS';
export const MANAGEMENT__FEATURE_ACCESS = '[MANAGEMENT] FEATURE_ACCESS';
export const MANAGEMENT__TIME_REGISTRATION_POLICY = '[MANAGEMENT] TIME_REGISTRATION_POLICY';
export const MANAGEMENT__ABSENCE = '[MANAGEMENT] ABSENCE';
export const MANAGEMENT__JOINT_COMMISSIONS = '[MANAGEMENT] JOINT_COMMISSIONS';
export const MANAGEMENT__SECURITY_AUTHENTICATION = '[MANAGEMENT] SECURITY_AUTHENTICATION';
export const MANAGEMENT__CONTRACT_VALIDATION_COMPLIANCE = '[MANAGEMENT] CONTRACT_VALIDATION_COMPLIANCE';
export const MANAGEMENT__PERMISSIONS = '[MANAGEMENT] PERMISSIONS';
export const MANAGEMENT__DOMAIN_EMPTY_STATE = '[MANAGEMENT] DOMAIN_EMPTY_STATE';

// feature access (US 122)
export const FEATURE_ACCESS__TIME_REGISTRATION = '[FEATURE_ACCESS] TIME_REGISTRATION';
export const FEATURE_ACCESS__AVAILABILITIES = '[FEATURE_ACCESS] AVAILABILITIES';
export const FEATURE_ACCESS__DATA_WIZARD = '[FEATURE_ACCESS] DATA_WIZARD';
export const FEATURE_ACCESS__JOB_APPLICANTS = '[FEATURE_ACCESS] JOB_APPLICANTS';
export const FEATURE_ACCESS__COMPANY = '[FEATURE_ACCESS] COMPANY';
export const FEATURE_ACCESS__ENABLED = '[FEATURE_ACCESS] ENABLED';
export const FEATURE_ACCESS__DISABLED = '[FEATURE_ACCESS] DISABLED';
export const FEATURE_ACCESS__SEARCH_COMPANIES = '[FEATURE_ACCESS] SEARCH_COMPANIES';
export const FEATURE_ACCESS__FILTER_FEATURE = '[FEATURE_ACCESS] FILTER_FEATURE';
export const FEATURE_ACCESS__FILTER_STATUS = '[FEATURE_ACCESS] FILTER_STATUS';
export const FEATURE_ACCESS__ANY_FEATURE = '[FEATURE_ACCESS] ANY_FEATURE';
export const FEATURE_ACCESS__ANY_STATUS = '[FEATURE_ACCESS] ANY_STATUS';
export const FEATURE_ACCESS__SELECTED = '[FEATURE_ACCESS] SELECTED';
export const FEATURE_ACCESS__EDIT_ALL = '[FEATURE_ACCESS] EDIT_ALL';
export const FEATURE_ACCESS__ENABLE = '[FEATURE_ACCESS] ENABLE';
export const FEATURE_ACCESS__DISABLE = '[FEATURE_ACCESS] DISABLE';
export const FEATURE_ACCESS__LEAVE_UNCHANGED = '[FEATURE_ACCESS] LEAVE_UNCHANGED';
// "Apply these changes to {total} companies?"
export const FEATURE_ACCESS__BULK_CONFIRM = '[FEATURE_ACCESS] BULK_CONFIRM';
// "Access granted for {company}" / "Access removed for {company}"
export const FEATURE_ACCESS__ACCESS_GRANTED = '[FEATURE_ACCESS] ACCESS_GRANTED';
export const FEATURE_ACCESS__ACCESS_REMOVED = '[FEATURE_ACCESS] ACCESS_REMOVED';
// "Changes saved for {total} companies"
export const FEATURE_ACCESS__BULK_SAVED = '[FEATURE_ACCESS] BULK_SAVED';
// "Time registration could not be disabled because registrations are still running for" — the company names are appended after a colon
export const FEATURE_ACCESS__BULK_BLOCKED = '[FEATURE_ACCESS] BULK_BLOCKED';
export const FEATURE_ACCESS__EMPTY_STATE = '[FEATURE_ACCESS] EMPTY_STATE';
export const FEATURE_ACCESS__LOAD_ERROR = '[FEATURE_ACCESS] LOAD_ERROR';
export const FEATURE_ACCESS__PANEL_LOAD_ERROR = '[FEATURE_ACCESS] PANEL_LOAD_ERROR';
export const FEATURE_ACCESS__NO_ACCESS = '[FEATURE_ACCESS] NO_ACCESS';

// feature access API error keys — values match ErrorResponse.error verbatim
export const FEATURE_ACCESS__COMPANY_NOT_FOUND = '[FEATURE_ACCESS] COMPANY_NOT_FOUND';
// also the "can't disable while registrations are running" message
export const FEATURE_ACCESS__TIME_REGISTRATION_RUNNING = '[FEATURE_ACCESS] TIME_REGISTRATION_RUNNING';
// also the "Someone else changed this. Reloading…" message
export const FEATURE_ACCESS__CONCURRENT_CHANGE = '[FEATURE_ACCESS] CONCURRENT_CHANGE';
export const FEATURE_ACCESS__UNKNOWN_FEATURE = '[FEATURE_ACCESS] UNKNOWN_FEATURE';
export const FEATURE_ACCESS__DUPLICATE_FEATURE = '[FEATURE_ACCESS] DUPLICATE_FEATURE';
export const FEATURE_ACCESS__NO_COMPANIES_SELECTED = '[FEATURE_ACCESS] NO_COMPANIES_SELECTED';
// feature-disabled 403 keys returned by the feature endpoints themselves
export const TIME_REGISTRATION__FEATURE_DISABLED = '[TIME_REGISTRATION] FEATURE_DISABLED';
export const AVAILABILITY__FEATURE_DISABLED = '[AVAILABILITY] FEATURE_DISABLED';
export const DATA_WIZARD__FEATURE_DISABLED = '[DATA_WIZARD] FEATURE_DISABLED';

// absence reasons (US 123)
export const ABSENCE_REASON__ADD = '[ABSENCE_REASON] ADD';
export const ABSENCE_REASON__REASON = '[ABSENCE_REASON] REASON';
export const ABSENCE_REASON__REMUN_CODE_DESCRIPTION = '[ABSENCE_REASON] REMUN_CODE_DESCRIPTION';
export const ABSENCE_REASON__REMUN_CODE = '[ABSENCE_REASON] REMUN_CODE';
export const ABSENCE_REASON__REMARK = '[ABSENCE_REASON] REMARK';
export const ABSENCE_REASON__PROOF = '[ABSENCE_REASON] PROOF';
export const ABSENCE_REASON__REMARK_POLICY = '[ABSENCE_REASON] REMARK_POLICY';
export const ABSENCE_REASON__PROOF_POLICY = '[ABSENCE_REASON] PROOF_POLICY';
export const ABSENCE_REASON__REQUIRED = '[ABSENCE_REASON] REQUIRED';
export const ABSENCE_REASON__OPTIONAL = '[ABSENCE_REASON] OPTIONAL';
export const ABSENCE_REASON__NAME_NL = '[ABSENCE_REASON] NAME_NL';
export const ABSENCE_REASON__NAME_FR = '[ABSENCE_REASON] NAME_FR';
export const ABSENCE_REASON__NAME_EN = '[ABSENCE_REASON] NAME_EN';
export const ABSENCE_REASON__DEACTIVATED_BADGE = '[ABSENCE_REASON] DEACTIVATED_BADGE';
export const ABSENCE_REASON__DEACTIVATE = '[ABSENCE_REASON] DEACTIVATE';
// "Deactivate this absence reason? This cannot be undone."
export const ABSENCE_REASON__DEACTIVATE_CONFIRM = '[ABSENCE_REASON] DEACTIVATE_CONFIRM';
export const ABSENCE_REASON__PANEL_TITLE = '[ABSENCE_REASON] PANEL_TITLE';
export const ABSENCE_REASON__NEW_REASON = '[ABSENCE_REASON] NEW_REASON';
export const ABSENCE_REASON__SAVED = '[ABSENCE_REASON] SAVED';
export const ABSENCE_REASON__DEACTIVATE_SUCCESS = '[ABSENCE_REASON] DEACTIVATE_SUCCESS';
export const ABSENCE_REASON__EMPTY_STATE = '[ABSENCE_REASON] EMPTY_STATE';
export const ABSENCE_REASON__LOAD_ERROR = '[ABSENCE_REASON] LOAD_ERROR';
export const ABSENCE_REASON__PANEL_LOAD_ERROR = '[ABSENCE_REASON] PANEL_LOAD_ERROR';
export const ABSENCE_REASON__NO_ACCESS = '[ABSENCE_REASON] NO_ACCESS';

// absence reason API error keys — values match ErrorResponse.error verbatim; also used as client validation messages
export const ABSENCE_REASON__NAME_REQUIRED = '[ABSENCE_REASON] NAME_REQUIRED';
export const ABSENCE_REASON__NAME_TOO_LONG = '[ABSENCE_REASON] NAME_TOO_LONG';
export const ABSENCE_REASON__REMUN_CODE_DESCRIPTION_REQUIRED = '[ABSENCE_REASON] REMUN_CODE_DESCRIPTION_REQUIRED';
export const ABSENCE_REASON__REMUN_CODE_DESCRIPTION_TOO_LONG = '[ABSENCE_REASON] REMUN_CODE_DESCRIPTION_TOO_LONG';
export const ABSENCE_REASON__REMUN_CODE_REQUIRED = '[ABSENCE_REASON] REMUN_CODE_REQUIRED';
// RemunCode is 0 or negative
export const ABSENCE_REASON__INVALID_REMUN_CODE = '[ABSENCE_REASON] INVALID_REMUN_CODE';
export const ABSENCE_REASON__INVALID_POLICY = '[ABSENCE_REASON] INVALID_POLICY';
export const ABSENCE_REASON__ROW_VERSION_REQUIRED = '[ABSENCE_REASON] ROW_VERSION_REQUIRED';
export const ABSENCE_REASON__NOT_FOUND = '[ABSENCE_REASON] NOT_FOUND';
// the reason was deactivated meanwhile (409); the row badge uses ABSENCE_REASON__DEACTIVATED_BADGE
export const ABSENCE_REASON__DEACTIVATED = '[ABSENCE_REASON] DEACTIVATED';
// also the "This reason was changed by someone else" message
export const ABSENCE_REASON__CONCURRENT_CHANGE = '[ABSENCE_REASON] CONCURRENT_CHANGE';
// mobile "Report absence" (US 123 contract) — key only, used by the mobile app
export const ABSENCE__REASON_NO_LONGER_AVAILABLE = '[ABSENCE] REASON_NO_LONGER_AVAILABLE';
// no-show reason selector in service / contract confirmation — sent reason is no longer active
export const CONTRACT_PROCESSING__INVALID_NO_SHOW_REASON = '[CONTRACT_PROCESSING] INVALID_NO_SHOW_REASON';
export const NO_SHOW__REASON_NOT_AVAILABLE = '[NO_SHOW] REASON_NOT_AVAILABLE';

// time registration policy
export const TIME_REGISTRATION_POLICY__REQUIRED_FIELD = '[TIME_REGISTRATION_POLICY] REQUIRED_FIELD';
export const TIME_REGISTRATION_POLICY__INVALID_MINUTES = '[TIME_REGISTRATION_POLICY] INVALID_MINUTES';
export const TIME_REGISTRATION_POLICY__INVALID_ROUNDING_INTERVAL =
  '[TIME_REGISTRATION_POLICY] INVALID_ROUNDING_INTERVAL';
export const TIME_REGISTRATION_POLICY__INVALID_ROUNDING_DIRECTION =
  '[TIME_REGISTRATION_POLICY] INVALID_ROUNDING_DIRECTION';
export const TIME_REGISTRATION_POLICY__INVALID_MAXIMUM_NUMBER_OF_BREAKS =
  '[TIME_REGISTRATION_POLICY] INVALID_MAXIMUM_NUMBER_OF_BREAKS';
export const TIME_REGISTRATION_POLICY__INVALID_ON_SITE_RADIUS = '[TIME_REGISTRATION_POLICY] INVALID_ON_SITE_RADIUS';
export const TIME_REGISTRATION_POLICY__INVALID_AUTHENTICATION_MODE =
  '[TIME_REGISTRATION_POLICY] INVALID_AUTHENTICATION_MODE';
export const TIME_REGISTRATION_POLICY__CONCURRENT_CHANGE = '[TIME_REGISTRATION_POLICY] CONCURRENT_CHANGE';
export const TIME_REGISTRATION_POLICY__UNKNOWN_SETTING = '[TIME_REGISTRATION_POLICY] UNKNOWN_SETTING';
export const TIME_REGISTRATION_POLICY__INTRO = '[TIME_REGISTRATION_POLICY] INTRO';
export const TIME_REGISTRATION_POLICY__SECTION_POLICY = '[TIME_REGISTRATION_POLICY] SECTION_POLICY';
export const TIME_REGISTRATION_POLICY__SECTION_LOCATION = '[TIME_REGISTRATION_POLICY] SECTION_LOCATION';
export const TIME_REGISTRATION_POLICY__SECTION_KIOSK = '[TIME_REGISTRATION_POLICY] SECTION_KIOSK';
export const TIME_REGISTRATION_POLICY__KIOSK_NOTE = '[TIME_REGISTRATION_POLICY] KIOSK_NOTE';
export const TIME_REGISTRATION_POLICY__COLUMN_SETTING = '[TIME_REGISTRATION_POLICY] COLUMN_SETTING';
export const TIME_REGISTRATION_POLICY__COLUMN_DEFAULT = '[TIME_REGISTRATION_POLICY] COLUMN_DEFAULT';
export const TIME_REGISTRATION_POLICY__COLUMN_PERMISSION = '[TIME_REGISTRATION_POLICY] COLUMN_PERMISSION';
export const TIME_REGISTRATION_POLICY__OVERRULABLE = '[TIME_REGISTRATION_POLICY] OVERRULABLE';
export const TIME_REGISTRATION_POLICY__LOCKED = '[TIME_REGISTRATION_POLICY] LOCKED';
export const TIME_REGISTRATION_POLICY__EDIT = '[TIME_REGISTRATION_POLICY] EDIT';
export const TIME_REGISTRATION_POLICY__LOAD_ERROR = '[TIME_REGISTRATION_POLICY] LOAD_ERROR';
export const TIME_REGISTRATION_POLICY__PANEL_GROUP = '[TIME_REGISTRATION_POLICY] PANEL_GROUP';
export const TIME_REGISTRATION_POLICY__VALUE_ENABLED = '[TIME_REGISTRATION_POLICY] VALUE_ENABLED';
export const TIME_REGISTRATION_POLICY__VALUE_DISABLED = '[TIME_REGISTRATION_POLICY] VALUE_DISABLED';
export const TIME_REGISTRATION_POLICY__VALUE_OFF = '[TIME_REGISTRATION_POLICY] VALUE_OFF';
export const TIME_REGISTRATION_POLICY__VALUE_WINDOW = '[TIME_REGISTRATION_POLICY] VALUE_WINDOW';
export const TIME_REGISTRATION_POLICY__VALUE_ROUNDING = '[TIME_REGISTRATION_POLICY] VALUE_ROUNDING';
export const TIME_REGISTRATION_POLICY__VALUE_OVERWORK = '[TIME_REGISTRATION_POLICY] VALUE_OVERWORK';
export const TIME_REGISTRATION_POLICY__VALUE_LOCATION_REQUIRED = '[TIME_REGISTRATION_POLICY] VALUE_LOCATION_REQUIRED';
export const TIME_REGISTRATION_POLICY__VALUE_LOCATION_NOT_REQUIRED =
  '[TIME_REGISTRATION_POLICY] VALUE_LOCATION_NOT_REQUIRED';
export const TIME_REGISTRATION_POLICY__UNIT_ALLOW_START_IN_FUTURE =
  '[TIME_REGISTRATION_POLICY] UNIT_ALLOW_START_IN_FUTURE';
export const TIME_REGISTRATION_POLICY__UNIT_REGISTRATION_WINDOW = '[TIME_REGISTRATION_POLICY] UNIT_REGISTRATION_WINDOW';
export const TIME_REGISTRATION_POLICY__UNIT_EXTENDED_WINDOW = '[TIME_REGISTRATION_POLICY] UNIT_EXTENDED_WINDOW';
export const TIME_REGISTRATION_POLICY__UNIT_MAX_BREAKS = '[TIME_REGISTRATION_POLICY] UNIT_MAX_BREAKS';
export const TIME_REGISTRATION_POLICY__UNIT_BREAK_ROUNDING = '[TIME_REGISTRATION_POLICY] UNIT_BREAK_ROUNDING';
export const TIME_REGISTRATION_POLICY__UNIT_START_END_ROUNDING = '[TIME_REGISTRATION_POLICY] UNIT_START_END_ROUNDING';
export const TIME_REGISTRATION_POLICY__UNIT_OVERWORK_LIMIT = '[TIME_REGISTRATION_POLICY] UNIT_OVERWORK_LIMIT';
export const TIME_REGISTRATION_POLICY__UNIT_AUTO_FREEZE = '[TIME_REGISTRATION_POLICY] UNIT_AUTO_FREEZE';
export const TIME_REGISTRATION_POLICY__UNIT_LOCATION_CAPTURE = '[TIME_REGISTRATION_POLICY] UNIT_LOCATION_CAPTURE';
export const TIME_REGISTRATION_POLICY__UNIT_KIOSK_AUTH_MODE = '[TIME_REGISTRATION_POLICY] UNIT_KIOSK_AUTH_MODE';
export const TIME_REGISTRATION_POLICY__UNIT_PERSONAL_DEVICE_BLOCK =
  '[TIME_REGISTRATION_POLICY] UNIT_PERSONAL_DEVICE_BLOCK';
export const TIME_REGISTRATION_POLICY__UNIT_KIOSK_AVAILABILITY = '[TIME_REGISTRATION_POLICY] UNIT_KIOSK_AVAILABILITY';
export const TIME_REGISTRATION_POLICY__DESC_ALLOW_START_IN_FUTURE =
  '[TIME_REGISTRATION_POLICY] DESC_ALLOW_START_IN_FUTURE';
export const TIME_REGISTRATION_POLICY__DESC_REGISTRATION_WINDOW = '[TIME_REGISTRATION_POLICY] DESC_REGISTRATION_WINDOW';
export const TIME_REGISTRATION_POLICY__DESC_EXTENDED_WINDOW = '[TIME_REGISTRATION_POLICY] DESC_EXTENDED_WINDOW';
export const TIME_REGISTRATION_POLICY__DESC_MAX_BREAKS = '[TIME_REGISTRATION_POLICY] DESC_MAX_BREAKS';
export const TIME_REGISTRATION_POLICY__DESC_BREAK_ROUNDING = '[TIME_REGISTRATION_POLICY] DESC_BREAK_ROUNDING';
export const TIME_REGISTRATION_POLICY__DESC_START_END_ROUNDING = '[TIME_REGISTRATION_POLICY] DESC_START_END_ROUNDING';
export const TIME_REGISTRATION_POLICY__DESC_OVERWORK_LIMIT = '[TIME_REGISTRATION_POLICY] DESC_OVERWORK_LIMIT';
export const TIME_REGISTRATION_POLICY__DESC_AUTO_FREEZE = '[TIME_REGISTRATION_POLICY] DESC_AUTO_FREEZE';
export const TIME_REGISTRATION_POLICY__DESC_LOCATION_CAPTURE = '[TIME_REGISTRATION_POLICY] DESC_LOCATION_CAPTURE';
export const TIME_REGISTRATION_POLICY__DESC_KIOSK_AUTH_MODE = '[TIME_REGISTRATION_POLICY] DESC_KIOSK_AUTH_MODE';
export const TIME_REGISTRATION_POLICY__DESC_PERSONAL_DEVICE_BLOCK =
  '[TIME_REGISTRATION_POLICY] DESC_PERSONAL_DEVICE_BLOCK';
export const TIME_REGISTRATION_POLICY__DESC_KIOSK_AVAILABILITY = '[TIME_REGISTRATION_POLICY] DESC_KIOSK_AVAILABILITY';
export const TIME_REGISTRATION_POLICY__FIELD_BEFORE_START = '[TIME_REGISTRATION_POLICY] FIELD_BEFORE_START';
export const TIME_REGISTRATION_POLICY__FIELD_AFTER_START = '[TIME_REGISTRATION_POLICY] FIELD_AFTER_START';
export const TIME_REGISTRATION_POLICY__FIELD_ROUND_BREAK_TIMES = '[TIME_REGISTRATION_POLICY] FIELD_ROUND_BREAK_TIMES';
export const TIME_REGISTRATION_POLICY__FIELD_ROUND_START_END = '[TIME_REGISTRATION_POLICY] FIELD_ROUND_START_END';
export const TIME_REGISTRATION_POLICY__FIELD_BREAK_START = '[TIME_REGISTRATION_POLICY] FIELD_BREAK_START';
export const TIME_REGISTRATION_POLICY__FIELD_BREAK_END = '[TIME_REGISTRATION_POLICY] FIELD_BREAK_END';
export const TIME_REGISTRATION_POLICY__FIELD_START_TIME = '[TIME_REGISTRATION_POLICY] FIELD_START_TIME';
export const TIME_REGISTRATION_POLICY__FIELD_END_TIME = '[TIME_REGISTRATION_POLICY] FIELD_END_TIME';
export const TIME_REGISTRATION_POLICY__FIELD_CHOOSE_DIRECTION = '[TIME_REGISTRATION_POLICY] FIELD_CHOOSE_DIRECTION';
export const TIME_REGISTRATION_POLICY__FIELD_INTERVAL = '[TIME_REGISTRATION_POLICY] FIELD_INTERVAL';
export const TIME_REGISTRATION_POLICY__FIELD_LIMIT_OVERWORK = '[TIME_REGISTRATION_POLICY] FIELD_LIMIT_OVERWORK';
export const TIME_REGISTRATION_POLICY__FIELD_MAX_OVERWORK = '[TIME_REGISTRATION_POLICY] FIELD_MAX_OVERWORK';
export const TIME_REGISTRATION_POLICY__FIELD_REQUIRE_LOCATION = '[TIME_REGISTRATION_POLICY] FIELD_REQUIRE_LOCATION';
export const TIME_REGISTRATION_POLICY__FIELD_ON_SITE_RADIUS = '[TIME_REGISTRATION_POLICY] FIELD_ON_SITE_RADIUS';
export const TIME_REGISTRATION_POLICY__FIELD_AUTH_MODE = '[TIME_REGISTRATION_POLICY] FIELD_AUTH_MODE';
export const TIME_REGISTRATION_POLICY__AUTH_OPEN_LIST = '[TIME_REGISTRATION_POLICY] AUTH_OPEN_LIST';
export const TIME_REGISTRATION_POLICY__AUTH_PIN = '[TIME_REGISTRATION_POLICY] AUTH_PIN';
export const TIME_REGISTRATION_POLICY__AUTH_PIN_APPROVAL = '[TIME_REGISTRATION_POLICY] AUTH_PIN_APPROVAL';
export const TIME_REGISTRATION_POLICY__PERMISSION_TOGGLE = '[TIME_REGISTRATION_POLICY] PERMISSION_TOGGLE';
export const TIME_REGISTRATION_POLICY__PERMISSION_OVERRULABLE_TEXT =
  '[TIME_REGISTRATION_POLICY] PERMISSION_OVERRULABLE_TEXT';
export const TIME_REGISTRATION_POLICY__PERMISSION_LOCKED_TEXT = '[TIME_REGISTRATION_POLICY] PERMISSION_LOCKED_TEXT';
export const TIME_REGISTRATION_POLICY__CONFIRM_TITLE_CHANGE = '[TIME_REGISTRATION_POLICY] CONFIRM_TITLE_CHANGE';
export const TIME_REGISTRATION_POLICY__CONFIRM_TITLE_LOCK = '[TIME_REGISTRATION_POLICY] CONFIRM_TITLE_LOCK';
export const TIME_REGISTRATION_POLICY__CONFIRM_TITLE_UNLOCK = '[TIME_REGISTRATION_POLICY] CONFIRM_TITLE_UNLOCK';
export const TIME_REGISTRATION_POLICY__CONFIRM_NO_COMPANY = '[TIME_REGISTRATION_POLICY] CONFIRM_NO_COMPANY';
export const TIME_REGISTRATION_POLICY__CONFIRM_RECEIVING_ONE = '[TIME_REGISTRATION_POLICY] CONFIRM_RECEIVING_ONE';
export const TIME_REGISTRATION_POLICY__CONFIRM_RECEIVING_OTHER = '[TIME_REGISTRATION_POLICY] CONFIRM_RECEIVING_OTHER';
export const TIME_REGISTRATION_POLICY__CONFIRM_LOSING_ONE = '[TIME_REGISTRATION_POLICY] CONFIRM_LOSING_ONE';
export const TIME_REGISTRATION_POLICY__CONFIRM_LOSING_OTHER = '[TIME_REGISTRATION_POLICY] CONFIRM_LOSING_OTHER';
export const TIME_REGISTRATION_POLICY__CONFIRM_NO_OVERRULE_LOST = '[TIME_REGISTRATION_POLICY] CONFIRM_NO_OVERRULE_LOST';
export const TIME_REGISTRATION_POLICY__CONFIRM_UNLOCK = '[TIME_REGISTRATION_POLICY] CONFIRM_UNLOCK';
export const TIME_REGISTRATION_POLICY__CONFIRM_KIOSK_IMMEDIATE = '[TIME_REGISTRATION_POLICY] CONFIRM_KIOSK_IMMEDIATE';
export const TIME_REGISTRATION_POLICY__SAVED = '[TIME_REGISTRATION_POLICY] SAVED';
export const TIME_REGISTRATION_POLICY__SAVE_TIMEOUT = '[TIME_REGISTRATION_POLICY] SAVE_TIMEOUT';
export const TIME_REGISTRATION_POLICY__SAVE_FAILED = '[TIME_REGISTRATION_POLICY] SAVE_FAILED';
export const TIME_REGISTRATION_POLICY__RELOAD = '[TIME_REGISTRATION_POLICY] RELOAD';

export const KIOSK__SETTING_LOCKED = '[KIOSK] SETTING_LOCKED';
export const KIOSK__KIOSK_MODE_NOT_AVAILABLE = '[KIOSK] KIOSK_MODE_NOT_AVAILABLE';

// contract validation & compliance — break hours for minors (US 125)
export const CONTRACT_COMPLIANCE__BREAK_HOURS_FOR_MINORS = '[CONTRACT_COMPLIANCE] BREAK_HOURS_FOR_MINORS';
// "Changes apply from the moment they're saved — there is no start or end date. Legal minimums are seeded as the initial defaults. ..."
export const CONTRACT_COMPLIANCE__BREAK_HOURS_INTRO = '[CONTRACT_COMPLIANCE] BREAK_HOURS_INTRO';
// "Rule 1 — continuous work"
export const CONTRACT_COMPLIANCE__RULE_CONTINUOUS_WORK = '[CONTRACT_COMPLIANCE] RULE_CONTINUOUS_WORK';
export const CONTRACT_COMPLIANCE__RULE_CONTINUOUS_WORK_NOTE = '[CONTRACT_COMPLIANCE] RULE_CONTINUOUS_WORK_NOTE';
// "Rule 2 — legal work time"
export const CONTRACT_COMPLIANCE__RULE_LEGAL_WORK_TIME = '[CONTRACT_COMPLIANCE] RULE_LEGAL_WORK_TIME';
export const CONTRACT_COMPLIANCE__RULE_LEGAL_WORK_TIME_NOTE = '[CONTRACT_COMPLIANCE] RULE_LEGAL_WORK_TIME_NOTE';
// "Default"
export const CONTRACT_COMPLIANCE__DEFAULT = '[CONTRACT_COMPLIANCE] DEFAULT';
// "{break} after {threshold}"
export const CONTRACT_COMPLIANCE__DEFAULT_CONTINUOUS_WORK = '[CONTRACT_COMPLIANCE] DEFAULT_CONTINUOUS_WORK';
// "{total} total ({continuous} continuous) after {threshold}"
export const CONTRACT_COMPLIANCE__DEFAULT_LEGAL_WORK_TIME = '[CONTRACT_COMPLIANCE] DEFAULT_LEGAL_WORK_TIME';
// "{minutes} min"
export const CONTRACT_COMPLIANCE__MINUTES_SHORT = '[CONTRACT_COMPLIANCE] MINUTES_SHORT';
export const CONTRACT_COMPLIANCE__EDIT_DEFAULT = '[CONTRACT_COMPLIANCE] EDIT_DEFAULT';
export const CONTRACT_COMPLIANCE__EDIT_DEFAULT_VALUE = '[CONTRACT_COMPLIANCE] EDIT_DEFAULT_VALUE';
export const CONTRACT_COMPLIANCE__ADD_EXCEPTION = '[CONTRACT_COMPLIANCE] ADD_EXCEPTION';
export const CONTRACT_COMPLIANCE__EDIT_EXCEPTION = '[CONTRACT_COMPLIANCE] EDIT_EXCEPTION';
export const CONTRACT_COMPLIANCE__REMOVE_EXCEPTION = '[CONTRACT_COMPLIANCE] REMOVE_EXCEPTION';
// "Search scope entity…"
export const CONTRACT_COMPLIANCE__SEARCH_SCOPE_ENTITY = '[CONTRACT_COMPLIANCE] SEARCH_SCOPE_ENTITY';
export const CONTRACT_COMPLIANCE__SCOPE_LEVEL = '[CONTRACT_COMPLIANCE] SCOPE_LEVEL';
export const CONTRACT_COMPLIANCE__SCOPE_ENTITY = '[CONTRACT_COMPLIANCE] SCOPE_ENTITY';
// "Scope entities (select one or more)"
export const CONTRACT_COMPLIANCE__SCOPE_ENTITIES = '[CONTRACT_COMPLIANCE] SCOPE_ENTITIES';
// "General / Agency"
export const CONTRACT_COMPLIANCE__SCOPE_AGENCY = '[CONTRACT_COMPLIANCE] SCOPE_AGENCY';
export const CONTRACT_COMPLIANCE__SCOPE_JOINT_COMMISSION = '[CONTRACT_COMPLIANCE] SCOPE_JOINT_COMMISSION';
export const CONTRACT_COMPLIANCE__SCOPE_COMPANY = '[CONTRACT_COMPLIANCE] SCOPE_COMPANY';
export const CONTRACT_COMPLIANCE__SCOPE_API_USER = '[CONTRACT_COMPLIANCE] SCOPE_API_USER';
// "Applies to the whole Agency — no entities to select."
export const CONTRACT_COMPLIANCE__SCOPE_AGENCY_HINT = '[CONTRACT_COMPLIANCE] SCOPE_AGENCY_HINT';
// "Adding an exception here bypasses this validation for the selected scope entities — there's no other value to set."
export const CONTRACT_COMPLIANCE__EXCEPTION_BINARY_HINT = '[CONTRACT_COMPLIANCE] EXCEPTION_BINARY_HINT';
// "This change takes effect the moment you save it — there is no start or end date. ..."
export const CONTRACT_COMPLIANCE__TAKES_EFFECT_HINT = '[CONTRACT_COMPLIANCE] TAKES_EFFECT_HINT';
export const CONTRACT_COMPLIANCE__CONTINUOUS_WORK_THRESHOLD = '[CONTRACT_COMPLIANCE] CONTINUOUS_WORK_THRESHOLD';
export const CONTRACT_COMPLIANCE__LEGAL_WORK_TIME_THRESHOLD = '[CONTRACT_COMPLIANCE] LEGAL_WORK_TIME_THRESHOLD';
export const CONTRACT_COMPLIANCE__MINIMUM_BREAK = '[CONTRACT_COMPLIANCE] MINIMUM_BREAK';
export const CONTRACT_COMPLIANCE__TOTAL_BREAK = '[CONTRACT_COMPLIANCE] TOTAL_BREAK';
export const CONTRACT_COMPLIANCE__CONTINUOUS_BREAK = '[CONTRACT_COMPLIANCE] CONTINUOUS_BREAK';
// input unit, "min"
export const CONTRACT_COMPLIANCE__MINUTES = '[CONTRACT_COMPLIANCE] MINUTES';
// "Must be greater than 0"
export const CONTRACT_COMPLIANCE__THRESHOLD_POSITIVE = '[CONTRACT_COMPLIANCE] THRESHOLD_POSITIVE';
// "Must be between 0 and the threshold"
export const CONTRACT_COMPLIANCE__BREAK_RANGE = '[CONTRACT_COMPLIANCE] BREAK_RANGE';
// "Must be 60 minutes or less"
export const CONTRACT_COMPLIANCE__BREAK_MAXIMUM = '[CONTRACT_COMPLIANCE] BREAK_MAXIMUM';
// "Must be less than or equal to the total break duration"
export const CONTRACT_COMPLIANCE__CONTINUOUS_EXCEEDS_TOTAL_HINT = '[CONTRACT_COMPLIANCE] CONTINUOUS_EXCEEDS_TOTAL_HINT';
// "Enter a whole number of minutes"
export const CONTRACT_COMPLIANCE__REQUIRED_WHOLE_MINUTES = '[CONTRACT_COMPLIANCE] REQUIRED_WHOLE_MINUTES';
// "Select at most {max} entities"
export const CONTRACT_COMPLIANCE__TOO_MANY_SCOPE_ENTITIES = '[CONTRACT_COMPLIANCE] TOO_MANY_SCOPE_ENTITIES';
// "Justification (optional)"
export const CONTRACT_COMPLIANCE__JUSTIFICATION = '[CONTRACT_COMPLIANCE] JUSTIFICATION';
// "Why is this configuration needed? (max 500 characters)"
export const CONTRACT_COMPLIANCE__JUSTIFICATION_PLACEHOLDER = '[CONTRACT_COMPLIANCE] JUSTIFICATION_PLACEHOLDER';
// "Supporting document (optional)"
export const CONTRACT_COMPLIANCE__SUPPORTING_DOCUMENT = '[CONTRACT_COMPLIANCE] SUPPORTING_DOCUMENT';
// "Attach supporting document"
export const CONTRACT_COMPLIANCE__ATTACH_DOCUMENT = '[CONTRACT_COMPLIANCE] ATTACH_DOCUMENT';
// "PDF, Word, JPG or PNG, max 10 MB"
export const CONTRACT_COMPLIANCE__DOCUMENT_HINT = '[CONTRACT_COMPLIANCE] DOCUMENT_HINT';
// "Only PDF, Word, JPG or PNG files up to 10 MB can be attached"
export const CONTRACT_COMPLIANCE__DOCUMENT_REJECTED = '[CONTRACT_COMPLIANCE] DOCUMENT_REJECTED';
// "This change applies to all contracts created from now on and does not change contracts already planned."
export const CONTRACT_COMPLIANCE__CONFIRM_SAVE = '[CONTRACT_COMPLIANCE] CONFIRM_SAVE';
// "Contracts already created for {entity} under this exception may now violate the rule. ..."
export const CONTRACT_COMPLIANCE__REMOVE_DISCLAIMER = '[CONTRACT_COMPLIANCE] REMOVE_DISCLAIMER';
// "No exceptions — legal default applies everywhere."
export const CONTRACT_COMPLIANCE__EMPTY_STATE = '[CONTRACT_COMPLIANCE] EMPTY_STATE';
// "No exceptions match your search."
export const CONTRACT_COMPLIANCE__NO_MATCHES = '[CONTRACT_COMPLIANCE] NO_MATCHES';
export const CONTRACT_COMPLIANCE__DEFAULT_SAVED = '[CONTRACT_COMPLIANCE] DEFAULT_SAVED';
export const CONTRACT_COMPLIANCE__EXCEPTION_SAVED = '[CONTRACT_COMPLIANCE] EXCEPTION_SAVED';
export const CONTRACT_COMPLIANCE__EXCEPTION_REMOVED = '[CONTRACT_COMPLIANCE] EXCEPTION_REMOVED';
export const CONTRACT_COMPLIANCE__LOAD_ERROR = '[CONTRACT_COMPLIANCE] LOAD_ERROR';
export const CONTRACT_COMPLIANCE__PANEL_LOAD_ERROR = '[CONTRACT_COMPLIANCE] PANEL_LOAD_ERROR';
export const CONTRACT_COMPLIANCE__NO_ACCESS = '[CONTRACT_COMPLIANCE] NO_ACCESS';

// contract compliance API error keys — values match ErrorResponse.error verbatim (seeded by the backend)
export const CONTRACT_COMPLIANCE__NOT_FOUND = '[CONTRACT_COMPLIANCE] NOT_FOUND';
export const CONTRACT_COMPLIANCE__CONCURRENT_CHANGE = '[CONTRACT_COMPLIANCE] CONCURRENT_CHANGE';
export const CONTRACT_COMPLIANCE__DUPLICATE_EXCEPTION = '[CONTRACT_COMPLIANCE] DUPLICATE_EXCEPTION';
export const CONTRACT_COMPLIANCE__SCOPE_ENTITY_NOT_FOUND = '[CONTRACT_COMPLIANCE] SCOPE_ENTITY_NOT_FOUND';
export const CONTRACT_COMPLIANCE__NIGHT_WORK_FOR_MINORS = '[CONTRACT_COMPLIANCE] NIGHT_WORK_FOR_MINORS';
export const CONTRACT_COMPLIANCE__NIGHT_WORK_INTRO = '[CONTRACT_COMPLIANCE] NIGHT_WORK_INTRO';
export const CONTRACT_COMPLIANCE__RULE_ABSOLUTE_PROHIBITION = '[CONTRACT_COMPLIANCE] RULE_ABSOLUTE_PROHIBITION';
export const CONTRACT_COMPLIANCE__RULE_ABSOLUTE_PROHIBITION_NOTE =
  '[CONTRACT_COMPLIANCE] RULE_ABSOLUTE_PROHIBITION_NOTE';
export const CONTRACT_COMPLIANCE__RULE_UNDER_16 = '[CONTRACT_COMPLIANCE] RULE_UNDER_16';
export const CONTRACT_COMPLIANCE__RULE_UNDER_16_NOTE = '[CONTRACT_COMPLIANCE] RULE_UNDER_16_NOTE';
export const CONTRACT_COMPLIANCE__RULE_16_17 = '[CONTRACT_COMPLIANCE] RULE_16_17';
export const CONTRACT_COMPLIANCE__RULE_16_17_NOTE = '[CONTRACT_COMPLIANCE] RULE_16_17_NOTE';
export const CONTRACT_COMPLIANCE__START_TIME = '[CONTRACT_COMPLIANCE] START_TIME';
export const CONTRACT_COMPLIANCE__END_TIME = '[CONTRACT_COMPLIANCE] END_TIME';
export const CONTRACT_COMPLIANCE__DEFAULT_INTERVAL_HINT = '[CONTRACT_COMPLIANCE] DEFAULT_INTERVAL_HINT';
export const CONTRACT_COMPLIANCE__EXCEPTION_INTERVAL_HINT = '[CONTRACT_COMPLIANCE] EXCEPTION_INTERVAL_HINT';
export const CONTRACT_COMPLIANCE__AGE_FROM = '[CONTRACT_COMPLIANCE] AGE_FROM';
export const CONTRACT_COMPLIANCE__AGE_TO = '[CONTRACT_COMPLIANCE] AGE_TO';
export const CONTRACT_COMPLIANCE__YEARS = '[CONTRACT_COMPLIANCE] YEARS';
export const CONTRACT_COMPLIANCE__DEFAULT_NIGHT_WORK_AGE_BAND = '[CONTRACT_COMPLIANCE] DEFAULT_NIGHT_WORK_AGE_BAND';
export const CONTRACT_COMPLIANCE__VALUE = '[CONTRACT_COMPLIANCE] VALUE';
export const CONTRACT_COMPLIANCE__RULE_NOT_APPLIED = '[CONTRACT_COMPLIANCE] RULE_NOT_APPLIED';
export const CONTRACT_COMPLIANCE__TIME_REQUIRED = '[CONTRACT_COMPLIANCE] TIME_REQUIRED';
export const CONTRACT_COMPLIANCE__INVALID_TIME = '[CONTRACT_COMPLIANCE] INVALID_TIME';
export const CONTRACT_COMPLIANCE__INTERVAL_BOTH_TIMES = '[CONTRACT_COMPLIANCE] INTERVAL_BOTH_TIMES';
export const CONTRACT_COMPLIANCE__START_EQUALS_END = '[CONTRACT_COMPLIANCE] START_EQUALS_END';
export const CONTRACT_COMPLIANCE__REQUIRED_WHOLE_YEARS = '[CONTRACT_COMPLIANCE] REQUIRED_WHOLE_YEARS';
export const CONTRACT_COMPLIANCE__AGE_BAND_RANGE = '[CONTRACT_COMPLIANCE] AGE_BAND_RANGE';
export const CONTRACT_COMPLIANCE__INVALID_INTERVAL = '[CONTRACT_COMPLIANCE] INVALID_INTERVAL';
export const CONTRACT_COMPLIANCE__INTERVAL_NOT_APPLICABLE = '[CONTRACT_COMPLIANCE] INTERVAL_NOT_APPLICABLE';
export const CONTRACT_COMPLIANCE__INTERVAL_OUTSIDE_RULE_WINDOW = '[CONTRACT_COMPLIANCE] INTERVAL_OUTSIDE_RULE_WINDOW';
export const CONTRACT_COMPLIANCE__INVALID_AGE_BAND = '[CONTRACT_COMPLIANCE] INVALID_AGE_BAND';
export const CONTRACT_COMPLIANCE__AGE_BAND_NOT_APPLICABLE = '[CONTRACT_COMPLIANCE] AGE_BAND_NOT_APPLICABLE';

/* ── Employee function links (US 577) ─────────────────────────────────────── */
export const EMPLOYEE_FUNCTION_LINKS__SECTION_TITLE = '[EMPLOYEE_FUNCTION_LINKS] SECTION_TITLE';
export const EMPLOYEE_FUNCTION_LINKS__ADD_BUTTON = '[EMPLOYEE_FUNCTION_LINKS] ADD_BUTTON';
export const EMPLOYEE_FUNCTION_LINKS__ADD_TITLE = '[EMPLOYEE_FUNCTION_LINKS] ADD_TITLE';
export const EMPLOYEE_FUNCTION_LINKS__EDIT_TITLE = '[EMPLOYEE_FUNCTION_LINKS] EDIT_TITLE';
export const EMPLOYEE_FUNCTION_LINKS__COLUMN_EMPLOYEE = '[EMPLOYEE_FUNCTION_LINKS] COLUMN_EMPLOYEE';
export const EMPLOYEE_FUNCTION_LINKS__COLUMN_FUNCTIONS = '[EMPLOYEE_FUNCTION_LINKS] COLUMN_FUNCTIONS';
export const EMPLOYEE_FUNCTION_LINKS__COLUMN_CATEGORIES = '[EMPLOYEE_FUNCTION_LINKS] COLUMN_CATEGORIES';
export const EMPLOYEE_FUNCTION_LINKS__EMPLOYEES_LABEL = '[EMPLOYEE_FUNCTION_LINKS] EMPLOYEES_LABEL';
export const EMPLOYEE_FUNCTION_LINKS__FUNCTIONS_LABEL = '[EMPLOYEE_FUNCTION_LINKS] FUNCTIONS_LABEL';
export const EMPLOYEE_FUNCTION_LINKS__ALL_EMPLOYEES_LINKED = '[EMPLOYEE_FUNCTION_LINKS] ALL_EMPLOYEES_LINKED';
export const EMPLOYEE_FUNCTION_LINKS__NO_EMPLOYEES_FOUND = '[EMPLOYEE_FUNCTION_LINKS] NO_EMPLOYEES_FOUND';
export const EMPLOYEE_FUNCTION_LINKS__REMOVE_ROW_CONFIRM = '[EMPLOYEE_FUNCTION_LINKS] REMOVE_ROW_CONFIRM';
export const EMPLOYEE_FUNCTION_LINKS__NO_ACTIVE_FUNCTION = '[EMPLOYEE_FUNCTION_LINKS] NO_ACTIVE_FUNCTION';
export const EMPLOYEE_FUNCTION_LINKS__DELETE_FUNCTION_WARNING = '[EMPLOYEE_FUNCTION_LINKS] DELETE_FUNCTION_WARNING';
export const EMPLOYEE_FUNCTION_LINKS__DELETE_FUNCTIONS_WARNING = '[EMPLOYEE_FUNCTION_LINKS] DELETE_FUNCTIONS_WARNING';

// Raised by the API as well as by the add/edit modal, so both paths resolve to one translation.
export const EMPLOYEE_FUNCTION_LINKS__EMPLOYEES_REQUIRED = '[EMPLOYEE_FUNCTION_LINK] EMPLOYEES_REQUIRED';
export const EMPLOYEE_FUNCTION_LINKS__FUNCTIONS_REQUIRED = '[EMPLOYEE_FUNCTION_LINK] FUNCTIONS_REQUIRED';

/* ── First-time TOTP MFA enrollment (US 53) ───────────────────────────────── */
export const MFA_ENROLLMENT__SETUP_TITLE = '[MFA_ENROLLMENT] SETUP_TITLE';
export const MFA_ENROLLMENT__SETUP_INSTRUCTIONS = '[MFA_ENROLLMENT] SETUP_INSTRUCTIONS';
export const MFA_ENROLLMENT__CODE_LABEL = '[MFA_ENROLLMENT] CODE_LABEL';
export const MFA_ENROLLMENT__SECRET_COPIED = '[MFA_ENROLLMENT] SECRET_COPIED';
export const MFA_ENROLLMENT__BACK_TO_SIGN_IN = '[MFA_ENROLLMENT] BACK_TO_SIGN_IN';
export const MFA_ENROLLMENT__CONTINUE = '[MFA_ENROLLMENT] CONTINUE';
export const MFA_ENROLLMENT__RETRY_IN_SECONDS = '[MFA_ENROLLMENT] RETRY_IN_SECONDS'; // interpolates {seconds}
export const MFA_ENROLLMENT__BACKUP_CODES_TITLE = '[MFA_ENROLLMENT] BACKUP_CODES_TITLE';
export const MFA_ENROLLMENT__BACKUP_CODES_WARNING = '[MFA_ENROLLMENT] BACKUP_CODES_WARNING';
export const MFA_ENROLLMENT__COPY_CODES = '[MFA_ENROLLMENT] COPY_CODES';
export const MFA_ENROLLMENT__DOWNLOAD_CODES = '[MFA_ENROLLMENT] DOWNLOAD_CODES';
export const MFA_ENROLLMENT__CODES_COPIED = '[MFA_ENROLLMENT] CODES_COPIED';
export const MFA_ENROLLMENT__CONFIRM = '[MFA_ENROLLMENT] CONFIRM';

/* ── Grace-period enrollment banner (US 93) ───────────────────────────────── */
export const MFA_ENROLLMENT__BANNER_MESSAGE = '[MFA_ENROLLMENT] BANNER_MESSAGE'; // interpolates {date}
/**
 * Fallback for the contradictory `showMfaEnrollmentBanner: true` + `mfaMandatoryFrom: null` pair.
 * The contract says it cannot happen — a missing date means mandatory now, which turns the flag off —
 * but the alternative is interpolating an empty string into "…becomes mandatory on .".
 */
export const MFA_ENROLLMENT__BANNER_MESSAGE_NO_DATE = '[MFA_ENROLLMENT] BANNER_MESSAGE_NO_DATE';
export const MFA_ENROLLMENT__BANNER_CTA = '[MFA_ENROLLMENT] BANNER_CTA';
export const MFA_ENROLLMENT__BANNER_DISMISS = '[MFA_ENROLLMENT] BANNER_DISMISS';
// The dialog's secondary button reuses GENERAL__CANCEL_BUTTON — it is already translated everywhere.

/* ── Returning-user TOTP MFA challenge (US 54) ────────────────────────────── */
export const MFA_CHALLENGE__TITLE = '[MFA_CHALLENGE] TITLE';
export const MFA_CHALLENGE__INSTRUCTIONS = '[MFA_CHALLENGE] INSTRUCTIONS';
export const MFA_CHALLENGE__CODE_LABEL = '[MFA_CHALLENGE] CODE_LABEL';
export const MFA_CHALLENGE__VERIFY = '[MFA_CHALLENGE] VERIFY';
export const MFA_CHALLENGE__BACK_TO_SIGN_IN = '[MFA_CHALLENGE] BACK_TO_SIGN_IN';
export const MFA_CHALLENGE__RETRY_IN_SECONDS = '[MFA_CHALLENGE] RETRY_IN_SECONDS'; // interpolates {seconds}
export const MFA_CHALLENGE__USE_BACKUP_CODE = '[MFA_CHALLENGE] USE_BACKUP_CODE';

/* ── Recovery with a backup code (US 94) ──────────────────────────────────── */
export const MFA_CHALLENGE__BACKUP_CODE_TITLE = '[MFA_CHALLENGE] BACKUP_CODE_TITLE';
export const MFA_CHALLENGE__BACKUP_CODE_INSTRUCTIONS = '[MFA_CHALLENGE] BACKUP_CODE_INSTRUCTIONS';
export const MFA_CHALLENGE__BACKUP_CODE_LABEL = '[MFA_CHALLENGE] BACKUP_CODE_LABEL';
export const MFA_CHALLENGE__USE_AUTHENTICATOR = '[MFA_CHALLENGE] USE_AUTHENTICATOR';
export const MFA_CHALLENGE__BACKUP_CODE_ACCEPTED_TITLE = '[MFA_CHALLENGE] BACKUP_CODE_ACCEPTED_TITLE';
export const MFA_CHALLENGE__BACKUP_CODES_REMAINING = '[MFA_CHALLENGE] BACKUP_CODES_REMAINING'; // interpolates {count}
/** The zero case gets its own key, not a pluralisation: the story asks for markedly stronger copy. */
export const MFA_CHALLENGE__BACKUP_CODES_NONE_LEFT = '[MFA_CHALLENGE] BACKUP_CODES_NONE_LEFT';
export const MFA_CHALLENGE__CONTINUE = '[MFA_CHALLENGE] CONTINUE';

/**
 * The two error keys the backup-code endpoint returns. Nothing imports these — like every other
 * `[MFA] …` failure they arrive in the response body and go straight through `t()` (see
 * `resolveMfaFailure`) — but they are registered here so `/translation-table` picks them up: the
 * backend ships them with no translation row, so `message` is null until these are filled in.
 */
export const MFA__BACKUP_CODE_INVALID = '[MFA] BACKUP_CODE_INVALID';
export const MFA__BACKUP_CODES_EXHAUSTED = '[MFA] BACKUP_CODES_EXHAUSTED';

// security & authentication
export const SECURITY__MFA_TITLE = '[SECURITY] MFA_TITLE';
export const SECURITY__REQUIRED_BY_ROLE_AND_PLATFORM = '[SECURITY] REQUIRED_BY_ROLE_AND_PLATFORM';
export const SECURITY__ROLE = '[SECURITY] ROLE';
export const SECURITY__ROLE_EMPLOYEE = '[SECURITY] ROLE_EMPLOYEE';
export const SECURITY__ROLE_MANAGER = '[SECURITY] ROLE_MANAGER';
export const SECURITY__ROLE_SUPERADMIN = '[SECURITY] ROLE_SUPERADMIN';
export const SECURITY__PLATFORM_WEBAPP = '[SECURITY] PLATFORM_WEBAPP';
export const SECURITY__PLATFORM_NATIVE_MOBILE = '[SECURITY] PLATFORM_NATIVE_MOBILE';
export const SECURITY__MFA_REQUIRED = '[SECURITY] MFA_REQUIRED';
export const SECURITY__MFA_NOT_REQUIRED = '[SECURITY] MFA_NOT_REQUIRED';
export const SECURITY__MANDATORY_ACTIVATION = '[SECURITY] MANDATORY_ACTIVATION';
export const SECURITY__GRACE_PERIOD_ENDS = '[SECURITY] GRACE_PERIOD_ENDS';
export const SECURITY__GRACE_PERIOD_HELP = '[SECURITY] GRACE_PERIOD_HELP';
export const SECURITY__GRACE_PERIOD_ENDED = '[SECURITY] GRACE_PERIOD_ENDED';
export const SECURITY__FAILS_CLOSED_NOTICE = '[SECURITY] FAILS_CLOSED_NOTICE';
export const SECURITY__DISCARD_CHANGES = '[SECURITY] DISCARD_CHANGES';
export const SECURITY__SAVE_POLICY = '[SECURITY] SAVE_POLICY';
export const SECURITY__CONFIRM_ENFORCEMENT_INCREASED = '[SECURITY] CONFIRM_ENFORCEMENT_INCREASED';
export const SECURITY__CONFIRM_ENFORCEMENT_IMMEDIATE = '[SECURITY] CONFIRM_ENFORCEMENT_IMMEDIATE';
export const SECURITY__LOAD_ERROR = '[SECURITY] LOAD_ERROR';
export const SECURITY__SAVE_ERROR = '[SECURITY] SAVE_ERROR';
export const TIME_REGISTRATION_SETTINGS__INTRO = '[TIME_REGISTRATION_SETTINGS] INTRO';
export const TIME_REGISTRATION_SETTINGS__LOAD_ERROR = '[TIME_REGISTRATION_SETTINGS] LOAD_ERROR';
export const TIME_REGISTRATION_SETTINGS__FEATURE_NOT_ENABLED = '[TIME_REGISTRATION_SETTINGS] FEATURE_NOT_ENABLED';
export const TIME_REGISTRATION_SETTINGS__COLUMN_VALUE = '[TIME_REGISTRATION_SETTINGS] COLUMN_VALUE';
export const TIME_REGISTRATION_SETTINGS__COLUMN_STATE = '[TIME_REGISTRATION_SETTINGS] COLUMN_STATE';
export const TIME_REGISTRATION_SETTINGS__OVERRULED = '[TIME_REGISTRATION_SETTINGS] OVERRULED';
export const TIME_REGISTRATION_SETTINGS__VIEW = '[TIME_REGISTRATION_SETTINGS] VIEW';
export const TIME_REGISTRATION_SETTINGS__PANEL_STATE = '[TIME_REGISTRATION_SETTINGS] PANEL_STATE';
export const TIME_REGISTRATION_SETTINGS__STATE_OVERRULABLE_TEXT = '[TIME_REGISTRATION_SETTINGS] STATE_OVERRULABLE_TEXT';
export const TIME_REGISTRATION_SETTINGS__STATE_OVERRULED_TEXT = '[TIME_REGISTRATION_SETTINGS] STATE_OVERRULED_TEXT';
export const TIME_REGISTRATION_SETTINGS__STATE_LOCKED_TEXT = '[TIME_REGISTRATION_SETTINGS] STATE_LOCKED_TEXT';
export const TIME_REGISTRATION_SETTINGS__REVERT_TO_AGENCY = '[TIME_REGISTRATION_SETTINGS] REVERT_TO_AGENCY';
export const TIME_REGISTRATION_SETTINGS__REVERT_PENDING = '[TIME_REGISTRATION_SETTINGS] REVERT_PENDING';
export const TIME_REGISTRATION_SETTINGS__COMPANY_DEFAULT = '[TIME_REGISTRATION_SETTINGS] COMPANY_DEFAULT';
export const TIME_REGISTRATION_SETTINGS__LOCATION_OVERRIDES = '[TIME_REGISTRATION_SETTINGS] LOCATION_OVERRIDES';
export const TIME_REGISTRATION_SETTINGS__LOCATION_OVERRIDES_EMPTY =
  '[TIME_REGISTRATION_SETTINGS] LOCATION_OVERRIDES_EMPTY';
export const TIME_REGISTRATION_SETTINGS__ADD_LOCATION_OVERRIDE = '[TIME_REGISTRATION_SETTINGS] ADD_LOCATION_OVERRIDE';
export const TIME_REGISTRATION_SETTINGS__REMOVE_LOCATION_OVERRIDE =
  '[TIME_REGISTRATION_SETTINGS] REMOVE_LOCATION_OVERRIDE';
export const TIME_REGISTRATION_SETTINGS__OVERRIDE_LOCATIONS = '[TIME_REGISTRATION_SETTINGS] OVERRIDE_LOCATIONS';
export const TIME_REGISTRATION_SETTINGS__OVERRIDE_LOCATIONS_PLACEHOLDER =
  '[TIME_REGISTRATION_SETTINGS] OVERRIDE_LOCATIONS_PLACEHOLDER';
export const TIME_REGISTRATION_SETTINGS__LOCATION_OVERRIDES_COUNT_ONE =
  '[TIME_REGISTRATION_SETTINGS] LOCATION_OVERRIDES_COUNT_ONE';
export const TIME_REGISTRATION_SETTINGS__LOCATION_OVERRIDES_COUNT_OTHER =
  '[TIME_REGISTRATION_SETTINGS] LOCATION_OVERRIDES_COUNT_OTHER';
export const TIME_REGISTRATION_SETTINGS__LOCATION_OVERRIDE_NOT_ALLOWED =
  '[TIME_REGISTRATION_SETTINGS] LOCATION_OVERRIDE_NOT_ALLOWED';
export const TIME_REGISTRATION_SETTINGS__LOCATION_OVERRIDE_WITHOUT_LOCATIONS =
  '[TIME_REGISTRATION_SETTINGS] LOCATION_OVERRIDE_WITHOUT_LOCATIONS';
export const TIME_REGISTRATION_SETTINGS__LOCATION_IN_MULTIPLE_OVERRIDES =
  '[TIME_REGISTRATION_SETTINGS] LOCATION_IN_MULTIPLE_OVERRIDES';
export const TIME_REGISTRATION_SETTINGS__UNKNOWN_LOCATION = '[TIME_REGISTRATION_SETTINGS] UNKNOWN_LOCATION';
export const TIME_REGISTRATION_SETTINGS__ALLOW_REGISTRATION_BEFORE_PLANNED_START_LOCKED =
  '[TIME_REGISTRATION_SETTINGS] ALLOW_REGISTRATION_BEFORE_PLANNED_START_LOCKED';
export const TIME_REGISTRATION_SETTINGS__ALLOW_START_IN_FUTURE_LOCKED =
  '[TIME_REGISTRATION_SETTINGS] ALLOW_START_IN_FUTURE_LOCKED';
export const TIME_REGISTRATION_SETTINGS__REGISTRATION_WINDOW_LOCKED =
  '[TIME_REGISTRATION_SETTINGS] REGISTRATION_WINDOW_LOCKED';
export const TIME_REGISTRATION_SETTINGS__EXTENDED_REGISTRATION_WINDOW_LOCKED =
  '[TIME_REGISTRATION_SETTINGS] EXTENDED_REGISTRATION_WINDOW_LOCKED';
export const TIME_REGISTRATION_SETTINGS__MAXIMUM_NUMBER_OF_BREAKS_LOCKED =
  '[TIME_REGISTRATION_SETTINGS] MAXIMUM_NUMBER_OF_BREAKS_LOCKED';
export const TIME_REGISTRATION_SETTINGS__BREAK_ROUNDING_LOCKED = '[TIME_REGISTRATION_SETTINGS] BREAK_ROUNDING_LOCKED';
export const TIME_REGISTRATION_SETTINGS__START_END_ROUNDING_LOCKED =
  '[TIME_REGISTRATION_SETTINGS] START_END_ROUNDING_LOCKED';
export const TIME_REGISTRATION_SETTINGS__OVERWORK_LIMIT_LOCKED = '[TIME_REGISTRATION_SETTINGS] OVERWORK_LIMIT_LOCKED';
export const TIME_REGISTRATION_SETTINGS__AUTO_FREEZE_ON_CLOCK_OUT_LOCKED =
  '[TIME_REGISTRATION_SETTINGS] AUTO_FREEZE_ON_CLOCK_OUT_LOCKED';
export const TIME_REGISTRATION_SETTINGS__KIOSK_AUTHENTICATION_MODE_LOCKED =
  '[TIME_REGISTRATION_SETTINGS] KIOSK_AUTHENTICATION_MODE_LOCKED';
export const TIME_REGISTRATION_SETTINGS__PERSONAL_DEVICE_BLOCK_LOCKED =
  '[TIME_REGISTRATION_SETTINGS] PERSONAL_DEVICE_BLOCK_LOCKED';
export const TIME_REGISTRATION_SETTINGS__KIOSK_MODE_AVAILABILITY_LOCKED =
  '[TIME_REGISTRATION_SETTINGS] KIOSK_MODE_AVAILABILITY_LOCKED';
export const TIME_REGISTRATION_SETTINGS__LOCATION_CAPTURE_LOCKED =
  '[TIME_REGISTRATION_SETTINGS] LOCATION_CAPTURE_LOCKED';
